import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import ReCAPTCHA from "react-google-recaptcha";
import axios from 'axios';
import './css/style.css';

import {
  APIProvider,
  ControlPosition,
  MapControl,
  AdvancedMarker,
  Map,
  Marker,
  useMap,
  useMapsLibrary,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";



/* import checkout_bg from './images/checkout_bg.jpg'; */
/* import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete'; */

/* import { GoogleMap, LoadScript, Autocomplete, Marker } from '@react-google-maps/api'; */


/* import { GooglePlacesAutocomplete } from 'react-google-places-autocomplete'; */


const mapcontainerStyle = {
  width: '100%',
  height: '175px',
};

const libraries = ["places"];

function App() {

  const navigate = useNavigate();
  const cons_location = useLocation();

  /* const apiurl = 'https://ifixscreens.com/store/app-repair/repair-api.php?sourceorogin=api';
  const storeurl = 'https://ifixscreens.com/store/';
   */

  const apiurl = 'https://ifixscreens.com/store/app-repair/repair-api-main-domain.php?sourceorogin=api';
  /*   const apiurl = 'https://ifixscreens.com/store/app-repair/repair-api-broken-screen.php?sourceorogin=api'; */
  /* const apiurl = 'https://ifixscreens.us/store/app-repair/repair-api-main-domain.php?sourceorogin=api'; */
  const storeurl = 'https://ifixscreens.com/store/';



  var other_product_id = 86135;
  var other_term_id = 14030;

  const recaptchaRef = React.createRef();



  const LocationscontainerRef = useRef(null);
  /* const repairdevicename = '' */

  const blogs = {
    data: []
  };

  const categories = {
    show: false,
    data: [],
    isSelected: false,
    value: '',
    nextStep: 0,
    name: '',
  };

  const postal = {
    show: false,
    value: '',
    complete_address: '',
    isSelected: false,
  };

  const deviceodel = {
    show: false
  };

  const brands = {
    show: false,
    data: [],
    isSelected: false,
    value: '',
    name: '',
  };

  const products = {
    show: false,
    data: [],
    isSelected: false,
    value: '',
    prevStep: '',
    name: '',
  };

  const variations = {
    show: false,
    data: [],
    selected_data: [],
    selected_variation_names: [],
    isSelected: false,
    value: '',
    repair_timing: '',
    prevStep: 0,
    name: '',
    description: '',
    isquote: 1,
    rivalRepairs: ['glass-lcd-replacement', 'glass-oled-replacement', 'glass-repair'],
  };

  const brokenScreens = {
    show: false,
    data: [],
    isSelected: false,
    value: '',
    selected_variation_name: '',
  };

  const servicelocations = {
    show: false,
    prevStep: 0,
    data: [],
    service: 0,
    store: 0,
  };

  const calendarappt = {
    show: false,
    date_slots: [],
    time_slots: [],
    date: '',
    time: '',
  }

  const carrycalendarappt = {
    show: false,
    date_slots: [],
    time_slots: [],
    date: '',
    time: '',
    quote_id: 0,
    errors: [],
    redu: false,
    instore: false,
    order_ref: '',
  }

  const contactinfo = {
    show: false,
    isSelected: false,
    errors: [],
    firstName: {
      value: '',
      error: 0,
      error_msg: '',
    },
    lastName: {
      value: '',
      error: 0,
      error_msg: '',
    },
    email: {
      value: '',
      error: 0,
      error_msg: '',
    },
    phone: {
      value: '',
      error: 0,
      error_msg: '',
    },
    newsletter: {
      value: 0,
    },
    postalCode: {
      value: '',
      error: 0,
      error_msg: '',
    },
    notes: {
      value: ''
    },
    contact_methods: [
      { id: "1", label: 'SMS', value: 'SMS', checked: false },
      { id: "2", label: 'Phone Call', value: 'Phone Call', checked: false },
      { id: "3", label: 'Email', value: 'Email', checked: false },
    ],

    contactMethod: {
      error: 0,
      error_msg: 'Please select approved contact methods(s)',
    },
    recaptcha: {
      error: 0,
      error_msg: 'reCAPTCHA verification failed'
    }
  }

  const instoreprice = {
    state: false,
    value: 0,
  }

  const quoteSuccess = {
    show: false,
    data: [],
    leadDetailsUrl: '',
    leadRescheduleUrl: '',
    addToCalendarBtns: {},

  }

  const cancelAppt = {
    show: false
  }

  var skeleton = {
    show: false
  };

  var mainSkeleton = {
    show: true,
  };

  var trackingSource = {
    source: '',
    value: '',
  };

  var trackingRepairLift = {
    repairlift: '',
    value: '',
  };





  const [blogData, setblogsData] = useState(blogs);
  const [categoriesData, setcategoriesData] = useState(categories);
  const [postalData, setpostalData] = useState(postal);
  const [devicemodelData, setdevicemodelData] = useState(deviceodel);
  const [brandsData, setbrandsData] = useState(brands);
  const [productsData, setproductsData] = useState(products);
  const [variationsData, setvariationsData] = useState(variations);
  const [brokenScreensData, setBrokenScreensData] = useState(brokenScreens);
  const [servicelocationsData, setservicelocationsData] = useState(servicelocations);
  const [repairdevicename, setrepairdevicename] = useState('Other');
  const [repairname, setrepairname] = useState('');
  const [calendarapptData, setcalendarapptData] = useState(calendarappt);
  const [calendarCarryapptData, setCarrycalendarapptData] = useState(carrycalendarappt);
  const [contactinfoData, setcontactinfoData] = useState(contactinfo);
  const [instorepriceData, setinstorepriceData] = useState(instoreprice);
  const [quoteSuccessData, setquoteSuccessData] = useState(quoteSuccess);
  const [changeLocationtrigger, setchangeLocationtrigger] = useState(0);
  const [devicePageTrigger, setdevicePageTrigger] = useState(0);
  const [skeletonData, setskeletonData] = useState(skeleton);
  const [mainSkeletonData, setmainSkeletonData] = useState(mainSkeleton);
  const [trackingParamsData, settrackingParamsData] = useState({});

  const [isRespomenu, setRespomenu] = useState(0);
  const [isDeviceMenuOPen, setDeviceMenuOpen] = useState(0);
  const [isStoreRepair, setisStoreRepair] = useState(0);
  const [store_hours, setstore_hours] = useState({});
  const [openStorePop, setopenStorePop] = useState(0);
  const [termsPopup, settermsPopup] = useState(false);
  const [privacyPopup, setprivacyPopup] = useState(false);
  const [repairicon, setrepairicon] = useState('');
  const [repairdeskmailin, setrepairdeskmailin] = useState(false);
  const [ishome, setishome] = useState(1);
  const [userLoggedIn, setuserLoggedIn] = useState(0);
  const [onlyMailin, setonlyMailin] = useState(0);
  const [quoteLeadID, setquoteLeadID] = useState(0);
  const [cancelApptData, setCancelAppt] = useState(cancelAppt);

  const [markerRef, marker] = useAdvancedMarkerRef();



  var urlParams = [];
  const [searchParams] = useSearchParams();



  const PlaceAutocomplete = ({ onPlaceSelect }) => {
    const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
    const inputRef = useRef(null);
    const places = useMapsLibrary("places");

    useEffect(() => {
      if (!places || !inputRef.current) return;

      const options = {
        fields: ["geometry", "name", "formatted_address", "address_components"],
        componentRestrictions: { country: 'US' }
      };

      setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
    }, [places]);
    useEffect(() => {
      if (!placeAutocomplete) return;

      placeAutocomplete.addListener("place_changed", () => {
        /*  onPlaceSelect(placeAutocomplete.getPlace()); */
        const place = placeAutocomplete.getPlace();

        if (place) {
          setpostalData({
            ...postalData,
            complete_address: place.formatted_address,
            isSelected: false,
          });

          const address = place.formatted_address;
          const zipcode = extractZipcodeFromAddressComponents(place.address_components);
          if (zipcode != '') {

            if (changeLocationtrigger == 1) {
              setchangeLocationtrigger(0);

              setpostalData((prevData) => ({
                ...prevData,
                value: zipcode,
                complete_address: address,
                isSelected: true,
                show: false,
              }))

              handleVariationContinue(zipcode);
              /* setservicelocationsData((prevData) => ({
              ...prevData,
              show:true,
              store:0,
              }))
              
              
              urlParams = [];
              urlParams['device'] = get_device_for_url();
              urlParams['postal'] = zipcode;
              urlParams['repair'] = variationsData.value;
              navigateHistory(); */
            }
            else if (devicePageTrigger == 1) {
              setdevicePageTrigger(0);
              /* setpostalData((prevData) => ({
                ...prevData,
                value: zipcode,
                complete_address: address,
                isSelected: true,
              }))
  
              setTimeout(()=>{
                setpostalData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
                handleDeviceContinue();
              },1000) */


              if (productsData.isSelected) {
                setvariationsData((prevData) => ({
                  ...prevData,
                  show: true,
                }))
              } else {
                if (brandsData.isSelected) {
                  onChangeBrand(brandsData.value);
                  setdevicemodelData((prevData) => ({
                    ...prevData,
                    show: true,
                  }))

                  setbrandsData((prevData) => ({
                    ...prevData,
                    show: true,
                  }))

                  setproductsData((prevData) => ({
                    ...prevData,
                    show: true,
                  }))
                }
              }

              setskeletonData((prevData) => ({
                show: true,
              }))

              setpostalData((prevData) => ({
                ...prevData,
                value: zipcode,
                complete_address: address,
                isSelected: true,
                show: false,
              }))


              urlParams = [];
              urlParams['device'] = categoriesData.value;
              urlParams['postal'] = zipcode;
              urlParams['complete_address'] = address;
              navigateHistory();

              setTimeout(function () {
                setskeletonData((prevData) => ({
                  show: false,
                }))
              }, 1000);

            }
            else {

              setskeletonData((prevData) => ({
                show: true,
              }))

              setpostalData((prevData) => ({
                ...prevData,
                value: zipcode,
                complete_address: address,
                isSelected: true,
                show: false,
              }))

              var cat_step = parseInt(categoriesData.nextStep);
              if (cat_step == 2) {
                setproductsData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
                setbrandsData((prevData) => ({
                  ...prevData,
                  show: true,
                }))
              }
              if (cat_step == 3) {
                setproductsData((prevData) => ({
                  ...prevData,
                  show: true,
                }))
              }

              setdevicemodelData({
                ...devicemodelData,
                show: true,
              })



              urlParams = [];
              urlParams['device'] = categoriesData.value;
              urlParams['postal'] = zipcode;
              urlParams['complete_address'] = address;
              navigateHistory();

              setTimeout(function () {
                setskeletonData((prevData) => ({
                  show: false,
                }))
              }, 1000);
            }
          }
          else {
            var localty_name = extractLocaltyNameComponents(place.address_components);
            if (localty_name != '') {

              axios.get(apiurl + '&operation=search_store&store_name=' + localty_name)
                .then(response => {
                  var statuscode = response.status;
                  if (statuscode == 200) {
                    var data = response.data;
                    var error = data.error;
                    if (error == 0) {
                      var response_data = data.data;
                      var zipcode = response_data.zipcode;

                      setskeletonData((prevData) => ({
                        show: true,
                      }))
                      setpostalData((prevData) => ({
                        ...prevData,
                        value: zipcode,
                        complete_address: address,
                        isSelected: true,
                        show: false,
                      }))

                      var cat_step = parseInt(categoriesData.nextStep);
                      if (cat_step == 2) {
                        setproductsData((prevData) => ({
                          ...prevData,
                          show: false,
                        }))
                        setbrandsData((prevData) => ({
                          ...prevData,
                          show: true,
                        }))
                      }
                      if (cat_step == 3) {
                        setproductsData((prevData) => ({
                          ...prevData,
                          show: true,
                        }))
                      }

                      setdevicemodelData({
                        ...devicemodelData,
                        show: true,
                      })



                      urlParams = [];
                      urlParams['device'] = categoriesData.value;
                      urlParams['postal'] = zipcode;
                      urlParams['complete_address'] = address;
                      navigateHistory();

                      setTimeout(function () {
                        setskeletonData((prevData) => ({
                          show: false,
                        }))
                      }, 1000);
                    }
                    else {
                      setpostalData((prevData) => ({
                        ...prevData,
                        value: '',
                        complete_address: address,
                        isSelected: false,
                      }))
                    }
                  }
                })
                .catch(error => {

                })
            }
            else {
              setpostalData((prevData) => ({
                ...prevData,
                value: '',
                complete_address: address,
                isSelected: false,
              }))
            }
          }



        }

      });
    }, [onPlaceSelect, placeAutocomplete]);
    return (
      <input ref={inputRef} type="text" placeholder="Enter ZIP code, area code or city" className="text" id="search_address" />
    );
  };


  useEffect(() => {
    console.log('useEffect');

    setquoteSuccessData((prevData) => ({
      ...prevData,
      show: false,
      data: [],
      leadDetailsUrl: '',
      leadRescheduleUrl: '',
      addToCalendarBtns: {},
    }))

    setquoteLeadID(0);

    /* for robots meta */
    const fullPath = cons_location.search;
    // Check if the URL contains '?'
    if (fullPath.includes('?')) {
      let metaTag = document.querySelector('meta[name="robots"]');
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('name', 'robots');
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', 'noindex, nofollow');
    } else {

    }
    /* end robots meta */

    window.addEventListener('popstate', handleHistoryChange)
    var url_device = searchParams.get('device');
    var rpostal = searchParams.get('rpostal');
    var rstore = searchParams.get('store');
    var mailin = searchParams.get('mailin');


    /* if url gets rpostal means we have to select store*/
    if (rpostal && rpostal != '') {
      if (rstore && rstore != '') {
        setisStoreRepair(1);
        setpostalData((prevData) => ({
          ...prevData,
          value: rpostal,
          isSelected: true
        }))

        setservicelocationsData((prevData) => ({
          ...prevData,
          store: rstore
        }))

      }
    }

    /* if url get mailin param => it is mail in request */
    if (mailin && mailin == '1') {
      setrepairdeskmailin(true);
    }



    const paramsObject = {};

    for (const [key, value] of searchParams.entries()) {
      paramsObject[key] = value;
    }

    settrackingParamsData(paramsObject);


    var order_ref = searchParams.get('order_ref');
    var order_action = searchParams.get('order_action');

    if (order_ref && order_ref != '' && order_action == 'instore') {
      validateInstoreOrder(order_ref)
      setishome(0);
    }
    else if (order_ref && order_ref != '') {
      validateReduOrder(order_ref);
      setishome(0);
    }
    else if (url_device && url_device != '') {
      var query_string = `&id=${url_device}`;

      var url_postal = searchParams.get('postal');
      var url_complete_address = searchParams.get('complete_address');

      if (!url_postal || url_postal == '' || url_postal == null) {
        var url_postal = searchParams.get('rpostal');
      }

      if (url_postal && url_postal != '') {
        query_string += `&postal=${url_postal}`;

        if (url_complete_address && url_complete_address != '') {
          query_string += `&complete_address=${url_complete_address}`;
        }


        var url_repair = searchParams.get('repair');


        if (url_repair && url_repair != '') {
          query_string += `&repair=${url_repair}`;

          var repair_description = searchParams.get('repair_description');
          if (repair_description && repair_description != '') {
            query_string += `&repair_description=${repair_description}`;
          }
        }


        var url_service = searchParams.get('service');
        var url_store = searchParams.get('store');

        if (url_service && url_service != '' && url_store && url_store != '') {
          query_string += `&service=${url_service}&store=${url_store}`;
        }
      }
      else {
        var url_repair = searchParams.get('repair');
        if (url_repair && url_repair != '') {
          query_string += `&repair=${url_repair}`;

          var repair_description = searchParams.get('repair_description');
          if (repair_description && repair_description != '') {
            query_string += `&repair_description=${repair_description}`;
          }
        }
      }

      console.log('pageReload');

      pageReload(query_string);
    }
    else {

      pageInit();
    }

    checkAuth();
    getBlogs();


    return () => {
      window.removeEventListener('popstate', handleHistoryChange);
    }

  }, []);


  const getYear = () => {
    return new Date().getFullYear();
  }

  const openDeviceSubMenu = () => {
    setDeviceMenuOpen(!isDeviceMenuOPen);
  }

  const isTermPopOpen = () => {
    return termsPopup;
  }
  const closeTermsPop = () => {
    settermsPopup(false);
  }

  const openTermsPop = () => {
    settermsPopup(true);
  }

  const closeprivacyPopup = () => {
    setprivacyPopup(false);
  }


  const isprivacyPopupOpen = () => {
    return privacyPopup;
  }


  const openprivacyPopup = () => {
    setprivacyPopup(true);
  }

  const handleSearch = (event) => {

  }


  const storePopupToggleClass = () => {
    if (openStorePop == 1) {
      return 'store-hours-popup active';
    }
    return 'store-hours-popup';
  }


  const formatTimeRange = (inputTime) => {
    const formatTime = (time) => {
      const [hours, minutes] = time.split(':');
      let formattedHours = parseInt(hours, 10) % 12 || 12;
      const ampm = parseInt(hours, 10) >= 12 ? 'PM' : 'AM';
      return `${formattedHours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    };

    var exp_time = inputTime.split('-');
    const formattedStartTime = formatTime(exp_time[0].trim());
    const formattedEndTime = formatTime(exp_time[1].trim());

    /* return `${formattedStartTime} - ${formattedEndTime}`; */
    return `${formattedStartTime}`;
  }


  const formatTime = (inputTime) => {
    const time = inputTime.split(':');
    let hours = parseInt(time[0], 10);
    const minutes = time[1];

    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours %= 12;
    hours = hours ? hours : 12; // Handle midnight (0 hours)

    return `${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
  }

  const get_store_phone = () => {
    var location_id = servicelocationsData.store;
    var selected_service = servicelocationsData.service;

    /* selected_service = selected_service - 1;
 */
    /* var service = servicelocationsData.data[selected_service]; */
    var service = {};

    for (var x in servicelocationsData.data) {
      if (servicelocationsData.data[x]['id'] == selected_service) {
        service = servicelocationsData.data[x];
      }
    }


    var locations = service.locations;

    var phone = '';

    const foundLocation = locations.find(item => item.id == location_id);

    if (foundLocation) {
      phone = foundLocation.phone;
    }
    return phone;
  }


  const closeStoreHours = () => {
    setopenStorePop(0);
  }

  const openStoreHours = () => {
    setopenStorePop(1);
  }


  const get_store_direction_link = () => {
    var location_id = servicelocationsData.store;
    var selected_service = servicelocationsData.service;
    /*  selected_service = selected_service - 1; */

    var service = {};
    for (var x in servicelocationsData.data) {
      if (servicelocationsData.data[x]['id'] == selected_service) {
        service = servicelocationsData.data[x];
      }
    }


    var locations = service.locations;

    var google_directions = '';

    const foundLocation = locations.find(item => item.id == location_id);

    if (foundLocation) {
      google_directions = foundLocation.google_directions;
    }
    return google_directions;
  }

  const get_store_hours = () => {
    var store_hours = {};
    var location_id = servicelocationsData.store;

    if (location_id != 0 && location_id != '') {
      var selected_service = servicelocationsData.service;

      selected_service = selected_service - 1;

      var service = servicelocationsData.data[selected_service];
      var locations = service.locations;


      const foundLocation = locations.find(item => item.id == location_id);
      if (foundLocation) {
        store_hours = foundLocation.store_hours;
      }

      setstore_hours(store_hours);
    }
    return store_hours;
  }

  const formatDate = (inputDate) => {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const days = [
      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'
    ];

    const date = new Date(inputDate);
    const day = days[date.getDay()];
    const month = months[date.getMonth()];
    const dayOfMonth = date.getDate();
    const year = date.getFullYear();

    return `${day}, ${month} ${dayOfMonth}, ${year}`;
  }


  const openResomenu = () => {
    setRespomenu(!isRespomenu);
  }

  const onUseCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
          if (status == 'OK' && results[0]) {
            const address = results[0].formatted_address;
            const zipcode = extractZipcodeFromAddressComponents(results[0].address_components);
            if (zipcode != '') {
              if (changeLocationtrigger == 1) {
                setchangeLocationtrigger(0);


                setpostalData((prevData) => ({
                  ...prevData,
                  value: zipcode,
                  complete_address: address,
                  isSelected: true,
                  show: false,
                }))



                handleVariationContinue(zipcode);
                /* setservicelocationsData((prevData) => ({
                ...prevData,
                show:true,
                }))
                
                
                urlParams = [];
                urlParams['device'] = get_device_for_url();
                urlParams['postal'] = zipcode;
                urlParams['repair'] = variationsData.value;
                navigateHistory(); */
              }
              else {
                setpostalData((prevData) => ({
                  ...prevData,
                  value: zipcode,
                  complete_address: address,
                  isSelected: true,
                  show: false,
                }))

                var cat_step = parseInt(categoriesData.nextStep);
                if (cat_step == 2) {
                  setproductsData((prevData) => ({
                    ...prevData,
                    show: false,
                  }))
                  setbrandsData((prevData) => ({
                    ...prevData,
                    show: true,
                  }))
                }
                if (cat_step == 3) {
                  setproductsData((prevData) => ({
                    ...prevData,
                    show: true,
                  }))
                }

                setdevicemodelData({
                  ...devicemodelData,
                  show: true,
                })

                urlParams = [];
                urlParams['device'] = categoriesData.value;
                urlParams['postal'] = zipcode;
                urlParams['complete_address'] = address;
                navigateHistory();
              }
            }
            else {
              setpostalData((prevData) => ({
                ...prevData,
                value: '',
                complete_address: address,
                isSelected: false,
              }))
            }
          }
          else {
            /* console.error('Geocode was not successful for the following reason:', status); */
          }
        })
      }, (error) => {
        /* console.error('Error getting current location:', error); */
      })
    }
  };


  const onLoad = (autocomplete) => {
    /* autocomplete.setOptions({types: ['geocode'],{types: ['postal_code']},componentRestrictions: { country: 'US' } }); */
    autocomplete.setOptions({ componentRestrictions: { country: 'US' } });
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();

      if (place) {
        const address = place.formatted_address;
        const zipcode = extractZipcodeFromAddressComponents(place.address_components);
        if (zipcode != '') {

          if (changeLocationtrigger == 1) {
            setchangeLocationtrigger(0);

            setpostalData((prevData) => ({
              ...prevData,
              value: zipcode,
              complete_address: address,
              isSelected: true,
              show: false,
            }))

            handleVariationContinue(zipcode);
            /* setservicelocationsData((prevData) => ({
            ...prevData,
            show:true,
            store:0,
            }))
            
            
            urlParams = [];
            urlParams['device'] = get_device_for_url();
            urlParams['postal'] = zipcode;
            urlParams['repair'] = variationsData.value;
            navigateHistory(); */
          }
          else if (devicePageTrigger == 1) {
            setdevicePageTrigger(0);
            /* setpostalData((prevData) => ({
              ...prevData,
              value: zipcode,
              complete_address: address,
              isSelected: true,
            }))

            setTimeout(()=>{
              setpostalData((prevData) => ({
                ...prevData,
                show: false,
              }))
              handleDeviceContinue();
            },1000) */


            if (productsData.isSelected) {
              setvariationsData((prevData) => ({
                ...prevData,
                show: true,
              }))
            } else {
              if (brandsData.isSelected) {
                onChangeBrand(brandsData.value);
                setdevicemodelData((prevData) => ({
                  ...prevData,
                  show: true,
                }))

                setbrandsData((prevData) => ({
                  ...prevData,
                  show: true,
                }))

                setproductsData((prevData) => ({
                  ...prevData,
                  show: true,
                }))
              }
            }

            setskeletonData((prevData) => ({
              show: true,
            }))

            setpostalData((prevData) => ({
              ...prevData,
              value: zipcode,
              complete_address: address,
              isSelected: true,
              show: false,
            }))


            urlParams = [];
            urlParams['device'] = categoriesData.value;
            urlParams['postal'] = zipcode;
            urlParams['complete_address'] = address;
            navigateHistory();

            setTimeout(function () {
              setskeletonData((prevData) => ({
                show: false,
              }))
            }, 1000);

          }
          else {

            setskeletonData((prevData) => ({
              show: true,
            }))

            setpostalData((prevData) => ({
              ...prevData,
              value: zipcode,
              complete_address: address,
              isSelected: true,
              show: false,
            }))

            var cat_step = parseInt(categoriesData.nextStep);
            if (cat_step == 2) {
              setproductsData((prevData) => ({
                ...prevData,
                show: false,
              }))
              setbrandsData((prevData) => ({
                ...prevData,
                show: true,
              }))
            }
            if (cat_step == 3) {
              setproductsData((prevData) => ({
                ...prevData,
                show: true,
              }))
            }

            setdevicemodelData({
              ...devicemodelData,
              show: true,
            })



            urlParams = [];
            urlParams['device'] = categoriesData.value;
            urlParams['postal'] = zipcode;
            urlParams['complete_address'] = address;
            navigateHistory();

            setTimeout(function () {
              setskeletonData((prevData) => ({
                show: false,
              }))
            }, 1000);
          }
        }
        else {
          var localty_name = extractLocaltyNameComponents(place.address_components);
          if (localty_name != '') {

            axios.get(apiurl + '&operation=search_store&store_name=' + localty_name)
              .then(response => {
                var statuscode = response.status;
                if (statuscode == 200) {
                  var data = response.data;
                  var error = data.error;
                  if (error == 0) {
                    var response_data = data.data;
                    var zipcode = response_data.zipcode;

                    setskeletonData((prevData) => ({
                      show: true,
                    }))
                    setpostalData((prevData) => ({
                      ...prevData,
                      value: zipcode,
                      complete_address: address,
                      isSelected: true,
                      show: false,
                    }))

                    var cat_step = parseInt(categoriesData.nextStep);
                    if (cat_step == 2) {
                      setproductsData((prevData) => ({
                        ...prevData,
                        show: false,
                      }))
                      setbrandsData((prevData) => ({
                        ...prevData,
                        show: true,
                      }))
                    }
                    if (cat_step == 3) {
                      setproductsData((prevData) => ({
                        ...prevData,
                        show: true,
                      }))
                    }

                    setdevicemodelData({
                      ...devicemodelData,
                      show: true,
                    })



                    urlParams = [];
                    urlParams['device'] = categoriesData.value;
                    urlParams['postal'] = zipcode;
                    urlParams['complete_address'] = address;
                    navigateHistory();

                    setTimeout(function () {
                      setskeletonData((prevData) => ({
                        show: false,
                      }))
                    }, 1000);
                  }
                  else {
                    setpostalData((prevData) => ({
                      ...prevData,
                      value: '',
                      complete_address: address,
                      isSelected: false,
                    }))
                  }
                }
              })
              .catch(error => {

              })
          }
          else {
            setpostalData((prevData) => ({
              ...prevData,
              value: '',
              complete_address: address,
              isSelected: false,
            }))
          }
        }



      }



    });
  };


  const extractZipcodeFromAddressComponents = (address_components) => {

    for (const component of address_components) {
      if (component.types.includes("postal_code")) {
        return component.long_name;
      }
    }
    return "";
  }


  const extractLocaltyNameComponents = (address_components) => {
    for (const component of address_components) {
      if (component.types.includes("locality") || component.types.includes("political")) {
        return component.long_name;
      }
    }
    return "";
  }

  const ChangeLocation = () => {
    setchangeLocationtrigger(1);
    setisStoreRepair(0);
    setservicelocationsData((prevData) => ({
      ...prevData,
      show: false,
      service: 0,
      postal: 0,
      isSelected: 0,
    }))
    setpostalData((prevData) => ({
      ...prevData,
      show: true,
      value: '',
      complete_address: '',
      isSelected: false,
    }))
    urlParams = [];
    urlParams['device'] = get_device_for_url();
    navigateHistory();
  }

  const handleHistoryChange = (event) => {
    if (quoteSuccessData.show) {

      setquoteSuccessData((prevData) => ({
        ...prevData,
        show: false,
        data: [],
        leadDetailsUrl: '',
        leadRescheduleUrl: '',
        addToCalendarBtns: {},
      }))

      setquoteLeadID(0);
    }


    if (event.state && event.state.source === 'user') {
      // This function will be called when user navigates back or forward

    }
    else {

      var queryParams = new URLSearchParams(window.location.search);
      var url_device = queryParams.get('device');

      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))




      if (url_device && url_device != '') {
        var query_string = `&id=${url_device}`;

        var url_postal = queryParams.get('postal');
        var url_complete_address = queryParams.get('complete_address');

        if (url_postal && url_postal != '' && url_complete_address && url_complete_address != '') {
          query_string += `&postal=${url_postal}&complete_address=${url_complete_address}`;


          var url_repair = queryParams.get('repair');
          if (url_repair && url_repair != '') {
            query_string += `&repair=${url_repair}`;

            var repair_description = queryParams.get('repair_description');
            if (repair_description && repair_description != '') {
              query_string += `&repair_description=${repair_description}`;
            }
          }


          var url_service = queryParams.get('service');
          var url_store = queryParams.get('store');

          if (url_service && url_service != '' && url_store && url_store != '') {
            query_string += `&service=${url_service}&store=${url_store}`;
          }
        }


        pageReload(query_string);
      }
      else {

        setpostalData((prevData) => ({
          ...prevData,
          show: false,
          isSelected: false,
          value: '',
        }))

        setcategoriesData((prevData) => ({
          ...prevData,
          show: true,
          value: ''
        }))

        setskeletonData((prevData) => ({
          ...prevData,
          show: false,
        }))

      }
    }

  }

  const pageInit = async () => {
    try {
      const response = await axios.get(apiurl + '&operation=category');
      var sttauscode = response.status;
      if (sttauscode === 200) {
        if (response.hasOwnProperty('data')) {
          var data = response.data;

          if (data.hasOwnProperty('error')) {
            var error = data.error;
            if (error === 0) {
              /* this.setState({...this.state,this.categories.data:data.data}) */

              setmainSkeletonData((prevData) => ({
                ...prevData,
                show: false,
              }))
            }


            setcategoriesData((prevData) => ({
              ...prevData,
              show: true,
              data: data.data,
              isSelected: false,
            }))
          }
        }



      }
    }
    catch (error) {

    }
  }

  const getBlogs = async () => {
    try {
      const response = await axios.get(apiurl + '&operation=get_latest_blogs');
      var sttauscode = response.status;
      if (sttauscode === 200) {
        var data = response.data;
        var error = data.error;
        if (error === 0) {
          var blogs = data.data.blogs;

          setblogsData((prevData) => ({
            ...prevData,
            data: blogs,
          }))
        }


      }
    }
    catch (error) {

    }
  }

  const checkAuth = async () => {
    try {
      const response = await axios.get(apiurl + '&operation=check_auth');
      var sttauscode = response.status;
      if (sttauscode === 200) {
        var data = response.data;
        var error = data.error;
        if (error === 0) {
          var user = data.data.user;
          setcontactinfoData((prevData) => ({
            ...prevData,
            email: {
              ...prevData.email,
              value: user.user_email,
            },
            firstName: {
              ...prevData.firstName,
              value: user.meta.billing_first_name,
            },
            lastName: {
              ...prevData.billing_last_name,
              value: user.meta.billing_last_name,
            },
            phone: {
              ...prevData.phone,
              value: user.meta.billing_phone,
            },
            postalCode: {
              ...prevData.postalCode,
              value: user.meta.billing_postcode,
            }
          }))

          setuserLoggedIn(1);

        }


      }
    }
    catch (error) {

    }
  }

  const validateReduOrder = async (order_ref) => {
    const response = await axios.get(apiurl + '&operation=validate_redu_order&order_ref=' + order_ref);
    var sttauscode = response.status;
    if (sttauscode === 200) {
      var data = response.data;
      var error = data.error;
      if (error === 0) {


        var date_slots = data.data.dates;
        var time_slots = data.data.times;
        var order = data.data.order;
        var store_hours = data.data.store_hours;
        var repairdevicename = data.data.repairdevicename;
        var repairname = data.data.repairname;
        var repairicon = data.data.repairicon;


        if (data.data.hasOwnProperty('price')) {
          var price = data.data.price;
          if (price != 0 && price != '' && price != null) {
            setinstorepriceData((prevData) => ({
              ...prevData,
              state: true,
              value: price
            }))
          }
        }

        setrepairicon(repairicon);
        setrepairname(repairname);
        setrepairdevicename(repairdevicename);

        setcontactinfoData((prevData) => ({
          ...prevData,
          show: false,
        }))

        var active = '';

        date_slots.map((slot) => {
          if (slot.active == 1) {
            active = slot.date;
          }
        })

        setservicelocationsData((prevData) => ({
          ...prevData,
          data: data.data.location_services,
          service: 1,
          store: data.data.order.bkapuser_location_id
        }))


        setCarrycalendarapptData((prevData) => ({
          ...prevData,
          show: true,
          date_slots: date_slots,
          time_slots: time_slots,
          date: active,
          redu: true,
          order_ref: order_ref,
        }))

        setcontactinfoData((prevData) => ({
          ...prevData,
          firstName: {
            ...prevData.firstName,
            value: order.bkapuser_firstname,
          },
          lastName: {
            ...prevData.lastName,
            value: order.bkapuser_lastname,
          },
          email: {
            ...prevData.email,
            value: order.bkapuser_email,
          },
          phone: {
            ...prevData.phone,
            value: order.bkapuser_phone,
          },
          postalCode: {
            ...prevData.postalCode,
            value: order.bkapuser_firstname,
          },
          notes: {
            ...prevData.notes,
            value: order.bkapuser_firstname,
          },
        }))


        setstore_hours(store_hours);

        setskeletonData((prevData) => ({
          ...prevData,
          show: false,
        }))
      }
      else {

      }
    }
    else {

    }
  }
  const validateInstoreOrder = async (order_ref) => {
    const response = await axios.get(apiurl + '&operation=validate_instore_order&order_ref=' + order_ref);
    var sttauscode = response.status;
    if (sttauscode === 200) {
      var data = response.data;
      var error = data.error;
      if (error === 0) {


        var date_slots = data.data.dates;
        var time_slots = data.data.times;
        var order = data.data.order;
        var store_hours = data.data.store_hours;
        var repairdevicename = data.data.repairdevicename;
        var repairname = data.data.repairname;
        var repairicon = data.data.repairicon;


        if (data.data.hasOwnProperty('price')) {
          var price = data.data['price'];
          var show_instore_price = data.data['show_instore_price'];
          if (show_instore_price && price != 0 && price != '' && price != null) {
            setinstorepriceData((prevData) => ({
              ...prevData,
              state: true,
              value: price
            }))
          }
          else {
            setinstorepriceData((prevData) => ({
              ...prevData,
              state: false,
              value: 0
            }))
          }
        }



        setrepairicon(repairicon);
        setrepairname(repairname);
        setrepairdevicename(repairdevicename);

        setcontactinfoData((prevData) => ({
          ...prevData,
          show: false,
        }))

        var active = '';

        date_slots.map((slot) => {
          if (slot.active == 1) {
            active = slot.date;
          }
        })

        setservicelocationsData((prevData) => ({
          ...prevData,
          data: data.data.location_services,
          service: 1,
          store: data.data.order.bkapuser_location_id
        }))


        setCarrycalendarapptData((prevData) => ({
          ...prevData,
          show: true,
          date_slots: date_slots,
          time_slots: time_slots,
          date: active,
          redu: false,
          instore: true,
          order_ref: order_ref,
        }))

        setcontactinfoData((prevData) => ({
          ...prevData,
          firstName: {
            ...prevData.firstName,
            value: order.bkapuser_firstname,
          },
          lastName: {
            ...prevData.lastName,
            value: order.bkapuser_lastname,
          },
          email: {
            ...prevData.email,
            value: order.bkapuser_email,
          },
          phone: {
            ...prevData.phone,
            value: order.bkapuser_phone,
          },
          postalCode: {
            ...prevData.postalCode,
            value: order.bkapuser_firstname,
          },
          notes: {
            ...prevData.notes,
            value: order.bkapuser_firstname,
          },
        }))


        setstore_hours(store_hours);

        setskeletonData((prevData) => ({
          ...prevData,
          show: false,
        }))
      }
      else {

      }
    }
    else {

    }
  }

  const pageReload = async (query_string) => {
    try {
      const response = await axios.get(apiurl + '&operation=validate_device' + query_string);
      var sttauscode = response.status;
      if (sttauscode === 200) {
        var data = response.data;
        var error = data.error;

        var tomove = false;
        if (data.hasOwnProperty('type')) {
          tomove = true;
        }

        if (error === 0) {
          tomove = true;
        }

        /* if (error === 0) { */
        if (tomove) {
          var new_categories = {
            show: false,
            data: [],
            isSelected: false,
            value: '',
            nextStep: 0,
            name: '',
          };

          var new_postal = {
            show: false,
            value: '',
            complete_address: '',
            isSelected: false,
          };

          var new_deviceodel = {
            show: false
          };

          var new_brands = {
            show: false,
            data: [],
            isSelected: false,
            value: '',
            name: '',
          };

          var new_products = {
            show: false,
            data: [],
            isSelected: false,
            value: '',
            prevStep: '',
            name: '',
          };

          var new_variations = {
            show: false,
            data: [],
            selected_variation_names: [],
            selected_data: [],
            isSelected: false,
            value: '',
            repair_timing: '',
            prevStep: 0,
            name: '',
            description: '',
            isquote: 1,
          };

          var new_servicelocations = {
            show: false,
            prevStep: 0,
            data: [],
            service: 0,
            store: 0,
          };

          var new_calendarappt = {
            show: false,
          };

          var repairdevicename = '';



          var responsetype = data.type;
          if (typeof responsetype != 'undefined') {

            setishome(0);

            /* for category */
            if (data.hasOwnProperty('category')) {
              var response_category = data['category'];
              var category_data = response_category['data'];

              new_categories.data = category_data;
              if (response_category.hasOwnProperty('id')) {
                var category_id = response_category['id'];
                new_categories.value = category_id;
                new_categories.isSelected = true;
              }

              if (response_category.hasOwnProperty('category_name')) {
                var category_name = response_category['category_name'];
                new_categories.name = category_name;
                repairdevicename = category_name;
              }

              if (response_category.hasOwnProperty('next_step')) {
                var next_step = response_category['next_step'];
                new_categories.nextStep = next_step;
              }



            }

            /* for postal */
            if (data.hasOwnProperty('postal')) {
              var postal_data = data['postal'];
              var postal_code = postal_data['value'];
              var complete_address = postal_data['complete_address'];

              new_postal.isSelected = true;
              new_postal.value = postal_code;
              new_postal.complete_address = complete_address
            }

            /* for product */
            if (data.hasOwnProperty('product')) {
              var product_response = data['product'];
              var product_data = product_response['data'];

              new_products.data = product_data;

              if (product_response.hasOwnProperty('id')) {
                new_products.isSelected = true;
                new_products.value = product_response['id'];
              }

              if (product_response.hasOwnProperty('name')) {
                new_products.name = product_response['name'];
                
                repairdevicename = new_products.name;
              }

              if (product_response.hasOwnProperty('prevStep')) {
                new_products.prevStep = parseInt(product_response['prevStep']);
              }

            }

            /* for brand */
            if (data.hasOwnProperty('brand')) {
              var brand_response = data['brand'];
              var brand_data = brand_response['data'];

              new_brands.data = brand_data;

              if (brand_response.hasOwnProperty('id')) {
                new_brands.isSelected = true;
                new_brands.value = brand_response['id'];
              }

              if (brand_response.hasOwnProperty('name')) {
                new_brands.name = brand_response['name'];
              }

            }


            setrepairdevicename(repairdevicename);

            /* for variations */
            if (data.hasOwnProperty('repair')) {
              var repair_response = data['repair'];
              var repair_data = repair_response['data'];
              new_variations.data = repair_data;


              if (repair_response.hasOwnProperty('screen_variations')) {
                var screen_variations = repair_response['screen_variations'];
                setBrokenScreensData({
                  show: false,
                  data: screen_variations,
                  isSelected: false,
                  value: '',
                })
              }

              /*  if (repair_response.hasOwnProperty('id')) {
                 new_variations.value = repair_response['id'];
                 new_variations.isSelected = true;
               } */


              /* if (repair_data.length == 1) {
                new_variations.isSelected = true;
                new_variations.value = repair_data[0].variation_term_id;
              } */

              var variation_data = [];
              var selected_variation_names = [];
              if (repair_response.hasOwnProperty('selected_variations')) {
                var selected_variations = repair_response['selected_variations'];

                for (var varx = 0; varx < selected_variations.length; varx++) {
                  var vari_data = [];
                  vari_data['variation_id'] = selected_variations[varx]['variation_id'];
                  vari_data['name'] = selected_variations[varx]['name'];
                  vari_data['isquote'] = parseInt(selected_variations[varx]['isquote']);
                  vari_data['repair_timing'] = selected_variations[varx]['variation_timing'];
                  variation_data.push(vari_data);
                  selected_variation_names.push(selected_variations[varx]['variation_slug']);
                }


                var vari_names = [];
                var vari_values = [];
                var vari_quote = 0;
                var vari_is_selected = false;
                variation_data.forEach((vari) => {
                  vari_names.push(vari['name']);
                  vari_values.push(vari['variation_id']);
                  if (vari['isquote'] == 1) {
                    vari_quote = vari['isquote'];
                  }
                })

                if (variation_data.length > 0) {
                  vari_is_selected = true;
                }

                new_variations.name = vari_names.join(', ');
                new_variations.isquote = vari_quote;
                new_variations.isSelected = vari_is_selected;
                new_variations.value = vari_values.join(', ');
                new_variations.selected_data = variation_data;
                new_variations.selected_variation_names = selected_variation_names;


                if (repair_data.length == 1) {
                  new_variations.isSelected = true;
                  new_variations.value = repair_data[0].variation_term_id;
                  new_variations.name = repair_data[0].variation_name;
                }

                setrepairname(vari_names.join(', '));



              }
              /*  if (repair_response.hasOwnProperty('name')) {
                 new_variations.name = repair_response['name'];
                 setrepairname(repair_response['name']);
               } */

              /* if (repair_response.hasOwnProperty('isquote')) {
                new_variations.isquote = repair_response['isquote'];
              } */

              if (repair_response.hasOwnProperty('repair_description')) {
                new_variations.description = repair_response['repair_description'];
              }

              /* if (repair_response.hasOwnProperty('repair_timing')) {
                new_variations.repair_timing = repair_response['repair_timing'];
              } */

            }

            /* for services and stores */
            if (data.hasOwnProperty('services')) {
              var services_response = data['services'];
              var services_data = services_response['data'];

              if (services_data.length == 1) {

                if (services_data[0]['text'] == 'Mail In') {
                  setonlyMailin(1);
                }
              }
              else {
                setonlyMailin(0);
              }


              new_servicelocations.data = services_data;

              if (services_response.hasOwnProperty('service')) {
                new_servicelocations.service = services_response['service'];
              }
              else {
                if (services_data.length > 0) {
                  new_servicelocations.service = services_data[0]['id'];
                }
              }

              if (services_response.hasOwnProperty('store')) {
                new_servicelocations.store = services_response['store'];
                new_servicelocations.isSelected = true;
              }
              else {
                if (services_data.length == 1) {
                  var locations = services_data[0]['locations'];
                  if (locations.length == 1) {
                    new_servicelocations.store = locations[0]['id'];
                  }
                }
              }
            }
            else {

              var rpostal = searchParams.get('rpostal');
              var rstore = searchParams.get('store');

              /* if url gets rpostal means we have to select store*/
              if (rpostal && rpostal != '') {
                if (rstore && rstore != '') {
                  setisStoreRepair(1);
                  postal_code = rpostal;
                  new_postal.show = 1
                  new_servicelocations.store = rstore;

                }
              }
            }

            if (responsetype == 'iscategory') {
              if (data.hasOwnProperty('brand')) {

                if (data.hasOwnProperty('postal')) {
                  new_brands.show = true;
                  new_deviceodel.show = true;
                  new_postal.isSelected = true;
                  new_postal.show = false;
                }
                else {
                  new_brands.show = false;
                  new_postal.show = true;
                  new_deviceodel.show = false;
                  new_postal.isSelected = false;
                }
              }
              else if (data.hasOwnProperty('product')) {
                if (data.hasOwnProperty('postal')) {
                  new_products.show = true;
                  new_deviceodel.show = true;
                  new_postal.isSelected = true;
                  new_postal.show = false;
                }
                else {
                  new_products.show = false;
                  new_postal.show = true;
                  new_deviceodel.show = false;
                  new_postal.isSelected = false;
                }
              }
            }


            if (responsetype == 'isproduct') {
              var prevStep = new_products.prevStep;

              new_products.show = false;
              new_variations.show = true;


              /* if product parent is category */
              if (prevStep == 1) {
                new_categories.isSelected = true;
                new_categories.show = false;

                new_postal.show = false;
                new_deviceodel.show = false;
                new_brands.show = false;
                new_products.show = true;
                new_variations.prevStep = 3;
              }
              /* if product parent is brand */
              if (prevStep == 2) {
                new_categories.isSelected = true;
                new_categories.show = false;

                new_postal.show = false;
                new_deviceodel.show = false;
                new_products.show = true;
                new_brands.show = true;
                new_variations.prevStep = 2;
              }

              /* if is other product */
              if (prevStep == 0) {
                new_categories.isSelected = true;
                new_categories.show = false;

                new_postal.show = false;
                new_deviceodel.show = false;
                new_variations.prevStep = 0;
                new_variations.show = true;
              }

              /* if url gets device but do not have location select (redirect from category pages)*/
              if (data.hasOwnProperty('postal')) {

              }
              else {
                if (rpostal && rpostal != '' && rstore && rstore != '') {

                }
                else {
                  setdevicePageTrigger(1);
                  new_postal.show = true;
                  new_postal.isSelected = false;
                }

              }
            }

            if (responsetype == 'isrepair') {
              if (data.hasOwnProperty('postal')) {
                new_categories.show = false;
                new_postal.show = false;
                new_deviceodel.show = false;
                new_variations.show = false;
                new_servicelocations.show = true;
              }
              else {

                /* if url gets device and repair but do not have location select (redirect from repair pages)*/
                new_brands.show = false;
                new_postal.show = true;
                new_deviceodel.show = false;
                new_postal.isSelected = false;
                setchangeLocationtrigger(1);
              }

            }


            if (responsetype == 'isstore') {
              new_categories.show = false;
              new_postal.show = false;
              new_deviceodel.show = false;
              new_variations.show = false;
              new_servicelocations.show = true;
              new_calendarappt.show = false;
            }

            if (responsetype == 'isbrand') {
              if (data.hasOwnProperty('postal')) {
                new_categories.show = false;
                new_postal.show = false;
                new_deviceodel.show = false;
                new_brands.show = false;
              }
              else {
                /* if url gets brand but do not have location select (redirect from repair pages)*/
                new_brands.show = false;
                new_postal.show = true;
                new_deviceodel.show = false;
                new_postal.isSelected = false;
                setdevicePageTrigger(1);
              }
            }






            setcategoriesData((prevData) => ({
              ...prevData,
              show: false,
              value: new_categories.value,
              isSelected: true,
              data: new_categories.data,
              nextStep: new_categories.nextStep,
              name: new_categories.name,
            }))

            setpostalData((prevData) => ({
              ...prevData,
              show: new_postal.show,
              value: postal_code,
              complete_address: new_postal.complete_address,
              isSelected: new_postal.isSelected,
            }))

            setbrandsData((prevData) => ({
              ...prevData,
              show: new_brands.show,
              data: new_brands.data,
              isSelected: new_brands.isSelected,
              value: new_brands.value,
              name: new_brands.name,
            }))


            setproductsData((prevData) => ({
              ...prevData,
              show: new_products.show,
              data: new_products.data,
              isSelected: new_products.isSelected,
              value: new_products.value,
              name: new_products.name,
            }))

            setdevicemodelData((prevData) => ({
              ...prevData,
              show: new_deviceodel.show,
            }))


            setvariationsData((prevData) => ({
              ...prevData,
              show: new_variations.show,
              isSelected: new_variations.isSelected,
              value: new_variations.value,
              name: new_variations.name,
              selected_variation_names: new_variations.selected_variation_names,
              selected_data: new_variations.selected_data,
              repair_timing: new_variations.repair_timing,
              prevStep: new_variations.prevStep,
              data: new_variations.data,
              isquote: new_variations.isquote,
              description: new_variations.description,
            }))

            setservicelocationsData((prevData) => ({
              show: new_servicelocations.show,
              prevStep: 0,
              data: new_servicelocations.data,
              service: new_servicelocations.service,
              store: new_servicelocations.store,
            }))

            setcalendarapptData((prevData) => ({
              ...prevData,
              show: new_calendarappt.show
            }));


            setmainSkeletonData((prevData) => ({
              ...prevData,
              show: false,
            }))

            setskeletonData((prevData) => ({
              ...prevData,
              show: false,
            }))
          }
          else {
            var categoriesData = new_categories.data;
            if (data.hasOwnProperty('category')) {
              var categoriesData = data.category.data;
            }
            setcategoriesData((prevData) => ({
              ...prevData,
              show: true,
              value: new_categories.value,
              isSelected: false,
              data: categoriesData,
              nextStep: new_categories.nextStep,
              name: new_categories.name,
            }))

            setmainSkeletonData((prevData) => ({
              ...prevData,
              show: false,
            }))

            setskeletonData((prevData) => ({
              ...prevData,
              show: false,
            }))
          }

        }
        else {

        }
      }
    }
    catch (error) {

    }
  }

  const navigateHistory = () => {
    const queryParams = new URLSearchParams();
    for (var key in urlParams) {
      var paramvalue = urlParams[key];
      if (typeof paramvalue !== 'undefined') {

      }
      else {
        paramvalue = '';
      }
      queryParams.set(key, paramvalue);
    }

    if (queryParams.size == 0) {
      setishome(1);
    }
    else {
      setishome(0);
    }


    navigate('?' + queryParams.toString());
    window.scroll(0, 0);

  }

  const onChangeCategory = (event, category_id, category_name) => {
    var nextStep = parseInt(event.target.getAttribute('nextstep'));
    onChangeCategoryProcess(nextStep, category_id, category_name);

  }

  const onChangeCategoryProcess = (nextStep, category_id, category_name, catsdata = []) => {

    if (catsdata.length == 0) {
      setcategoriesData((prevData) => ({
        ...prevData,
        isSelected: true,
        value: category_id,
        nextStep: nextStep,
        name: category_name,
      }))
    }
    else {
      setcategoriesData((prevData) => ({
        ...prevData,
        isSelected: true,
        value: category_id,
        nextStep: nextStep,
        name: category_name,
        data: catsdata,
      }))
    }


    setrepairdevicename(category_name);

    if (nextStep === 2) {

      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))

      axios.get(apiurl + '&operation=brands&category=' + category_id)
        .then(response => {
          var stauscode = response.status;
          if (stauscode == 200) {
            var data = response.data;
            var error = data.error;
            if (error == 0) {
              /* this.setState({...this.state,this.categories.data:data.data}) */
              if (catsdata.length == 0) {
                setcategoriesData((prevData) => ({
                  ...prevData,
                  show: false,
                  value: category_id,
                  nextStep: nextStep,
                  isSelected: true,
                  name: category_name,
                }))
              }
              else {
                setcategoriesData((prevData) => ({
                  ...prevData,
                  show: false,
                  value: category_id,
                  nextStep: nextStep,
                  isSelected: true,
                  name: category_name,
                  data: catsdata,
                }))
              }


              setbrandsData({
                ...brandsData,
                data: data.data,
                show: true
              })

              if (postalData.isSelected) {
                handlePostalContinue();
              }
              else {
                setpostalData({
                  ...postalData,
                  show: true
                })

                urlParams = [];
                urlParams['device'] = category_id;
                navigateHistory();

              }


              setskeletonData((prevData) => ({
                ...prevData,
                show: false,
              }))

              /* navigate(`?device=${category_id}`); */
            }
          }
        })
        .catch(error => {

        })
    }
    else {
      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))

      get_products(category_id);

      if (catsdata.length == 0) {
        setcategoriesData((prevData) => ({
          ...prevData,
          show: false,
          value: category_id,
          nextStep: nextStep,
          isSelected: true,
          name: category_name,
        }))
      }
      else {
        setcategoriesData((prevData) => ({
          ...prevData,
          show: false,
          value: category_id,
          nextStep: nextStep,
          isSelected: true,
          name: category_name,
          data: catsdata,
        }))
      }

      if (postalData.isSelected) {
        handlePostalContinue();
      }
      else {
        setpostalData({
          ...postalData,
          show: true
        })

        urlParams = [];
        urlParams['device'] = category_id;
        navigateHistory();
      }

      /* navigate(`?device=${category_id}`); */

    }
  }

  const handlePostalChange = (event) => {
    /* var value = event.target.value.trim(); */
    var value = event.target.value;

    setpostalData({
      ...postalData,
      complete_address: value,
      isSelected: false,
    });

    /* var postal_code = event.target.value.trim();
    var numericInput = postal_code.replace(/[^0-9]/g, '');
    
    
    if (numericInput === '') {
    
    setpostalData({
    ...postalData,
    value: '',
    complete_address: '',
    isSelected: false,
    });
    }
    else {
    setpostalData({
    ...postalData,
    value: postal_code,
    complete_address: postal_code,
    isSelected: true,
    });
    } */
  }


  const handlePostalContinue = (event) => {

    if (postalData.isSelected) {

      setpostalData((prevData) => ({
        ...prevData,
        show: false,
      }))

      var cat_step = parseInt(categoriesData.nextStep);
      if (cat_step == 2) {
        setproductsData((prevData) => ({
          ...prevData,
          show: false,
        }))
        setbrandsData((prevData) => ({
          ...prevData,
          show: true,
        }))
      }
      if (cat_step == 3) {
        setproductsData((prevData) => ({
          ...prevData,
          show: true,
        }))
      }

      setdevicemodelData((prevData) => ({
        ...prevData,
        show: true,
      }))

      urlParams = [];
      urlParams['device'] = categoriesData.value;
      urlParams['postal'] = postalData.value;
      urlParams['complete_address'] = postalData.complete_address;
      navigateHistory();

    }
  }

  const handlePostalBack = () => {
    setpostalData((prevData) => ({
      ...prevData,
      show: false,
      isSelected: false,
      value: '',
    }))

    setcategoriesData((prevData) => ({
      ...prevData,
      show: true,
      value: ''
    }))

    urlParams = [];
    navigateHistory();
  }


  const onChangeBrand = (selected_value) => {
    if (selected_value != '') {
      var name = '';
      for (var x in brandsData.data) {
        if (selected_value == brandsData.data[x]['brd_term_id']) {
          name = brandsData.data[x]['brd_term_name']
        }
      }

      setbrandsData({
        ...brandsData,
        isSelected: true,
        value: selected_value,
        name: name,
      })


      if (selected_value == other_product_id) {
        setproductsData((prevData) => ({
          ...prevData,
          show: false,
          value: '',
          isSelected: false,
          name: name,
        }))

        setskeletonData((prevData) => ({
          show: true,
        }))

        /* hook handleDeaviceContinue code here */
        get_variations(selected_value, 2);
        setrepairdevicename(name);

        urlParams = [];
        urlParams['device'] = selected_value;
        urlParams['postal'] = postalData.value;
        urlParams['complete_address'] = postalData.complete_address;
        navigateHistory();
      }
      else {
        get_products(selected_value);
      }


    }
    else {
      setbrandsData({
        ...brandsData,
        isSelected: false,
        value: ''
      })

      setproductsData({
        ...productsData,
        isSelected: false,
        value: '',
        show: false,
      })
    }
  }

  const onChangeProduct = (selected_val) => {

    if (selected_val != '') {
      var name = '';
      for (var x in productsData.data) {
        if (selected_val == productsData.data[x]['product_id']) {
          name = productsData.data[x]['product_name'];
        }
      }
      setproductsData((prevData) => ({
        ...prevData,
        isSelected: true,
        value: selected_val,
        name: name,
      }));


      /* hook handleDeviceContinue(); */

      setskeletonData((prevData) => ({
        show: true,
      }))


      setrepairdevicename(name);
      get_variations(selected_val, 3);


      urlParams = [];
      urlParams['device'] = selected_val;
      urlParams['postal'] = postalData.value;
      urlParams['complete_address'] = postalData.complete_address;
      navigateHistory();


    }
    else {
      setproductsData((prevData) => ({
        ...prevData,
        isSelected: false,
        value: '',
        name: '',
      }));
    }
  }

  const get_products = (parent_id,) => {
    axios.get(apiurl + '&operation=products&parent_id=' + parent_id)
      .then(response => {
        var stauscode = response.status;
        if (stauscode == 200) {
          var data = response.data;
          var error = data.error;
          if (error == 0) {

            setproductsData({
              ...productsData,
              show: true,
              data: data.data,
              isSelected: false,
              value: '',
              name: '',
            })

            /* this.setState(prevState => ({
            ...prevState,
            categories: {
            ...prevState.categories,
            show: false,
            },
            brands: {
            ...prevState.brands,
            show: false,
            },
            products: {
            ...prevState.products,
            show: true,
            data: data.data,
            prevStep: prevstep,
            }
            })) */


            setskeletonData((prevData) => ({
              ...prevData,
              show: false,
            }))
          }
        }
      })
      .catch(error => {

      })
  }

  const handleDeviceContinue = () => {

    if (brandsData.value == other_product_id) {
      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))
      setTimeout(function () {
        get_variations(brandsData.value, 2);
      }, 1000);

      setrepairdevicename(brandsData.name);

      urlParams = [];
      urlParams['device'] = brandsData.value;
      urlParams['postal'] = postalData.value;
      urlParams['complete_address'] = postalData.complete_address;
      navigateHistory();
    }
    else {
      if (productsData.isSelected) {
        setskeletonData((prevData) => ({
          ...prevData,
          show: true,
        }))
        setrepairdevicename(productsData.name);
        setTimeout(function () {
          get_variations(productsData.value, 3);
        }, 1000);


        urlParams = [];
        urlParams['device'] = productsData.value;
        urlParams['postal'] = postalData.value;
        urlParams['complete_address'] = postalData.complete_address;
        navigateHistory();
      }
    }

  }

  const handleDeviceBack = () => {
    var cat_step = parseInt(categoriesData.nextStep);
    setisStoreRepair(0);

    setbrandsData((prevData) => ({
      ...prevData,
      value: '',
      show: false,
      isSelected: false,
    }))


    setproductsData((prevData) => ({
      ...prevData,
      value: '',
      show: false,
      isSelected: false,
    }))

    setdevicemodelData((prevData) => ({
      ...prevData,
      show: false,
    }))

    setpostalData((prevData) => ({
      ...prevData,
      show: true,
      value: '',
      complete_address: '',
      isSelected: false,
    }))


    urlParams = [];
    urlParams['device'] = categoriesData.value;
    navigateHistory();
  }

  const get_variations = (product_id, stepback) => {
    axios.get(apiurl + '&operation=variations&product_id=' + product_id)
      .then(response => {
        var statuscode = response.status;
        if (statuscode == 200) {
          var data = response.data;
          var error = data.error;
          if (error == 0) {



            /* setbrandsData({
            ...brandsData,
            show: false,
            })
            setproductsData({
            ...productsData,
            show: false,
            }) */

            var variations = data.data;
            if (data.hasOwnProperty('screen_variations')) {
              var screen_variations = data.screen_variations;

              setBrokenScreensData({
                show: false,
                data: screen_variations,
                isSelected: false,
                value: '',
              })
            }

            setdevicemodelData({
              show: false,
            })



            if (variations.length == 1) {
              var vari_data = [];
              var variation_data = [];
              var selected_variation_names = [];

              vari_data['variation_id'] = variations[0]['variation_id'];
              vari_data['name'] = variations[0]['variation_name'];
              vari_data['isquote'] = parseInt(variations[0]['isquote']);
              vari_data['repair_timing'] = variations[0]['variation_timing'];
              variation_data.push(variation_data);
              selected_variation_names.push(variations[0]['variation_slug']);

              setvariationsData({
                ...variationsData,
                value: variations[0].variation_term_id,
                name: variations[0].variation_name,
                selected_variation_names: selected_variation_names,
                selected_data: variation_data,
                isSelected: true,
                show: true,
                data: variations,
                prevStep: stepback
              })
            }
            else {
              setvariationsData({
                ...variationsData,
                show: true,
                data: variations,
                prevStep: stepback
              })
            }




            setskeletonData((prevData) => ({
              ...prevData,
              show: false,
            }))
          }
        }
      })
      .catch(error => {

      })
  }

  const onVariationSelect = (variation_id, variation_name) => {
    var names = [];
    var values = [];
    var isquote = 0;
    var repair_timing = '';
    var is_selected = false;

    var rivalSelected = false;


    var variation_data = variationsData.selected_data;
    var variation_names = variationsData.selected_variation_names;
    var all_variations = variationsData.data;
    var rivalRepairs = variationsData.rivalRepairs;


    /* if (rivalRepairs.indexOf(variation_name) !== -1) {
      variation_names.map((vari_name) => {
        if (rivalRepairs.indexOf(vari_name) !== -1) {
          if (variation_names.indexOf(variation_name) !== -1) {
            
          }
          else {
            rivalSelected = true;
          }
  
        }
      })
    }
  
    if (rivalSelected) {
      variation_names.map((vari_name, index) => {
        if (rivalRepairs.indexOf(vari_name) !== -1) {
          variation_data.splice(index, 1);
          variation_names.splice(index, 1);
        }
      })
    } */


    if (rivalRepairs.indexOf(variation_name) !== -1) {
      variation_names.map((vari_name, index) => {
        if (rivalRepairs.indexOf(vari_name) !== -1) {
          rivalSelected = true;
        }
      })
    }

    if (rivalSelected && variation_names.indexOf(variation_name) == -1) {
      return false;
    }


    var index = -1;

    variation_data.forEach((vari, idx) => {
      if (vari['variation_id'] == variation_id) {
        index = idx;
      }
    })



    if (index !== -1) {
      variation_data.splice(index, 1);
      variation_names.splice(index, 1);
    }
    else {
      for (var x in variationsData.data) {
        if (variation_id == variationsData.data[x]['variation_term_id']) {

          var vari_data = [];
          vari_data['variation_id'] = variation_id;
          vari_data['name'] = variationsData.data[x]['variation_name'];
          vari_data['isquote'] = parseInt(variationsData.data[x]['isquote']);
          vari_data['repair_timing'] = variationsData.data[x]['variation_timing'];
          variation_data.push(vari_data);
          variation_names.push(variation_name);
        }
      }
    }

    variation_data.forEach((vari) => {
      names.push(vari['name']);
      values.push(vari['variation_id']);
      if (vari['isquote'] == 1) {
        isquote = vari['isquote'];
      }
    })

    if (variation_data.length > 0) {
      is_selected = true;
    }


    setvariationsData((prevData) => ({
      ...prevData,
      isSelected: is_selected,
      selected_data: variation_data,
      value: values.join(','),
      name: names.join(', '),
      isquote: isquote,
      selected_variation_names: variation_names
    }))

  }

  const RepairDescriptionChange = (event) => {
    var val = event.target.value;

    var new_val = val.trim();

    if (new_val.length == 0) {
      setvariationsData((prevData) => ({
        ...prevData,
        description: new_val,
      }))
    }
    else {

      if (val.length <= 500 && new_val.length != 0) {
        setvariationsData((prevData) => ({
          ...prevData,
          description: val,
        }))
      }
    }
  }

  const handleVariationContinue = async (zipcode = '') => {




    if (variationsData.isSelected && variationsData.data.length == 1) {
      if (variationsData.description == '') {
        return;
      }
    }

    if (variationsData.isSelected) {


      setrepairname(variationsData.name);
      setvariationsData((prevData) => ({
        ...prevData,
        show: false,
      }));

      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))


      urlParams = [];
      urlParams['device'] = get_device_for_url();
      urlParams['postal'] = zipcode;
      urlParams['complete_address'] = postalData.complete_address;
      urlParams['repair'] = variationsData.value;
      urlParams['repair_description'] = variationsData.description;
      urlParams['repair_description'] = variationsData.description;
      navigateHistory();


      /* if (isStoreSelected()) {
      handleservicelocationContinue();
      }
      else { */
      var services = await get_services(zipcode);
      var statuscode = services.status;
      if (statuscode == 200) {
        var data = services.data;
        var error = data.error;
        if (error == 0) {
          var first_service = 0;
          var resdata = data.data;

          if (resdata.length > 0) {
            first_service = resdata[0]['id'];
            if (repairdeskmailin) {
              for (var x in resdata) {
                if (resdata[x]['text'] == 'Mail In') {
                  first_service = resdata[x]['id'];
                }
              }
            }
          }


          if (resdata.length == 1) {
            for (var x in resdata) {
              if (resdata[x]['text'] == 'Mail In') {
                setonlyMailin(1);
              }
            }
          }
          else {
            setonlyMailin(0);
          }

          var store = 0;

          if (resdata.length == 1) {
            var locations = resdata[0]['locations'];
            if (locations.length == 1) {
              store = locations[0]['id'];
            }
          }

          setservicelocationsData((prevData) => ({
            ...prevData,
            show: true,
            data: resdata,
            service: first_service,
            store: store,
          }))


          setskeletonData((prevData) => ({
            ...prevData,
            show: false,
          }))
        }
      }
      /* } */
    }

  }

  const handleVariationBack = () => {
    var variation_step_back = variationsData.prevStep;
    urlParams = [];
    setvariationsData((prevData) => ({
      ...prevData,
      isSelected: false,
      selected_variation_names: [],
      selected_data: [],
      name: '',
      value: 0,
      show: false,
    }))


    if (variation_step_back == 2 || variation_step_back == 3) {


      if (variation_step_back == 2) {
        urlParams['device'] = brandsData.value;
        setbrandsData((prevData) => ({
          ...prevData,
          show: true,
        }))
      }

      if (variation_step_back == 3) {
        urlParams['device'] = productsData.value;
        setproductsData((prevData) => ({
          ...prevData,
          show: true,
        }))
      }


      setdevicemodelData((prevData) => ({
        ...prevData,
        show: true,
      }));

      setrepairdevicename(categoriesData.name);


      urlParams['postal'] = postalData.value;
      urlParams['complete_address'] = postalData.complete_address;
      urlParams['device'] = categoriesData.value;
      navigateHistory();
    }




    if (variation_step_back == 0) {
      setcategoriesData((prevData) => ({
        ...prevData,
        isSelected: false,
        show: true,
        value: '',
        name: '',
      }))


      urlParams['postal'] = postalData.value;
      urlParams['complete_address'] = postalData.complete_address;
      navigateHistory();
    }


  }


  const get_device_for_url = () => {
    var device = '';
    if (brandsData.value == other_product_id) {
      device = brandsData.value;
    }
    else {
      if (productsData.isSelected) {
        device = productsData.value;
      }
    }

    return device;

  }


  const get_services = async (postal_code) => {
    if (isStoreRepair) {
      var response = await axios.get(apiurl + '&operation=new_services&isstorerepair=1&store=' + servicelocationsData.store
        + '&postal=' + postal_code);
    }
    else {
      var response = await axios.get(apiurl + '&operation=new_services&postal=' + postal_code);
    }

    return response;
    /* var statuscode = response.status;
    axios.get(apiurl + '&operation=new_services&postal=' + postal_code)
    .then(response => {
    var statuscode = response.status;
    if (statuscode == 200) {
    var data = response.data;
    var error = data.error;
    if (error == 0) {
   
    }
    }
    })
    .catch(error => {
   
    }) */
  }



  const handleservicelocationContinueOLd = () => {


    if (servicelocationsData.store != 0 && servicelocationsData.service != 0) {

      var isquote = 0;
      var service = servicelocationsData.service;


      if (brandsData.value == other_product_id) {
        isquote = 1;
      }
      else if (productsData.value == other_product_id) {
        isquote = 1;
      }
      /* else if (variationsData.isquote == 1) {
        isquote = 1;
      } */
      else {
        var variation_data = variationsData.selected_data;

        variation_data.forEach((vari, idx) => {
          if (parseInt(vari['variation_id']) == other_term_id) {
            isquote = 1;
          }
        })
      }


      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))


      /*  ------------------------- */
      /* if (service == 1) {
        setservicelocationsData((prevData) => ({
          ...prevData,
          show: false,
        }))
  
        setcontactinfoData((prevData) => ({
          ...prevData,
          show: true,
        }))
  
        urlParams = [];
        urlParams['device'] = get_device_for_url();
        urlParams['postal'] = postalData.value;
        urlParams['complete_address'] = postalData.complete_address;
        urlParams['repair'] = variationsData.value;
        urlParams['repair_description'] = variationsData.description;
        urlParams['service'] = servicelocationsData.service;
        urlParams['store'] = servicelocationsData.store;
        navigateHistory();
  
        setTimeout(function () {
          setskeletonData((prevData) => ({
            ...prevData,
            show: false,
          }))
        }, 1000);
      }
      else { */
      var query_params = {
        operation: 'validate_before_checkout',
        term_id: variationsData.value,
        product_id: get_device_for_url(),
        service: servicelocationsData.service,
        store: servicelocationsData.store,
        postal: postalData.value,
      };


      var query_string = new URLSearchParams(query_params).toString();


      axios.get(`${apiurl}&${query_string}`)
        .then(response => {


          var stauscode = response.status;
          if (stauscode == 200) {
            var data = response.data;
            var error = data.error;
            if (error == 0) {
              if (service == 3) {
                var query_params = {
                  operation: 'get_appoitment_dates',
                  store: servicelocationsData.store,
                  repair_availability_type: variationsData.repair_timing,
                };

                var query_string = new URLSearchParams(query_params).toString();

                axios.get(`${apiurl}&${query_string}`)
                  .then(response => {
                    var stauscode = response.status;
                    if (stauscode == 200) {
                      var data = response.data;
                      var error = data.error;
                      if (error == 0) {
                        var date_slots = data.data.dates;
                        var time_slots = data.data.times;

                        setservicelocationsData((prevData) => ({
                          ...prevData,
                          show: false,
                        }))

                        var active = '';

                        date_slots.map((slot) => {
                          if (slot.active == 1) {
                            active = slot.date;
                          }
                        })


                        setcalendarapptData((prevData) => ({
                          ...prevData,
                          show: true,
                          date_slots: date_slots,
                          time_slots: time_slots,
                          date: active,
                        }))

                        setskeletonData((prevData) => ({
                          ...prevData,
                          show: false,
                        }))


                        urlParams = [];
                        urlParams['device'] = get_device_for_url();
                        urlParams['postal'] = postalData.value;
                        urlParams['complete_address'] = postalData.complete_address;
                        urlParams['repair'] = variationsData.value;
                        urlParams['repair_description'] = variationsData.description;
                        urlParams['service'] = servicelocationsData.service;
                        urlParams['store'] = servicelocationsData.store;
                        navigateHistory();

                        window.scroll(0, 0);
                      }
                    }
                  })
                  .catch(error => {

                  })
              }
              /* if service is mail-in and price is available */
              else if (service == 2) {
                AddToCart();
              }
              else {

                var price = data.price;
                var show_instore_price = data.show_instore_price;
                if (show_instore_price && price != 0 && price != '' && price != null) {
                  setinstorepriceData((prevData) => ({
                    ...prevData,
                    state: true,
                    value: data.price
                  }))
                }
                else {
                  setinstorepriceData((prevData) => ({
                    ...prevData,
                    state: false,
                    value: 0
                  }))
                }


                setservicelocationsData((prevData) => ({
                  ...prevData,
                  show: false,
                }))

                setcontactinfoData((prevData) => ({
                  ...prevData,
                  show: true,
                }))

                urlParams = [];
                urlParams['device'] = get_device_for_url();
                urlParams['postal'] = postalData.value;
                urlParams['complete_address'] = postalData.complete_address;
                urlParams['repair'] = variationsData.value;
                urlParams['repair_description'] = variationsData.description;
                urlParams['service'] = servicelocationsData.service;
                urlParams['store'] = servicelocationsData.store;
                navigateHistory();

                setTimeout(function () {
                  setskeletonData((prevData) => ({
                    ...prevData,
                    show: false,
                  }))
                }, 1000);
              }
            }
            else {
              setservicelocationsData((prevData) => ({
                ...prevData,
                show: false,
              }))

              setcontactinfoData((prevData) => ({
                ...prevData,
                show: true,
              }))

              setinstorepriceData((prevData) => ({
                ...prevData,
                state: false,
                value: 0
              }))

              urlParams = [];
              urlParams['device'] = get_device_for_url();
              urlParams['postal'] = postalData.value;
              urlParams['complete_address'] = postalData.complete_address;
              urlParams['repair'] = variationsData.value;
              urlParams['repair_description'] = variationsData.description;
              urlParams['service'] = servicelocationsData.service;
              urlParams['store'] = servicelocationsData.store;
              navigateHistory();

              setTimeout(function () {
                setskeletonData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
              }, 1000);
            }
          }
        })
        .catch(error => {

        })

      /*   } */
      /*  --------------------------   */


      /* if (isquote == 0 && service == 3) {
        var query_params = {
          operation: 'get_appoitment_dates',
          store: servicelocationsData.store,
          repair_availability_type: variationsData.repair_timing,
        };
  
        var query_string = new URLSearchParams(query_params).toString();
  
        axios.get(`${apiurl}&${query_string}`)
          .then(response => {
            var stauscode = response.status;
            if (stauscode == 200) {
              var data = response.data;
              var error = data.error;
              if (error == 0) {
                var date_slots = data.data.dates;
                var time_slots = data.data.times;
  
                setservicelocationsData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
  
                var active = '';
  
                date_slots.map((slot) => {
                  if (slot.active == 1) {
                    active = slot.date;
                  }
                })
  
  
                setcalendarapptData((prevData) => ({
                  ...prevData,
                  show: true,
                  date_slots: date_slots,
                  time_slots: time_slots,
                  date: active,
                }))
  
                setskeletonData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
  
  
                urlParams = [];
                urlParams['device'] = get_device_for_url();
                urlParams['postal'] = postalData.value;
                urlParams['complete_address'] = postalData.complete_address;
                urlParams['repair'] = variationsData.value;
                urlParams['repair_description'] = variationsData.description;
                urlParams['service'] = servicelocationsData.service;
                urlParams['store'] = servicelocationsData.store;
                navigateHistory();
  
  
  
                window.scroll(0, 0);
              }
            }
          })
          .catch(error => {
  
          })
      } */
      /* if service is mail-in and price is available */
      /*  else if (isquote == 0 && service == 2) {
         AddToCart();
       }
       else {
         setservicelocationsData((prevData) => ({
           ...prevData,
           show: false,
         }))
   
         setcontactinfoData((prevData) => ({
           ...prevData,
           show: true,
         }))
   
         urlParams = [];
         urlParams['device'] = get_device_for_url();
         urlParams['postal'] = postalData.value;
         urlParams['complete_address'] = postalData.complete_address;
         urlParams['repair'] = variationsData.value;
         urlParams['repair_description'] = variationsData.description;
         urlParams['service'] = servicelocationsData.service;
         urlParams['store'] = servicelocationsData.store;
         navigateHistory();
   
         setTimeout(function () {
           setskeletonData((prevData) => ({
             ...prevData,
             show: false,
           }))
         }, 1000);
       } */
    }



    /* if (servicelocationsData.store != 0 && servicelocationsData.service != 0) {
    setservicelocationsData((prevData) => ({
    ...prevData,
    show: false,
    }))
   
    setcalendarapptData((prevData) => ({
    ...prevData,
    show: true,
    }))
    }
   
    urlParams = [];
    urlParams['device'] = get_device_for_url();
    urlParams['postal'] = postalData.value;
    urlParams['complete_address'] = postalData.complete_address;
    urlParams['repair'] = variationsData.value;
    urlParams['repair_description'] = variationsData.description;
    urlParams['service'] = servicelocationsData.service;
    urlParams['store'] = servicelocationsData.store;
    navigateHistory(); */
  }


  const handleservicelocationContinue = () => {

    setservicelocationsData((prevData) => ({
      ...prevData,
      show: false,
    }))

    setcontactinfoData((prevData) => ({
      ...prevData,
      show: true,
    }))

    setinstorepriceData((prevData) => ({
      ...prevData,
      state: false,
      value: 0
    }))

    urlParams = [];
    urlParams['device'] = get_device_for_url();
    urlParams['postal'] = postalData.value;
    urlParams['complete_address'] = postalData.complete_address;
    urlParams['repair'] = variationsData.value;
    urlParams['repair_description'] = variationsData.description;
    urlParams['service'] = servicelocationsData.service;
    urlParams['store'] = servicelocationsData.store;
    navigateHistory();

    setTimeout(function () {
      setskeletonData((prevData) => ({
        ...prevData,
        show: false,
      }))
    }, 1000);

    return false;


    if (servicelocationsData.store != 0 && servicelocationsData.service != 0) {

      var isquote = 0;
      var service = servicelocationsData.service;


      if (brandsData.value == other_product_id) {
        isquote = 1;
      }
      else if (productsData.value == other_product_id) {
        isquote = 1;
      }
      /* else if (variationsData.isquote == 1) {
        isquote = 1;
      } */
      else {
        var variation_data = variationsData.selected_data;

        variation_data.forEach((vari, idx) => {
          if (parseInt(vari['variation_id']) == other_term_id) {
            isquote = 1;
          }
        })
      }


      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))



      var query_params = {
        operation: 'validate_before_checkout',
        term_id: variationsData.value,
        product_id: get_device_for_url(),
        service: servicelocationsData.service,
        store: servicelocationsData.store,
        postal: postalData.value,
      };


      var query_string = new URLSearchParams(query_params).toString();


      axios.get(`${apiurl}&${query_string}`)
        .then(response => {


          var stauscode = response.status;
          if (stauscode == 200) {
            var data = response.data;
            var error = data.error;
            if (error == 0) {
              if (service == 3) {
                var query_params = {
                  operation: 'get_appoitment_dates',
                  store: servicelocationsData.store,
                  repair_availability_type: variationsData.repair_timing,
                };

                var query_string = new URLSearchParams(query_params).toString();

                axios.get(`${apiurl}&${query_string}`)
                  .then(response => {
                    var stauscode = response.status;
                    if (stauscode == 200) {
                      var data = response.data;
                      var error = data.error;
                      if (error == 0) {
                        var date_slots = data.data.dates;
                        var time_slots = data.data.times;

                        setservicelocationsData((prevData) => ({
                          ...prevData,
                          show: false,
                        }))

                        var active = '';

                        date_slots.map((slot) => {
                          if (slot.active == 1) {
                            active = slot.date;
                          }
                        })


                        setcalendarapptData((prevData) => ({
                          ...prevData,
                          show: true,
                          date_slots: date_slots,
                          time_slots: time_slots,
                          date: active,
                        }))

                        setskeletonData((prevData) => ({
                          ...prevData,
                          show: false,
                        }))


                        urlParams = [];
                        urlParams['device'] = get_device_for_url();
                        urlParams['postal'] = postalData.value;
                        urlParams['complete_address'] = postalData.complete_address;
                        urlParams['repair'] = variationsData.value;
                        urlParams['repair_description'] = variationsData.description;
                        urlParams['service'] = servicelocationsData.service;
                        urlParams['store'] = servicelocationsData.store;
                        navigateHistory();

                        window.scroll(0, 0);
                      }
                    }
                  })
                  .catch(error => {

                  })
              }
              /* if service is mail-in and price is available */
              else if (service == 2) {
                AddToCart();
              }
              else {

                var price = data.price;
                var show_instore_price = data.show_instore_price;
                if (show_instore_price && price != 0 && price != '' && price != null) {
                  setinstorepriceData((prevData) => ({
                    ...prevData,
                    state: true,
                    value: data.price
                  }))
                }
                else {
                  setinstorepriceData((prevData) => ({
                    ...prevData,
                    state: false,
                    value: 0
                  }))
                }


                setservicelocationsData((prevData) => ({
                  ...prevData,
                  show: false,
                }))

                setcontactinfoData((prevData) => ({
                  ...prevData,
                  show: true,
                }))

                urlParams = [];
                urlParams['device'] = get_device_for_url();
                urlParams['postal'] = postalData.value;
                urlParams['complete_address'] = postalData.complete_address;
                urlParams['repair'] = variationsData.value;
                urlParams['repair_description'] = variationsData.description;
                urlParams['service'] = servicelocationsData.service;
                urlParams['store'] = servicelocationsData.store;
                navigateHistory();

                setTimeout(function () {
                  setskeletonData((prevData) => ({
                    ...prevData,
                    show: false,
                  }))
                }, 1000);
              }
            }
            else {
              setservicelocationsData((prevData) => ({
                ...prevData,
                show: false,
              }))

              setcontactinfoData((prevData) => ({
                ...prevData,
                show: true,
              }))

              setinstorepriceData((prevData) => ({
                ...prevData,
                state: false,
                value: 0
              }))

              urlParams = [];
              urlParams['device'] = get_device_for_url();
              urlParams['postal'] = postalData.value;
              urlParams['complete_address'] = postalData.complete_address;
              urlParams['repair'] = variationsData.value;
              urlParams['repair_description'] = variationsData.description;
              urlParams['service'] = servicelocationsData.service;
              urlParams['store'] = servicelocationsData.store;
              navigateHistory();

              setTimeout(function () {
                setskeletonData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
              }, 1000);
            }
          }
        })
        .catch(error => {

        })

      /*   } */
      /*  --------------------------   */


      /* if (isquote == 0 && service == 3) {
        var query_params = {
          operation: 'get_appoitment_dates',
          store: servicelocationsData.store,
          repair_availability_type: variationsData.repair_timing,
        };
  
        var query_string = new URLSearchParams(query_params).toString();
  
        axios.get(`${apiurl}&${query_string}`)
          .then(response => {
            var stauscode = response.status;
            if (stauscode == 200) {
              var data = response.data;
              var error = data.error;
              if (error == 0) {
                var date_slots = data.data.dates;
                var time_slots = data.data.times;
  
                setservicelocationsData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
  
                var active = '';
  
                date_slots.map((slot) => {
                  if (slot.active == 1) {
                    active = slot.date;
                  }
                })
  
  
                setcalendarapptData((prevData) => ({
                  ...prevData,
                  show: true,
                  date_slots: date_slots,
                  time_slots: time_slots,
                  date: active,
                }))
  
                setskeletonData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
  
  
                urlParams = [];
                urlParams['device'] = get_device_for_url();
                urlParams['postal'] = postalData.value;
                urlParams['complete_address'] = postalData.complete_address;
                urlParams['repair'] = variationsData.value;
                urlParams['repair_description'] = variationsData.description;
                urlParams['service'] = servicelocationsData.service;
                urlParams['store'] = servicelocationsData.store;
                navigateHistory();
  
  
  
                window.scroll(0, 0);
              }
            }
          })
          .catch(error => {
  
          })
      } */
      /* if service is mail-in and price is available */
      /*  else if (isquote == 0 && service == 2) {
         AddToCart();
       }
       else {
         setservicelocationsData((prevData) => ({
           ...prevData,
           show: false,
         }))
   
         setcontactinfoData((prevData) => ({
           ...prevData,
           show: true,
         }))
   
         urlParams = [];
         urlParams['device'] = get_device_for_url();
         urlParams['postal'] = postalData.value;
         urlParams['complete_address'] = postalData.complete_address;
         urlParams['repair'] = variationsData.value;
         urlParams['repair_description'] = variationsData.description;
         urlParams['service'] = servicelocationsData.service;
         urlParams['store'] = servicelocationsData.store;
         navigateHistory();
   
         setTimeout(function () {
           setskeletonData((prevData) => ({
             ...prevData,
             show: false,
           }))
         }, 1000);
       } */
    }



    /* if (servicelocationsData.store != 0 && servicelocationsData.service != 0) {
    setservicelocationsData((prevData) => ({
    ...prevData,
    show: false,
    }))
   
    setcalendarapptData((prevData) => ({
    ...prevData,
    show: true,
    }))
    }
   
    urlParams = [];
    urlParams['device'] = get_device_for_url();
    urlParams['postal'] = postalData.value;
    urlParams['complete_address'] = postalData.complete_address;
    urlParams['repair'] = variationsData.value;
    urlParams['repair_description'] = variationsData.description;
    urlParams['service'] = servicelocationsData.service;
    urlParams['store'] = servicelocationsData.store;
    navigateHistory(); */
  }






  const handleservicelocationBack = () => {
    setservicelocationsData((prevData) => ({
      ...prevData,
      show: false,
    }))
    setvariationsData((prevData) => ({
      ...prevData,
      show: true,
    }))

    urlParams = [];
    urlParams['device'] = get_device_for_url();
    urlParams['postal'] = postalData.value;
    urlParams['complete_address'] = postalData.complete_address;
    navigateHistory();
  }

  const enableDisableLocationClass = () => {
    if (servicelocationsData.store != 0 && servicelocationsData.service != 0) {
      return '';
    }
    return 'disabled';
  }

  const get_store_location = () => {
    var location = '';
    for (var x in servicelocationsData.data) {

      if (servicelocationsData.data[x]['id'] == servicelocationsData.service) {
        for (var y in servicelocationsData.data[x]['locations']) {
          if (servicelocationsData.data[x]['locations'][y]['id'] == servicelocationsData.store) {
            location = servicelocationsData.data[x]['locations'][y]['address1'];
            break;
          }
        }
      }
    }

    return location;
  }

  const isStoreSelected = () => {
    return servicelocationsData.store != 0 && servicelocationsData.service != 0
  }

  const dateSlotsClass = (item) => {
    var cls = [];
    cls.push('dates_list_item');


    if (item.disabled) {
      cls.push('closed');
    }

    if (item.date == calendarapptData.date) {
      cls.push('active');
    }

    return cls.join(' ');
  }


  const timeSlotsClass = (item) => {
    var cls = [];
    cls.push('time_list_item');

    var match_str = `${item.start_time}-${item.end_time}`;

    if (match_str == calendarapptData.time) {
      cls.push('active');
    }

    return cls.join(' ');
  }


  const dateCarrySlotsClass = (item) => {
    var cls = [];
    cls.push('dates_list_item');


    if (item.disabled) {
      cls.push('closed');
    }

    if (item.date == calendarCarryapptData.date) {
      cls.push('active');
    }

    return cls.join(' ');
  }


  const timeCarrySlotsClass = (item) => {
    var cls = [];
    cls.push('time_list_item');

    var match_str = `${item.start_time}-${item.end_time}`;

    if (match_str == calendarCarryapptData.time) {
      cls.push('active');
    }

    return cls.join(' ');
  }


  const enableDisableCalendarClass = () => {
    if (calendarapptData.date == '' || calendarapptData.time == '') {
      return 'disabled';
    }
    return '';
  }

  const enableDisableCarryCalendarClass = () => {
    if (calendarCarryapptData.date == '' || calendarCarryapptData.time == '') {
      return 'disabled';
    }
    return '';
  }

  const selectAppDate = (item) => {

    if (!item.disabled && item.date != calendarapptData.date) {



      setcalendarapptData((prevData) => ({
        ...prevData,
        date: item.date,
      }))



      var query_params = {
        operation: 'get_appoitment_times',
        date: item.date,
        store: servicelocationsData.store,
        repair_availability_type: variationsData.repair_timing,
      };

      var query_string = new URLSearchParams(query_params).toString();

      axios.get(`${apiurl}&${query_string}`)
        .then(response => {
          var stauscode = response.status;
          if (stauscode == 200) {
            var data = response.data;
            var error = data.error;
            if (error == 0) {
              var time_slots = data.data;

              setcalendarapptData((prevData) => ({
                ...prevData,
                time_slots: time_slots,
                /*  date: item.date, */
                time: '',
              }))

            }
          }
        })
        .catch(error => {

        })
    }
  }

  const selectAppTime = (item) => {

    var new_time = `${item.start_time}-${item.end_time}`;
    setcalendarapptData((prevData) => ({
      ...prevData,
      time: new_time,
    }))
  }


  const selectCarryAppDate = (item) => {

    if (!item.disabled && item.date != calendarCarryapptData.date) {

      setCarrycalendarapptData((prevData) => ({
        ...prevData,
        date: item.date,
      }));



      /* setskeletonData((prevData) => ({
        show: true,
      })) */

      var query_params = {
        operation: 'get_carry_appoitment_times',
        date: item.date,
        store: servicelocationsData.store,
        repair_availability_type: variationsData.repair_timing,
      };

      var query_string = new URLSearchParams(query_params).toString();

      axios.get(`${apiurl}&${query_string}`)
        .then(response => {

          /* setskeletonData((prevData) => ({
            show: false,
          })) */


          var stauscode = response.status;
          if (stauscode == 200) {
            var data = response.data;
            var error = data.error;
            if (error == 0) {
              var time_slots = data.data;

              setCarrycalendarapptData((prevData) => ({
                ...prevData,
                time_slots: time_slots,
                /*  date: item.date, */
                time: '',
              }))

            }
          }
        })
        .catch(error => {
          /* setskeletonData((prevData) => ({
            show: false,
          })) */
        })
    }
  }

  const selectCarryAppTime = (item) => {

    var new_time = `${item.start_time}-${item.end_time}`;
    setCarrycalendarapptData((prevData) => ({
      ...prevData,
      time: new_time,
    }))
  }

  const get_date_str_time_slot = () => {
    var dt = calendarapptData.date;
    var new_dt_str = '';
    if (dt != '') {
      /* var new_dt = new Date(dt); */
       var parts = dt.split('-');
       var new_dt = new Date(parts[0], parts[1] - 1, parts[2]); // Note: month is 0-indexed

      var month_arr = {
        '0': 'January',
        '1': 'February',
        '2': 'March',
        '3': 'April',
        '4': 'May',
        '5': 'June',
        '6': 'July',
        '7': 'August',
        '8': 'September',
        '9': 'October',
        '10': 'November',
        '11': 'December'
      };

      var days_arr = {
        '0': 'Sun',
        '1': 'Mon',
        '2': 'Tue',
        '3': 'Wed',
        '4': 'Thu',
        '5': 'Fri',
        '6': 'Sat',
      };

      new_dt_str = `${days_arr[new_dt.getDay()]}, ${month_arr[new_dt.getMonth()]} ${new_dt.getDate()}`;
    }

    return new_dt_str;
  }

  const get_carry_date_str_time_slot = () => {
    var dt = calendarCarryapptData.date;
    var new_dt_str = '';
    if (dt != '') {
     /*  var new_dt = new Date(dt); */
      var parts = dt.split('-');
       var new_dt = new Date(parts[0], parts[1] - 1, parts[2]);
      var month_arr = {
        '0': 'January',
        '1': 'February',
        '2': 'March',
        '3': 'April',
        '4': 'May',
        '5': 'June',
        '6': 'July',
        '7': 'August',
        '8': 'September',
        '9': 'October',
        '10': 'November',
        '11': 'December'
      };

      var days_arr = {
        '0': 'Sun',
        '1': 'Mon',
        '2': 'Tue',
        '3': 'Wed',
        '4': 'Thu',
        '5': 'Fri',
        '6': 'Sat',
      };

      new_dt_str = `${days_arr[new_dt.getDay()]}, ${month_arr[new_dt.getMonth()]} ${new_dt.getDate()}`;
    }

    return new_dt_str;
  }


  const handlecalendarapptContinue = () => {

    if (calendarapptData.date != '' && calendarapptData.time != '') {
      var isquote = 0;
      var service = servicelocationsData.service;
      if (brandsData.value == other_product_id) {
        isquote = 1;
      }
      else if (productsData.value == other_product_id) {
        isquote = 1;
      }
      else if (variationsData.isquote == 1) {
        isquote = 1;
      }


      if (service == 3) {
        setskeletonData((prevData) => ({
          show: true,
        }))
        AddToCart(quoteLeadID)
      }
      else if (service == 1) {
        urlParams = [];
        urlParams['device'] = get_device_for_url();
        urlParams['postal'] = postalData.value;
        urlParams['repair'] = variationsData.value;
        urlParams['repair_description'] = variationsData.description;
        urlParams['complete_address'] = postalData.complete_address;
        urlParams['service'] = servicelocationsData.service;
        urlParams['store'] = servicelocationsData.store;
        urlParams['date'] = calendarapptData.date;
        urlParams['time'] = calendarapptData.time;
        navigateHistory();

        setcalendarapptData((prevData) => ({
          ...prevData,
          show: false,
        }))

        setcontactinfoData((prevData) => ({
          ...prevData,
          show: true,
        }))


      }
      /* else {
      setcalendarapptData((prevData) => ({
      ...prevData,
      show: false,
      }))
    
      setcontactinfoData((prevData) => ({
      ...prevData,
      show: true,
      }))
    
      urlParams = [];
      urlParams['device'] = get_device_for_url();
      urlParams['postal'] = postalData.value;
      urlParams['complete_address'] = postalData.complete_address;
      urlParams['repair'] = variationsData.value;
      urlParams['repair_description'] = variationsData.description;
      urlParams['service'] = servicelocationsData.service;
      urlParams['store'] = servicelocationsData.store;
      navigateHistory();
      } */
    }
  }

  const AddToCart = (lead_id = 0) => {
    var term_ids = variationsData.value;
    term_ids = term_ids.split(',');

    if (variationsData.value.includes("14592")) {
      term_ids.push(brokenScreensData.value);
    }

    var index = -1;

    term_ids.forEach((term_id, idx) => {
      if (term_id == '14592') {
        index = idx;
      }
    })

    if (index !== -1) {
      term_ids.splice(index, 1);
    }

    term_ids = term_ids.filter(value => value);
    var query_params = {
      operation: 'add_to_cart',
      term_id: term_ids.join(','),
      product_id: get_device_for_url(),
      service: servicelocationsData.service,
      store: servicelocationsData.store,
      postal: postalData.value,
      date: calendarapptData.date,
      time: calendarapptData.time,
      complete_address: postalData.complete_address,
    };

    if (lead_id != 0) {
      query_params.lead_id = lead_id;
    }


    var check_query_params = {
      device: get_device_for_url(),
      repair: variationsData.value,
      repair_description: variationsData.description,
      service: servicelocationsData.service,
      store: servicelocationsData.store,
      postal: postalData.value,
    };


    const firstObjectKeys = Object.keys(check_query_params);

    const filteredKeys = Object.keys(trackingParamsData).filter(key => !firstObjectKeys.includes(key));

    const filteredSecondObject = filteredKeys.reduce((obj, key) => {
      obj[key] = trackingParamsData[key];
      return obj;
    }, {});


    var query_string = new URLSearchParams(query_params).toString();
    var cart_query_string = new URLSearchParams(filteredSecondObject).toString();

    axios.get(`${apiurl}&${query_string}`)
      .then(response => {
        var stauscode = response.status;
        if (stauscode == 200) {
          var data = response.data;
          var error = data.error;
          if (error == 0) {
            window.location.href = `${storeurl}checkout?${cart_query_string}`;
          }
          else {
            /*  window.location.reload(); */
          }
        }
      })
      .catch(error => {

      })
  }

  const handlecalendarapptBack = () => {
    setcalendarapptData((prevData) => ({
      ...prevData,
      show: false,
    }))

    setservicelocationsData((prevData) => ({
      ...prevData,
      show: true,
    }))

    urlParams = [];
    urlParams['device'] = get_device_for_url();
    urlParams['postal'] = postalData.value;
    urlParams['repair'] = variationsData.value;
    urlParams['repair_description'] = variationsData.description;
    urlParams['complete_address'] = postalData.complete_address;
    urlParams['service'] = servicelocationsData.service;
    urlParams['store'] = servicelocationsData.store;
    navigateHistory();
  }

  const handleBrokenScreenBack = () => {
    setBrokenScreensData((prevData) => ({
      ...prevData,
      show: false,
    }))

    setquoteSuccessData((prevData) => ({
      ...prevData,
      show: false,
      data: [],
      leadDetailsUrl: '',
      leadRescheduleUrl: '',
      addToCalendarBtns: {},
    }))

    setquoteLeadID(0);

    handlecontactinfoBack();
  }

  const handlecontactinfoBack = () => {
    setcontactinfoData((prevData) => ({
      ...prevData,
      show: false,
    }))

    var service = servicelocationsData.service;

    if (service == 1) {


      setservicelocationsData((prevData) => ({
        ...prevData,
        show: true,
      }))

      /* setskeletonData((prevData) => ({
      ...prevData,
      show: true,
      }))
    
      var query_params = {
      operation: 'get_carry_appoitment_dates',
      store: servicelocationsData.store,
      repair_availability_type: variationsData.repair_timing,
      };
    
      var query_string = new URLSearchParams(query_params).toString();
    
      axios.get(`${apiurl}&${query_string}`)
      .then(response => {
      var stauscode = response.status;
      if (stauscode == 200) {
      var data = response.data;
      var error = data.error;
      if (error == 0) {
      var date_slots = data.data.dates;
      var time_slots = data.data.times;
    
      var active = '';
    
      date_slots.map((slot) => {
      if (slot.active == 1) {
      active = slot.date;
      }
      })
    
    
      setcalendarapptData((prevData) => ({
      ...prevData,
      show: true,
      date_slots: date_slots,
      time_slots: time_slots,
      date: active,
      time: '',
      }))
    
      setskeletonData((prevData) => ({
      ...prevData,
      show: false,
      }))
      }
      }
      })
      .catch(error => {
    
      }) */
    }
    else {
      setservicelocationsData((prevData) => ({
        ...prevData,
        show: true,
      }))
    }




    /* if(servicelocations.service==3){
    setcalendarapptData((prevData) => ({
    ...prevData,
    show: true,
    }))
    }
    else{
   
    } */



    urlParams = [];
    urlParams['device'] = get_device_for_url();
    urlParams['postal'] = postalData.value;
    urlParams['complete_address'] = postalData.complete_address;
    urlParams['service'] = servicelocationsData.service;
    urlParams['store'] = servicelocationsData.store;
    navigateHistory();
  }


  const handleContactInput = (e) => {
    const { name, value } = e.target;
    var new_value = value;
    if (name == 'phone') {
      if (new_value.length <= 10) { new_value = new_value.replace(/\D/g, ''); } else {
        new_value = contactinfoData[name].value;
      }
    } if (name == 'postalCode') {
      if (new_value.length <= 6) { new_value = new_value.replace(/\D/g, ''); } else {
        new_value = contactinfoData[name].value;
      }
    } setcontactinfoData((prevData) => ({
      ...prevData,
      [name]: {
        ...prevData[name],
        value: new_value
      }
    }))
  }

  const changeContactMethod = (id) => {
    setcontactinfoData((prevData) => ({
      ...prevData,
      contact_methods: prevData.contact_methods.map((option) =>
        option.id === id ? { ...option, checked: !option.checked } : option
      )
    }));
  };

  const hasErrorInput = (fieldName, value) => {
    var error = 0;
    var err_msg = '';
    switch (fieldName) {
      case 'firstName':
      case 'lastName':
        if (value === '') {
          error = 1;
          err_msg = 'This field is required';
        }
        break;
      case 'postalCode':
        if (!validatePostal(value)) {
          error = 1;
          err_msg = 'Please enter valid zip code';
        }
        break;
      case 'phone':
        if (!validatePhone(value)) {
          error = 1;
          err_msg = 'Please enter a valid phone number';
        }
        break;
      case 'email':
        if (!validateEmail(value)) {
          error = 1;
          err_msg = 'Please enter a valid email address';
        }
        break;
    }

    if (error == 0) {
      return false;
    }
    return err_msg;
  }


  const validateEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  const validatePhone = (value) => {
    return /^\d{10}$/.test(value);
  }

  const validatePostal = (value) => {
    return /^(?:\d{5}|\d{6})$/.test(value);
  }

  const RecaptchonChange = (value) => {
    if (value != null || value != '') {
      if (contactinfoData.show) {
        handleSubmit();
        setcontactinfoData((prevData) => ({
          ...prevData,
          recaptcha: {
            ...prevData.recaptcha,
            error: 0,
          }
        }))
      }
    }
    else {
      /*  console.log('RecaptchonChangeElse'); */

    }
  }

  const handleSubmit = () => {
    var recaptchaValue = recaptchaRef.current.getValue();
    if (recaptchaValue == '' || recaptchaValue == null) {
      recaptchaRef.current.execute();
    }

    else {


      /* console.log('recaptchaValue ',recaptchaValue); */

      var firstName = contactinfoData.firstName.value;
      var lastName = contactinfoData.lastName.value;
      var postalCode = contactinfoData.postalCode.value;
      var phone = contactinfoData.phone.value;
      var email = contactinfoData.email.value;
      var notes = contactinfoData.notes.value;

      var new_contactinfo = {
        firstName: {
          error: 0,
          error_msg: '',
        },
        lastName: {
          error: 0,
          error_msg: '',
        },
        email: {
          error: 0,
          error_msg: '',
        },
        phone: {
          error: 0,
          error_msg: '',
        },
        postalCode: {
          error: 0,
          error_msg: '',
        },
        contactMethod: {
          error: 0,
        },
        recaptcha: {
          error: 0,
        }
      };

      var hasError = false;



      var haserror_firstname = hasErrorInput('firstName', firstName);

      if (!haserror_firstname) {
        new_contactinfo.firstName.error = 0;
        new_contactinfo.firstName.error_msg = '';
      }
      else {
        hasError = true;
        new_contactinfo.firstName.error = 1;
        new_contactinfo.firstName.error_msg = haserror_firstname;
      }

      var haserror_lastname = hasErrorInput('lastName', lastName);
      if (!haserror_lastname) {
        new_contactinfo.lastName.error = 0;
        new_contactinfo.lastName.error_msg = '';
      }
      else {
        hasError = true;
        new_contactinfo.lastName.error = 1;
        new_contactinfo.lastName.error_msg = haserror_lastname;
      }

      var haserror_postalCode = hasErrorInput('postalCode', postalCode);
      if (!haserror_postalCode) {
        new_contactinfo.postalCode.error = 0;
        new_contactinfo.postalCode.error_msg = '';
      }
      else {
        hasError = true;
        new_contactinfo.postalCode.error = 1;
        new_contactinfo.postalCode.error_msg = haserror_postalCode;
      }

      var haserror_phone = hasErrorInput('phone', phone);
      if (!haserror_phone) {
        new_contactinfo.phone.error = 0;
        new_contactinfo.phone.error_msg = '';
      }
      else {
        hasError = true;
        new_contactinfo.phone.error = 1;
        new_contactinfo.phone.error_msg = haserror_phone;
      }

      var haserror_email = hasErrorInput('email', email);
      if (!haserror_email) {
        new_contactinfo.email.error = 0;
        new_contactinfo.email.error_msg = '';
      }
      else {
        hasError = true;
        new_contactinfo.email.error = 1;
        new_contactinfo.email.error_msg = haserror_email;
      }


      var contact_methods = [];
      contactinfoData.contact_methods.map((option) => {
        if (option.checked) {
          contact_methods.push(option.value);
        }
      })

      if (contact_methods.length == 0) {
        hasError = true;
        new_contactinfo.contactMethod.error = 1;
      } else {
        new_contactinfo.contactMethod.error = 0;
      }


      var recaptchaValue = recaptchaRef.current.getValue();

      if (recaptchaValue == '' || recaptchaValue == null) {
        hasError = true;
        new_contactinfo.recaptcha.error = 1;
      }
      else {
        new_contactinfo.recaptcha.error = 0;
      }

      setcontactinfoData((prevData) => ({
        ...prevData,
        firstName: {
          ...prevData.firstName,
          error: new_contactinfo.firstName.error,
          error_msg: new_contactinfo.firstName.error_msg,
        },
        lastName: {
          ...prevData.lastName,
          error: new_contactinfo.lastName.error,
          error_msg: new_contactinfo.lastName.error_msg,
        },
        postalCode: {
          ...prevData.postalCode,
          error: new_contactinfo.postalCode.error,
          error_msg: new_contactinfo.postalCode.error_msg,
        },
        phone: {
          ...prevData.phone,
          error: new_contactinfo.phone.error,
          error_msg: new_contactinfo.phone.error_msg,
        },
        email: {
          ...prevData.email,
          error: new_contactinfo.email.error,
          error_msg: new_contactinfo.email.error_msg,
        },
        contactMethod: {
          ...prevData.contactMethod,
          error: new_contactinfo.contactMethod.error,
        },
        recaptcha: {
          error: new_contactinfo.recaptcha.error,
          error_msg: 'reCAPTCHA verification failed',
        }
      }))


      if (!hasError) {


        setskeletonData((prevData) => ({
          ...prevData,
          show: true,
        }))

        var service = servicelocationsData.service;

        var query_params = {
          operation: 'submitquote',
          variation_id: variationsData.value,
          repairDes: variationsData.description,
          product_id: get_device_for_url(),
          service: service,
          store: servicelocationsData.store,
          postal: postalCode,
          first_name: firstName,
          last_name: lastName,
          phone: phone,
          email: email,
          notes: notes,
          contactMethod: contact_methods.join(','),
          price: instorepriceData.value,
        };


        var check_query_params = {
          operation: 'submitquote',
          device: get_device_for_url(),
          repair: variationsData.value,
          repair_description: variationsData.description,
          service: service,
          store: servicelocationsData.store,
          postal: postalCode,

        };


        const firstObjectKeys = Object.keys(check_query_params);

        const filteredKeys = Object.keys(trackingParamsData).filter(key => !firstObjectKeys.includes(key));

        const filteredSecondObject = filteredKeys.reduce((obj, key) => {
          obj[key] = trackingParamsData[key];
          return obj;
        }, {});


        const merge_query_params = { ...query_params, ...filteredSecondObject };



        /* if (service == 1) {
        query_params.date = calendarapptData.date;
        query_params.time = calendarapptData.time;
        } */



        var query_string = new URLSearchParams(merge_query_params).toString();

        axios.get(`${apiurl}&${query_string}`)
          .then(response => {
            var stauscode = response.status;
            if (stauscode == 200) {
              var data = response.data;
              var quoteResponse = data;
              setquoteLeadID(data.data.quote_id);
              var error = data.error;
              if (error == 0) {
                if (service == 1) {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    'event': 'in_store_quote_requested',
                    'lead_id': data.data.quote_id,
                  });
                }
                if (service == 2) {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    'event': 'mail_in_quote_requested',
                    'lead_id': data.data.quote_id,
                  });
                }
                if (service == 3) {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    'event': 'mobile_repair_quote_requested',
                    'lead_id': data.data.quote_id,
                  });
                }


                setquoteSuccessData((prevData) => ({
                  ...prevData,
                  data: quoteResponse.data
                }))



                if (variationsData.value.includes("14592")) {

                  setskeletonData((prevData) => ({
                    ...prevData,
                    show: false,
                  }))



                   


                  var isFoundGlassRepair = false;

                  for (var x in brokenScreensData.data) {
                    if ("glass-repair" == brokenScreensData.data[x]['variation_slug']) {
                      setBrokenScreensData((prevData) => ({
                        ...prevData,
                        isSelected: true,
                        value: brokenScreensData.data[x]['variation_term_id'],
                        selected_variation_name: brokenScreensData.data[x]['variation_name'],
                        show: true,
                      }))

                      isFoundGlassRepair = true;
                    }
                  }


                  if (!isFoundGlassRepair) {
                    setBrokenScreensData((prevData) => ({
                      ...prevData,
                      show: true,
                    }))
                  }

                } else {
                  checkForAddToCart(data.data.quote_id);
                }

              }
              else {
                var errors = data.errors;

                setskeletonData((prevData) => ({
                  ...prevData,
                  show: false,
                }))


                setcontactinfoData((prevData) => ({
                  ...prevData,
                  errors: errors,
                }))

              }
            }
          })
          .catch(error => {

          })

      }
    }
  }

  const onBrokenVariationSelect = (variation_id, variation_name) => {

    for (var x in brokenScreensData.data) {
      if (variation_id == brokenScreensData.data[x]['variation_term_id']) {
        setBrokenScreensData((prevData) => ({
          ...prevData,
          isSelected: true,
          value: variation_id,
          selected_variation_name: brokenScreensData.data[x]['variation_name'],
        }))
      }
    }
  }


  const checkForAddToCart = (lead_id = 0) => {
    var service = servicelocationsData.service;
    var term_ids = variationsData.value;
    term_ids = term_ids.split(',');

    if (variationsData.value.includes("14592")) {
      term_ids.push(brokenScreensData.value);
    }

    var index = -1;

    term_ids.forEach((term_id, idx) => {
      if (term_id == '14592') {
        index = idx;
      }
    })

    if (index !== -1) {
      term_ids.splice(index, 1);
    }

    term_ids = term_ids.filter(value => value); // This will remove any falsy value like empty strings, null, undefined, etc.

    var query_params = {
      operation: 'validate_before_checkout',
      term_id: term_ids.join(','),
      product_id: get_device_for_url(),
      service: servicelocationsData.service,
      store: servicelocationsData.store,
      postal: postalData.value,
    };


    var query_string = new URLSearchParams(query_params).toString();

    setskeletonData((prevData) => ({
      ...prevData,
      show: true,
    }))

    axios.get(`${apiurl}&${query_string}`)
      .then(response => {


        setcontactinfoData((prevData) => ({
          ...prevData,
          show: false,
        }))


        setBrokenScreensData((prevData) => ({
          ...prevData,
          show: false,
        }))


        setskeletonData((prevData) => ({
          ...prevData,
          show: false,
        }))

        var stauscode = response.status;
        if (stauscode == 200) {
          var term_names = variationsData.name;


          if (variationsData.value.includes("14592")) {
            term_names = term_names.replace('Broken screen', brokenScreensData.selected_variation_name);
            setrepairname(term_names);
          }


          var data = response.data;
          var error = data.error;
          if (error == 0) {
            if (service == 3) {
              var query_params = {
                operation: 'get_appoitment_dates',
                store: servicelocationsData.store,
                repair_availability_type: variationsData.repair_timing,
              };

              var query_string = new URLSearchParams(query_params).toString();

              axios.get(`${apiurl}&${query_string}`)
                .then(response => {
                  var stauscode = response.status;
                  if (stauscode == 200) {
                    var data = response.data;
                    var error = data.error;
                    if (error == 0) {
                      var date_slots = data.data.dates;
                      var time_slots = data.data.times;

                      setservicelocationsData((prevData) => ({
                        ...prevData,
                        show: false,
                      }))

                      var active = '';

                      date_slots.map((slot) => {
                        if (slot.active == 1) {
                          active = slot.date;
                        }
                      })


                      setcalendarapptData((prevData) => ({
                        ...prevData,
                        show: true,
                        date_slots: date_slots,
                        time_slots: time_slots,
                        date: active,
                      }))

                      setskeletonData((prevData) => ({
                        ...prevData,
                        show: false,
                      }))


                      urlParams = [];
                      urlParams['device'] = get_device_for_url();
                      urlParams['postal'] = postalData.value;
                      urlParams['complete_address'] = postalData.complete_address;
                      urlParams['repair'] = variationsData.value;
                      urlParams['repair_description'] = variationsData.description;
                      urlParams['service'] = servicelocationsData.service;
                      urlParams['store'] = servicelocationsData.store;
                      navigateHistory();

                      window.scroll(0, 0);
                    }
                  }
                })
                .catch(error => {

                })
            }
            /* if service is mail-in and price is available */
            else if (service == 2) {
              AddToCart(lead_id);
            }
            else {
              var price = data.price;
              var show_instore_price = data.show_instore_price;
              if (show_instore_price && price != 0 && price != '' && price != null) {
                setinstorepriceData((prevData) => ({
                  ...prevData,
                  state: true,
                  value: data.price
                }))
              }
              else {
                setinstorepriceData((prevData) => ({
                  ...prevData,
                  state: false,
                  value: 0
                }))
              }

              setcontactinfoData((prevData) => ({
                ...prevData,
                show: false,
              }))

              handleCarrySubmitQuoteContinue(lead_id);
            }
          }
          else {


            if (service == 1) {
              setquoteSuccessData((prevData) => ({
                ...prevData,
              }))
              handleCarrySubmitQuoteContinue(lead_id);
            }
            else {

              setquoteSuccessData((prevData) => ({
                ...prevData,
                show: true,
              }))

              setskeletonData((prevData) => ({
                ...prevData,
                show: false,
              }))
            }
          }
        }
      })
      .catch(error => {

      })
    ///////////////////
  }


  const handleSubmitOld = () => {

    const recaptchaValue = recaptchaRef.current.getValue();
    var firstName = contactinfoData.firstName.value;
    var lastName = contactinfoData.lastName.value;
    var postalCode = contactinfoData.postalCode.value;
    var phone = contactinfoData.phone.value;
    var email = contactinfoData.email.value;
    var notes = contactinfoData.notes.value;

    var new_contactinfo = {
      firstName: {
        error: 0,
        error_msg: '',
      },
      lastName: {
        error: 0,
        error_msg: '',
      },
      email: {
        error: 0,
        error_msg: '',
      },
      phone: {
        error: 0,
        error_msg: '',
      },
      postalCode: {
        error: 0,
        error_msg: '',
      },
      contactMethod: {
        error: 0,
      },
      recaptcha: {
        error: 0,
      }
    };

    var hasError = false;

    if (recaptchaValue == '' || recaptchaValue == null) {
      hasError = true;
      new_contactinfo.recaptcha.error = 1;
    }
    else {
      new_contactinfo.recaptcha.error = 0;
    }

    var haserror_firstname = hasErrorInput('firstName', firstName);

    if (!haserror_firstname) {
      new_contactinfo.firstName.error = 0;
      new_contactinfo.firstName.error_msg = '';
    }
    else {
      hasError = true;
      new_contactinfo.firstName.error = 1;
      new_contactinfo.firstName.error_msg = haserror_firstname;
    }

    var haserror_lastname = hasErrorInput('lastName', lastName);
    if (!haserror_lastname) {
      new_contactinfo.lastName.error = 0;
      new_contactinfo.lastName.error_msg = '';
    }
    else {
      hasError = true;
      new_contactinfo.lastName.error = 1;
      new_contactinfo.lastName.error_msg = haserror_lastname;
    }

    var haserror_postalCode = hasErrorInput('postalCode', postalCode);
    if (!haserror_postalCode) {
      new_contactinfo.postalCode.error = 0;
      new_contactinfo.postalCode.error_msg = '';
    }
    else {
      hasError = true;
      new_contactinfo.postalCode.error = 1;
      new_contactinfo.postalCode.error_msg = haserror_postalCode;
    }

    var haserror_phone = hasErrorInput('phone', phone);
    if (!haserror_phone) {
      new_contactinfo.phone.error = 0;
      new_contactinfo.phone.error_msg = '';
    }
    else {
      hasError = true;
      new_contactinfo.phone.error = 1;
      new_contactinfo.phone.error_msg = haserror_phone;
    }

    var haserror_email = hasErrorInput('email', email);
    if (!haserror_email) {
      new_contactinfo.email.error = 0;
      new_contactinfo.email.error_msg = '';
    }
    else {
      hasError = true;
      new_contactinfo.email.error = 1;
      new_contactinfo.email.error_msg = haserror_email;
    }


    var contact_methods = [];
    contactinfoData.contact_methods.map((option) => {
      if (option.checked) {
        contact_methods.push(option.value);
      }
    })

    if (contact_methods.length == 0) {
      hasError = true;
      new_contactinfo.contactMethod.error = 1;
    } else {
      new_contactinfo.contactMethod.error = 0;
    }

    setcontactinfoData((prevData) => ({
      ...prevData,
      firstName: {
        ...prevData.firstName,
        error: new_contactinfo.firstName.error,
        error_msg: new_contactinfo.firstName.error_msg,
      },
      lastName: {
        ...prevData.lastName,
        error: new_contactinfo.lastName.error,
        error_msg: new_contactinfo.lastName.error_msg,
      },
      postalCode: {
        ...prevData.postalCode,
        error: new_contactinfo.postalCode.error,
        error_msg: new_contactinfo.postalCode.error_msg,
      },
      phone: {
        ...prevData.phone,
        error: new_contactinfo.phone.error,
        error_msg: new_contactinfo.phone.error_msg,
      },
      email: {
        ...prevData.email,
        error: new_contactinfo.email.error,
        error_msg: new_contactinfo.email.error_msg,
      },
      contactMethod: {
        ...prevData.contactMethod,
        error: new_contactinfo.contactMethod.error,
      },
      recaptcha: {
        error: new_contactinfo.recaptcha.error,
        error_msg: 'reCAPTCHA verification failed',
      }
    }))


    if (!hasError) {


      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))

      var service = servicelocationsData.service;

      var query_params = {
        operation: 'submitquote',
        variation_id: variationsData.value,
        repairDes: variationsData.description,
        product_id: get_device_for_url(),
        service: service,
        store: servicelocationsData.store,
        postal: postalCode,
        first_name: firstName,
        last_name: lastName,
        phone: phone,
        email: email,
        notes: notes,
        contactMethod: contact_methods.join(','),
        price: instorepriceData.value,
      };


      var check_query_params = {
        operation: 'submitquote',
        device: get_device_for_url(),
        repair: variationsData.value,
        repair_description: variationsData.description,
        service: service,
        store: servicelocationsData.store,
        postal: postalCode,

      };


      const firstObjectKeys = Object.keys(check_query_params);

      const filteredKeys = Object.keys(trackingParamsData).filter(key => !firstObjectKeys.includes(key));

      const filteredSecondObject = filteredKeys.reduce((obj, key) => {
        obj[key] = trackingParamsData[key];
        return obj;
      }, {});


      const merge_query_params = { ...query_params, ...filteredSecondObject };



      /* if (service == 1) {
      query_params.date = calendarapptData.date;
      query_params.time = calendarapptData.time;
      } */



      var query_string = new URLSearchParams(merge_query_params).toString();

      axios.get(`${apiurl}&${query_string}`)
        .then(response => {
          var stauscode = response.status;
          if (stauscode == 200) {
            var data = response.data;
            var error = data.error;
            if (error == 0) {
              if (service == 1) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  'event': 'in_store_quote_requested',
                  'lead_id': data.data.quote_id,
                });
              }
              if (service == 2) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  'event': 'mail_in_quote_requested',
                  'lead_id': data.data.quote_id,
                });
              }
              if (service == 3) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  'event': 'mobile_repair_quote_requested',
                  'lead_id': data.data.quote_id,
                });
              }

              if (service == 1) {
                setquoteSuccessData((prevData) => ({
                  ...prevData,
                  data: data.data
                }))
                handleCarrySubmitQuoteContinue(data.data.quote_id);
              }
              else {
                setcontactinfoData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
                setquoteSuccessData((prevData) => ({
                  ...prevData,
                  show: true,
                  data: data.data
                }))

                setskeletonData((prevData) => ({
                  ...prevData,
                  show: false,
                }))
              }



              /* if(data.data.hasOwnProperty('cancel_booking_url')){
              window.location = data.data['cancel_booking_url'];
              return false;
              } */


            }
            else {
              var errors = data.errors;

              setskeletonData((prevData) => ({
                ...prevData,
                show: false,
              }))


              setcontactinfoData((prevData) => ({
                ...prevData,
                errors: errors,
              }))

            }
          }
        })
        .catch(error => {

        })

    }
  }


  const handlesubmitBrokenScreen = () => {
    if (brokenScreensData.isSelected) {
      var firstName = contactinfoData.firstName.value;
      var lastName = contactinfoData.lastName.value;
      var postalCode = contactinfoData.postalCode.value;
      var phone = contactinfoData.phone.value;
      var email = contactinfoData.email.value;
      var notes = contactinfoData.notes.value;

      var service = servicelocationsData.service;

      var contact_methods = [];
      contactinfoData.contact_methods.map((option) => {
        if (option.checked) {
          contact_methods.push(option.value);
        }
      })

      var query_params = {
        operation: 'submitLeadBrokenScreen',
        quote_id: quoteLeadID,
        variation_name: brokenScreensData.selected_variation_name,
        broken_variation_id: brokenScreensData.value,
        variation_id: variationsData.value,
        repairDes: variationsData.description,
        product_id: get_device_for_url(),
        service: service,
        store: servicelocationsData.store,
        postal: postalCode,
        first_name: firstName,
        last_name: lastName,
        phone: phone,
        email: email,
        notes: notes,
        contactMethod: contact_methods.join(','),
        price: instorepriceData.value,
      };


      var check_query_params = {
        device: get_device_for_url(),
        repair: variationsData.value,
        repair_description: variationsData.description,
        service: service,
        store: servicelocationsData.store,
        postal: postalCode,

      };


      const firstObjectKeys = Object.keys(check_query_params);

      const filteredKeys = Object.keys(trackingParamsData).filter(key => !firstObjectKeys.includes(key));

      const filteredSecondObject = filteredKeys.reduce((obj, key) => {
        obj[key] = trackingParamsData[key];
        return obj;
      }, {});


      const merge_query_params = { ...query_params, ...filteredSecondObject };
      var query_string = new URLSearchParams(merge_query_params).toString();


      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))

      axios.get(`${apiurl}&${query_string}`)
        .then(response => {
          setskeletonData((prevData) => ({
            ...prevData,
            show: false,
          }))
          var stauscode = response.status;
          if (stauscode == 200) {
            checkForAddToCart(quoteLeadID);
          }
        })
        .catch(error => {

        })


      /*  */

      /* var query_params = {
        operation: 'submitLeadBrokenScreen',
        quote_id: quoteLeadID,
        variation_name: brokenScreensData.selected_variation_name,
        variation_id: brokenScreensData.value,
      };
  
      var query_string = new URLSearchParams(query_params).toString();
  
      axios.get(`${apiurl}&${query_string}`)
        .then((success) => {
  
        })
        .catch((error) => {
  
        }) */



    }
  }




  const handleCarrySubmitQuoteContinue = (quote_id) => {
    window.scroll(0, 0);

    setskeletonData((prevData) => ({
      ...prevData,
      show: true,
    }))

    var query_params = {
      operation: 'get_carry_appoitment_dates',
      store: servicelocationsData.store,
      repair_availability_type: variationsData.repair_timing,
    };

    var query_string = new URLSearchParams(query_params).toString();

    axios.get(`${apiurl}&${query_string}`)
      .then(response => {
        var stauscode = response.status;
        if (stauscode == 200) {
          var data = response.data;
          var error = data.error;
          if (error == 0) {
            var date_slots = data.data.dates;
            var time_slots = data.data.times;

            setcontactinfoData((prevData) => ({
              ...prevData,
              show: false,
            }))

            var active = '';

            date_slots.map((slot) => {
              if (slot.active == 1) {
                active = slot.date;
              }
            })


            setCarrycalendarapptData((prevData) => ({
              ...prevData,
              show: true,
              quote_id: quote_id,
              date_slots: date_slots,
              time_slots: time_slots,
              date: active,
            }))

            setskeletonData((prevData) => ({
              ...prevData,
              show: false,
            }))


          }
        }
      })
      .catch(error => {

      })
  }


  const handleCarrycalendarapptContinue = () => {

    if (calendarCarryapptData.date != '' && calendarCarryapptData.time != '') {

      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))


      var query_params = {
        operation: 'submitquoteCarryin',
        quote_id: calendarCarryapptData.quote_id,
        date: calendarCarryapptData.date,
        time: calendarCarryapptData.time,
      };

      var query_string = new URLSearchParams(query_params).toString();

      axios.get(`${apiurl}&${query_string}`)
        .then(response => {
          var stauscode = response.status;
          if (stauscode == 200) {
            var data = response.data;
            var error = data.error;
            if (error == 0) {
              setCarrycalendarapptData((prevData) => ({
                ...prevData,
                show: false,
              }))
              setquoteSuccessData((prevData) => ({
                ...prevData,
                show: true,
                leadDetailsUrl: data.data['cancel_booking_url'],
                leadRescheduleUrl: data.data['reshedule_booking_url'],
                addToCalendarBtns: data.data['calendarLinks'],
              }))

              setskeletonData((prevData) => ({
                ...prevData,
                show: false,
              }))

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'in_store_appointment_booked'
              });


              urlParams = [];
              urlParams['device'] = get_device_for_url();
              urlParams['postal'] = postalData.value;
              urlParams['repair'] = variationsData.value;
              urlParams['repair_description'] = variationsData.description;
              urlParams['complete_address'] = postalData.complete_address;
              urlParams['service'] = servicelocationsData.service;
              urlParams['store'] = servicelocationsData.store;
              urlParams['date'] = calendarCarryapptData.date;
              urlParams['time'] = calendarCarryapptData.time;
              navigateHistory();

            }
            else {
              var errors = data.errors;

              setskeletonData((prevData) => ({
                ...prevData,
                show: false,
              }))


              setCarrycalendarapptData((prevData) => ({
                ...prevData,
                errors: errors,
              }))
            }
          }
        })
        .catch(error => {

        })


      var service = servicelocationsData.service;



    }
  }

  const handleReduCarrycalendarapptContinue = () => {

    if (calendarCarryapptData.date != '' && calendarCarryapptData.time != '') {

      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))


      if (calendarCarryapptData.redu) {
        var action = 'redu';
      }
      else {
        var action = 'instore';
      }
      var query_params = {
        operation: 'submitInstoreReduquoteCarryin',
        action: action,
        order_ref: calendarCarryapptData.order_ref,
        date: calendarCarryapptData.date,
        time: calendarCarryapptData.time,
      };

      var query_string = new URLSearchParams(query_params).toString();

      axios.get(`${apiurl}&${query_string}`)
        .then(response => {
          var stauscode = response.status;
          if (stauscode == 200) {
            var data = response.data;
            var error = data.error;
            if (error == 0) {
              setCarrycalendarapptData((prevData) => ({
                ...prevData,
                show: false,
              }))

              if (data.data.hasOwnProperty('price')) {
                var price = data.data['price'];
                var show_instore_price = data.data['show_instore_price'];
                if (show_instore_price && price != 0 && price != '' && price != null) {
                  setinstorepriceData((prevData) => ({
                    ...prevData,
                    state: true,
                    value: price
                  }))
                }
                else {
                  setinstorepriceData((prevData) => ({
                    ...prevData,
                    state: false,
                    value: 0
                  }))
                }
              }
              setquoteSuccessData((prevData) => ({
                ...prevData,
                show: true,
                quote_id: data.data['quote_id'],
                leadDetailsUrl: data.data['cancel_booking_url'],
                leadRescheduleUrl: data.data['reshedule_booking_url'],
                addToCalendarBtns: data.data['calendarLinks'],
                data: data.data
              }))

              setskeletonData((prevData) => ({
                ...prevData,
                show: false,
              }))

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'in_store_appointment_re_order',
                'lead_id': data.data['quote_id']
              });


              urlParams = [];
              /* urlParams['device'] = get_device_for_url();
              urlParams['postal'] = postalData.value;
              urlParams['repair'] = variationsData.value;
              urlParams['repair_description'] = variationsData.description;
              urlParams['complete_address'] = postalData.complete_address;
              urlParams['service'] = servicelocationsData.service;
              urlParams['store'] = servicelocationsData.store;
              urlParams['date'] = calendarCarryapptData.date;
              urlParams['time'] = calendarCarryapptData.time; */
              navigateHistory();

            }
            else {
              var errors = data.errors;

              setskeletonData((prevData) => ({
                ...prevData,
                show: false,
              }))


              setCarrycalendarapptData((prevData) => ({
                ...prevData,
                errors: errors,
              }))
            }
          }
        })
        .catch(error => {

        })


      var service = servicelocationsData.service;



    }
  }

  const showCancelApptPop = () => {
    setCancelAppt((prevData) => ({
      ...prevData,
      show: true
    }));
  }

  const hideCancelApptPop = () => {
    setCancelAppt((prevData) => ({
      ...prevData,
      show: false
    }));
  }


  const handleCancelCarryinAppt = () => {

    if (calendarCarryapptData.date != '' && calendarCarryapptData.time != '') {

      setskeletonData((prevData) => ({
        ...prevData,
        show: true,
      }))


      var query_params = {
        operation: 'CancelCarryin',
        quote_id: calendarCarryapptData.quote_id,
      };

      var query_string = new URLSearchParams(query_params).toString();

      axios.get(`${apiurl}&${query_string}`)
        .then(response => {
          var stauscode = response.status;
          if (stauscode == 200) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'event': 'in_store_appointment_cancelled', 'lead_id': calendarCarryapptData.quote_id });

            setTimeout(function () {
              window.location.href = quoteSuccessData.leadDetailsUrl;
            }, 500)

          }
        })
        .catch(error => {

        })
    }
  }


  const handleCarrySkip = () => {
    setCarrycalendarapptData((prevData) => ({
      ...prevData,
      show: false,
    }))
    setquoteSuccessData((prevData) => ({
      ...prevData,
      show: true,
    }))

    setskeletonData((prevData) => ({
      ...prevData,
      show: false,
    }))


    urlParams = [];
    urlParams['device'] = get_device_for_url();
    urlParams['postal'] = postalData.value;
    urlParams['repair'] = variationsData.value;
    urlParams['repair_description'] = variationsData.description;
    urlParams['complete_address'] = postalData.complete_address;
    urlParams['service'] = servicelocationsData.service;
    urlParams['store'] = servicelocationsData.store;
    urlParams['date'] = calendarCarryapptData.date;
    urlParams['time'] = calendarCarryapptData.time;
    navigateHistory();
  }

  const toggleVariationActiveClass = (variation_id, variation_slug) => {
    /* old_commmented if (variation_id == variationsData.value) {
      return 'issues_grid_item active'
    }
    else {
      return 'issues_grid_item'
    } */


    /* new_lines */
    var index = -1;

    var variation_data = variationsData.selected_data;

    variation_data.forEach((vari, idx) => {
      if (vari['variation_id'] == variation_id) {
        index = idx;
      }
    })



    var variation_names = variationsData.selected_variation_names;
    var rivalRepairs = variationsData.rivalRepairs;
    var isSelected = false;

    var cls = 'issues_grid_item ';


    if (rivalRepairs.indexOf(variation_slug) !== -1) {

      variation_names.map((vari_name) => {
        if (rivalRepairs.indexOf(vari_name) !== -1) {
          isSelected = true;
        }
      });

    }

    if (isSelected && variation_names.indexOf(variation_slug) == -1) {
      cls += 'disabled ';
    }


    if (index !== -1) {
      cls += ' active';
    }

    return cls;
    /* new_lines */
  }


  const toggleBrokenVariationActiveClass = (variation_id, variation_slug) => {
    if (variation_id == brokenScreensData.value) {
      return 'issues_grid_item active'
    }
    else {
      return 'issues_grid_item'
    }
  }

  const toggleBrokenContinueBtnClass = () => {
    if (brokenScreensData.value != '' && brokenScreensData.value != null) {
      return ''
    }
    else {
      return 'disabled'
    }
  }


  const isHomeClass = () => {
    if (ishome == 1) {
      document.body.classList.remove('steps_active');
      return '';
    }
    document.body.classList.add('steps_active');
    return '';
  }


  const enableDisableDeviceClass = () => {
    if (brandsData.value == other_product_id) {
      return '';
    }
    else {
      if (productsData.value != '') {
        return '';
      }
    }
    return 'disabled';
  }


  const enableDisablePostalClass = () => {
    if (!postalData.isSelected) {
      return 'disabled';
    }
    return '';
  }

  const enableDisableVariationClass = () => {
    if (!variationsData.isSelected) {
      return 'disabled';
    } else {
      if (variationsData.data.length == 1 && variationsData.description == '') {
        return 'disabled';
      }
      else {
        return '';
      }

    }
  }

  const deviceIcon = () => {
    if (repairicon != '') {
      return repairicon;

    }
    else if (productsData.value == other_product_id || brandsData.value == other_product_id) {
      return categoriesData.data[categoriesData.data.length - 1]['term_image'];
    }
    else {
      var term_image = '';
      for (var x in categoriesData.data) {
        if (categoriesData.data[x]['term_id'] == categoriesData.value) {
          term_image = categoriesData.data[x]['term_image'];
          break;
        }
      }
      return term_image;
    }
  }

  const changeDevice = () => {

    setcontactinfoData((prevData) => ({
      ...prevData,
      show: false,
    }))

    setservicelocationsData((prevData) => ({
      ...prevData,
      show: false,
    }))

    setcalendarapptData((prevData) => ({
      ...prevData,
      show: false,
    }))

    setvariationsData((prevData) => ({
      ...prevData,
      value: '',
      name: '',
      isSelected: false,
      show: false,
    }))

    setproductsData((prevData) => ({
      ...prevData,
      value: '',
      name: '',
      isSelected: false,
      show: false,
    }))

    setbrandsData((prevData) => ({
      ...prevData,
      value: '',
      name: '',
      isSelected: false,
      show: false,
    }))

    setdevicemodelData((prevData) => ({
      ...prevData,
      show: false,
    }))


    setpostalData((prevData) => ({
      ...prevData,
      show: false,
    }))

    setcategoriesData((prevData) => ({
      ...prevData,
      value: '',
      name: '',
      isSelected: false,
      show: true,
      nextStep: 0,
    }))

    urlParams = []
    navigateHistory();

  }

  const SelectService = (service_id) => {
    if (service_id != servicelocationsData.service) {
      var store = 0;

      if (service_id != 0 && service_id != '') {
        var services = servicelocationsData.data;
        services.forEach(item => {
          if (item.id == service_id) {
            var locations = item.locations;
            if (locations.length == 1) {
              store = locations[0]['id'];
            }
          }
        })
      }


      setservicelocationsData((prevData) => ({
        ...prevData,
        service: service_id,
        store: store,
      }))
    }
  }

  const serviceaccordianclass = (service_id) => {
    if (service_id == servicelocationsData.service) {
      return 'active';
    }
    return '';
  }

  const SelectStore = (id) => {
    var location_id = id;

    if (location_id != 0 && location_id != '') {
      var services = servicelocationsData.data;
      services.forEach(item => {
        var locations = item.locations;
        const foundLocation = locations.find(loc => loc.id == location_id);
        if (foundLocation) {
          setstore_hours(foundLocation.store_hours);
        }
      })
    }


    setservicelocationsData((prevData) => ({
      ...prevData,
      store: id,
    }))
  }

  const activeStoreClass = (id) => {
    if (id == servicelocationsData.store) {
      return 'active';
    }
    return '';
  }

  const isPreferredClass = (preferred) => {
    if (parseFloat(preferred)) {
      return 'isPreferred';
    }
    return '';
  }

  const handleMarkerLocationClick = (item, location) => {
    SelectStore(location.id);
    var location_item = document.getElementById(`location${item.id}${location.id}`);

    var header_offset = document.getElementsByClassName('ifs_page_header')[0].clientHeight;




    const offset = location_item.getBoundingClientRect().top - header_offset;



    /* location_item.scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "nearest",
    })
  
    window.scrollBy(0, -header_offset); */


    window.scrollTo({
      top: offset,
      behavior: "smooth",
    });


    /* if(location_item && LocationscontainerRef.current){
    LocationscontainerRef.current.scrollTo({
    top:location_item.offsetTop,
    behavior:'smooth'
    });
    } */
  }


  const createMarkerIcon = (locationIndex) => {

    return {
      url: 'https://maps.google.com/mapfiles/ms/icons/blue.png', // Icon URL
      size: new window.google.maps.Size(32, 32),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(16, 32),
      labelOrigin: new window.google.maps.Point(16, -10), // Adjust label position
      scaledSize: new window.google.maps.Size(32, 32), // Ensure consistent icon size
      label: {
        text: (locationIndex + 1).toString(),
        color: 'white', // Set the label color here
        fontSize: '14px', // Adjust label font size
        fontWeight: 'bold', // Set label font weight
      },
    };
  };


  return (
    <div className={isHomeClass()}>

      <header className="ifshdrRow  ifs_page_header">
        <div className="ifshdrTop">
          <div className="wrapper">
            <div className="ifshdrTopmain">
              <ul>
                <li><a className="hdlocMobNum" href="tel:(855)462-4349" aria-label="(855)462-4349"><span><svg
                  fill="#ffffff" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 50 50" width="100px"
                  height="100px">
                  <path fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round"
                    strokeMiterlimit="10" strokeWidth="2"
                    d="M35.445,3.106c-1.106,0.302-1.972,1.224-2.169,2.401l-0.304,1.822C32.812,8.293,31.978,9,31,9H19c-0.978,0-1.812-0.707-1.973-1.671l-0.304-1.822c-0.189-1.136-1.002-2.033-2.052-2.367" />
                  <path d="M28 5A1 1 0 1 0 28 7A1 1 0 1 0 28 5Z" />
                  <path fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round"
                    strokeMiterlimit="10" strokeWidth="2"
                    d="M25 6L22 6M35 47H15c-2.209 0-4-1.791-4-4V7c0-2.209 1.791-4 4-4h20c2.209 0 4 1.791 4 4v36C39 45.209 37.209 47 35 47z" />
                </svg></span> <span className="hdlocMobNumSpn">(855) 462-4349</span></a></li>
                <li><a target="_blank" href="https://ifixscreens.com/track-your-repair/" aria-label="Track Repair"><span><svg
                  fill="#ffffff" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 50 50" width="100px"
                  height="100px">
                  <path fill="none" stroke="#ffffff" strokeLinecap="round" strokeLinejoin="round"
                    strokeMiterlimit="10" strokeWidth="2"
                    d="M12 45c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H14c-1.1 0-2 .9-2 2V45zM22 43L28 43M12 9L38 9M12 40L38 40" />
                  <path
                    d="M19.04,23.496c-0.106,0-0.213,0.017-0.318,0.052l-6.035,2c-0.526,0.174-0.811,0.74-0.635,1.265c0.176,0.523,0.74,0.809,1.272,0.632l5.306-1.758l3.597,5.364c0.187,0.278,0.501,0.445,0.837,0.445c0,0,8.602-1,8.046-1l-7.508-1l-3.724-5.555C19.687,23.657,19.369,23.496,19.04,23.496z" />
                  <path
                    d="M24.576,20.628c-0.242,0.138-0.415,0.369-0.48,0.639c-0.064,0.27-0.012,0.554,0.142,0.784l1.362,2.031l-4.597,2.133c-0.504,0.233-0.721,0.829-0.486,1.329c0.236,0.5,0.835,0.714,1.337,0.483l5.657-2.625c0.266-0.123,0.465-0.355,0.543-0.637c0.08-0.28,0.031-0.582-0.132-0.824l-1.413-2.108c0,0,7.303-5.983,8.49-6.833C33.813,15.538,24.576,20.628,24.576,20.628z" />
                </svg></span> Track Repair</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="ifshdr">
          <div className="wrapper">
            <div className="ifshdrmain">
              <div className="ifsHdrRt">
                <div className="custhdr">
                  <div className="wrapper">
                    <div className="custhdrLft">
                      <div className="custnav">
                        <div className={isRespomenu ? 'custmenu isactive' : 'custmenu'}>
                          <div id="cssmenu">
                            <div id="menu-button" onClick={() => openResomenu()} className={isRespomenu ? 'menu-opened' :
                              ''}>Menu</div>
                            <ul id="menu-new-home-navigation" className={isRespomenu ? 'main-menu open' : 'main-menu'}>
                              <li id="menu-item-83492"
                                className={isDeviceMenuOPen ? 'menu-item menu-item-has-children active' : 'menu-item menu-item-has-children'}>
                                <a>Device Repair <span className="submenu-toggle" onClick={() => openDeviceSubMenu()}>menu</span></a>
                                <ul className="sub-menu">
                                  <li id="menu-item-83493"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83493">
                                    <a href="https://ifixscreens.com/smartphone-repair/iphone-repair/">iPhone
                                      Repair</a>
                                  </li>
                                  <li id="menu-item-83494"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83494">
                                    <a href="https://ifixscreens.com/smartphone-repair/samsung-repair/">Samsung
                                      Repair</a>
                                  </li>
                                  <li id="menu-item-83495"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83495">
                                    <a href="https://ifixscreens.com/smartphone-repair/google-repair/">Google
                                      Repair</a>
                                  </li>
                                  <li id="menu-item-83496"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83496">
                                    <a href="https://ifixscreens.com/smartphone-repair/">Smartphone
                                      Repair</a>
                                  </li>
                                  <li id="menu-item-83497"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83497">
                                    <a href="https://ifixscreens.com/tablets-repair/">Tablet
                                      Repair</a>
                                  </li>
                                  <li id="menu-item-83498"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83498">
                                    <a href="https://ifixscreens.com/game-console-repair/">Console
                                      Repair</a>
                                  </li>
                                  <li id="menu-item-83499"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83499">
                                    <a href="https://ifixscreens.com/drone-repairs/">Drones
                                      Repair</a>
                                  </li>
                                  <li id="menu-item-83500"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83500">
                                    <a href="https://ifixscreens.com/computer-repair/">Desktop
                                      Repair</a>
                                  </li>
                                  <li id="menu-item-83501"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83501">
                                    <a href="https://ifixscreens.com/laptop-and-mac-repair/">Laptop
                                      Repair</a>
                                  </li>
                                  <li id="menu-item-83502"
                                    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83502">
                                    <a href="https://ifixscreens.com/smartwatch-repair/">Watches
                                      Repair</a>
                                  </li>
                                </ul>
                              </li>
                              <li id="menu-item-83503"
                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83503">
                                <a href="https://ifixscreens.com/locations/">Locations</a>
                              </li>
                              <li id="menu-item-83504"
                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-home menu-item-83504">
                                <a href="https://ifixscreens.com/#business">Business</a>
                              </li>
                              <li id="menu-item-83505"
                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-83505">
                                <a href="https://ifixscreens.com/sell-your-device/">Sell
                                  your
                                  device</a>
                              </li>
                              <li><a href="https://ifixscreens.com/?s=">Search</a></li>
                              <li id="menu-item-196013"
                                className="navmenubtnstart menu-item menu-item-type-custom menu-item-object-custom current-menu-item menu-item-196013">
                                <a href="https://ifixscreens.com/start-repair/">Start Your Repair</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ifsMenu">
                  <ul>
                    <li className="active"><a>Device Repair</a>
                      <ul className="ifssubmenu">
                        <li><a href="https://ifixscreens.com/smartphone-repair/iphone-repair/"><svg
                          className="svg_icon_ifs" fill="#000000" xmlns="https://www.w3.org/2000/svg"
                          viewBox="0 0 64 64" width="128px" height="128px">
                          <path className="blue-fill"
                            d="M43,0H21c-3.866,0-7,3.134-7,7v50c0,3.866,3.134,7,7,7h22c3.866,0,7-3.134,7-7V7C50,3.134,46.866,0,43,0z M48,57c0,2.761-2.239,5-5,5H21c-2.761,0-5-2.239-5-5V7c0-2.761,2.239-5,5-5h22c2.761,0,5,2.239,5,5V57z">
                          </path>
                          <path className="red-fill"
                            d="M19 55c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1s1-.448 1-1v-2C20 55.448 19.552 55 19 55zM24 55c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1s1-.448 1-1v-2C25 55.448 24.552 55 24 55zM29 55c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1s1-.448 1-1v-2C30 55.448 29.552 55 29 55zM45 55c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1s1-.448 1-1v-2C46 55.448 45.552 55 45 55zM35 55c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1s1-.448 1-1v-2C36 55.448 35.552 55 35 55zM40 55c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1s1-.448 1-1v-2C41 55.448 40.552 55 40 55zM33 6h4c.552 0 1-.448 1-1s-.448-1-1-1h-4c-.552 0-1 .448-1 1S32.448 6 33 6zM27 6h2c.552 0 1-.448 1-1s-.448-1-1-1h-2c-.552 0-1 .448-1 1S26.448 6 27 6zM36.3 32.47c.466-.297.603-.915.306-1.381-.034-.053-.073-.103-.116-.149-2.184-2.492-5.975-2.741-8.467-.557s-2.741 5.975-.557 8.467 5.975 2.741 8.467.557c.198-.173.384-.359.557-.557.364-.415.323-1.047-.092-1.411-.028-.025-.057-.048-.088-.069-1.364-.94-1.708-2.809-.767-4.173.207-.3.467-.56.767-.767L36.3 32.47zM34.24 38.24c-.657.458-1.439.703-2.24.7-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4 .801-.003 1.583.242 2.24.7-1.652 1.886-1.652 4.704 0 6.59V38.24zM33 27.94c.266.002.521-.103.71-.29l1-1c.359-.419.31-1.051-.109-1.41-.374-.321-.927-.321-1.301 0l-1 1c-.387.394-.38 1.027.014 1.414C32.497 27.834 32.743 27.937 33 27.94z">
                          </path>
                          <path className="black-fill"
                            d="M37.228,10H26.772c-2.072,0-3.954-1.304-4.683-3.244l-2.026-5.404l1.873-0.703l2.026,5.404C24.399,7.218,25.528,8,26.772,8h10.455c1.244,0,2.373-0.782,2.81-1.947l2.026-5.404l1.873,0.703L41.91,6.756C41.182,8.696,39.3,10,37.228,10z">
                          </path>
                        </svg> <span>iPhone Repair</span></a></li>
                        <li><a href="https://ifixscreens.com/smartphone-repair/samsung-repair/"><svg
                          className="svg_icon_ifs" fill="#000000" xmlns="https://www.w3.org/2000/svg"
                          viewBox="0 0 64 64" width="128px" height="128px">
                          <path className="blue-fill"
                            d="M45,2H19c-2.757,0-5,2.243-5,5v50c0,2.757,2.243,5,5,5h26c2.757,0,5-2.243,5-5V7C50,4.243,47.757,2,45,2z M48,57c0,1.654-1.346,3-3,3H19c-1.654,0-3-1.346-3-3v-5h32V57z M48,8H37c-0.553,0-1,0.448-1,1s0.447,1,1,1h11v40H16V10h11c0.553,0,1-0.448,1-1s-0.447-1-1-1H16V7c0-1.654,1.346-3,3-3h26c1.654,0,3,1.346,3,3V8z">
                          </path>
                          <path className="red-fill"
                            d="M19 42c-.553 0-1 .448-1 1v2c0 .552.447 1 1 1s1-.448 1-1v-2C20 42.448 19.553 42 19 42zM24 42c-.553 0-1 .448-1 1v2c0 .552.447 1 1 1s1-.448 1-1v-2C25 42.448 24.553 42 24 42zM29 42c-.553 0-1 .448-1 1v2c0 .552.447 1 1 1s1-.448 1-1v-2C30 42.448 29.553 42 29 42zM45 46c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C44 45.552 44.447 46 45 46zM35 42c-.553 0-1 .448-1 1v2c0 .552.447 1 1 1s1-.448 1-1v-2C36 42.448 35.553 42 35 42zM40 46c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C39 45.552 39.447 46 40 46zM33 8h-2c-.553 0-1 .448-1 1s.447 1 1 1h2c.553 0 1-.448 1-1S33.553 8 33 8zM29 56h6c.553 0 1-.448 1-1s-.447-1-1-1h-6c-.553 0-1 .448-1 1S28.447 56 29 56z">
                          </path>
                        </svg> <span>Samsung Repair</span></a></li>
                        <li><a href="https://ifixscreens.com/smartphone-repair/google-repair/"><svg
                          className="svg_icon_ifs" fill="#000000" xmlns="https://www.w3.org/2000/svg"
                          viewBox="0 0 64 64" width="128px" height="128px">
                          <path className="red-fill"
                            d="M17 44c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1s1-.448 1-1v-2C18 44.448 17.552 44 17 44zM22 44c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1s1-.448 1-1v-2C23 44.448 22.552 44 22 44zM27 44c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1s1-.448 1-1v-2C28 44.448 27.552 44 27 44zM28 56A2 2 0 1 0 28 60 2 2 0 1 0 28 56zM33 4h-4c-.552 0-1 .448-1 1s.448 1 1 1h4c.552 0 1-.448 1-1S33.552 4 33 4zM25 4h-2c-.552 0-1 .448-1 1s.448 1 1 1h2c.552 0 1-.448 1-1S25.552 4 25 4z">
                          </path>
                          <path className="blue-fill"
                            d="M55.509,28H46v-4.442c0.81,0.52,1.886,0.375,2.545-0.369l3.065-3.46c0.368-0.416,0.547-0.971,0.49-1.523c-0.058-0.562-0.353-1.081-0.808-1.421c-1.601-1.198-3.4-2.119-5.301-2.74C45.992,14.029,46,14.016,46,14V7c0-3.86-3.14-7-7-7H17c-3.86,0-7,3.14-7,7v50c0,3.86,3.14,7,7,7h22c3.86,0,7-3.14,7-7v-8.825c7.058-2.129,11.503-8.272,11.503-16.617V30C57.503,28.897,56.608,28,55.509,28z M50.113,18.402l-3.034,3.48c-1.994-1.438-4.356-2.198-6.832-2.198c-3.72,0-7.027,1.744-9.144,4.437l-3.704-2.778c2.974-3.775,7.62-6.22,12.848-6.22C43.786,15.123,47.283,16.282,50.113,18.402z M42,36h6.015c-1.25,2.909-3.909,4.437-7.768,4.437c-5.275,0-9.566-4.206-9.566-9.376c0-5.17,4.291-9.376,9.566-9.376c1.308,0,2.577,0.258,3.753,0.751V28h-2.006C40.895,28,40,28.897,40,30v4C40,35.103,40.897,36,42,36z M29.181,34.359l-3.893,2.92C24.46,35.367,24,33.266,24,31.062c0-2.947,0.834-5.701,2.262-8.072l3.742,2.807c-0.841,1.576-1.323,3.365-1.323,5.265C28.681,32.208,28.858,33.314,29.181,34.359z M12,7c0-2.757,2.243-5,5-5h22c2.757,0,5,2.243,5,5v1H12V7z M44,57c0,2.757-2.243,5-5,5H17c-2.757,0-5-2.243-5-5v-3h32V57z M44,52H12v-4c0.552,0,1-0.448,1-1v-2c0-0.552-0.448-1-1-1V10h32v3.526c-1.232-0.256-2.489-0.403-3.753-0.403C30.186,13.123,22,21.17,22,31.062c0,6.571,3.624,12.313,9,15.437V47c0,0.552,0.448,1,1,1c0.385,0,0.708-0.224,0.875-0.543C35.132,48.442,37.623,49,40.247,49c1.308,0,2.561-0.115,3.753-0.333V52z M40.247,47c-5.979,0-11.2-3.194-14.021-7.925l3.748-2.811c1.924,3.661,5.803,6.173,10.273,6.173c2.643,0,4.862-0.633,6.575-1.839l3.518,3.015C47.744,45.776,44.292,47,40.247,47z M55.503,31.558c0,4.329-1.36,7.979-3.731,10.649l-3.456-2.962c0.944-1.077,1.644-2.409,2.061-3.99c0.079-0.3,0.015-0.62-0.175-0.865C50.014,34.144,49.721,34,49.411,34H42l-0.006-4h13.516L55.503,31.558z">
                          </path>
                        </svg> <span>Google Repair</span></a></li>
                        <li><a href="https://ifixscreens.com/smartphone-repair/"><svg fill="#000000"
                          xmlns="https://www.w3.org/2000/svg" viewBox="0 0 80 80" width="160px" height="160px">
                          <path className="path-fill-red" d="M31.946 14A1 1 0 1 0 31.946 16A1 1 0 1 0 31.946 14Z"
                            transform="rotate(-89.89 31.947 15)"></path>
                          <path className="path-stroke-blue" fill="none" stroke="#000000" strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M58 66V14c0-1.657-1.343-3-3-3H25c-1.657 0-3 1.343-3 3v52c0 1.657 1.343 3 3 3h30C56.657 69 58 67.657 58 66zM22 19L58 19">
                          </path>
                          <path className="path-stroke-red" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10" strokeWidth="2" d="M36 15L44 15"></path>
                          <path className="path-stroke-blue" fill="none" stroke="#000000" strokeMiterlimit="10"
                            strokeWidth="2" d="M58 59L22 59">
                          </path>
                          <path className="path-fill-red"
                            d="M40 62A2 2 0 1 0 40 66 2 2 0 1 0 40 62zM27 30A1 1 0 1 0 27 32 1 1 0 1 0 27 30zM27 34A1 1 0 1 0 27 36 1 1 0 1 0 27 34zM27 38A1 1 0 1 0 27 40 1 1 0 1 0 27 38zM27 42A1 1 0 1 0 27 44 1 1 0 1 0 27 42zM27 26A1 1 0 1 0 27 28 1 1 0 1 0 27 26zM27 46A1 1 0 1 0 27 48 1 1 0 1 0 27 46zM27 50A1 1 0 1 0 27 52 1 1 0 1 0 27 50zM27 54A1 1 0 1 0 27 56 1 1 0 1 0 27 54zM27 22A1 1 0 1 0 27 24 1 1 0 1 0 27 22zM16 31A1 1 0 1 0 16 33 1 1 0 1 0 16 31zM16 35A1 1 0 1 0 16 37 1 1 0 1 0 16 35zM16 39A1 1 0 1 0 16 41 1 1 0 1 0 16 39zM16 43A1 1 0 1 0 16 45 1 1 0 1 0 16 43zM16 27A1 1 0 1 0 16 29 1 1 0 1 0 16 27zM16 47A1 1 0 1 0 16 49 1 1 0 1 0 16 47zM16 51A1 1 0 1 0 16 53 1 1 0 1 0 16 51zM16 55A1 1 0 1 0 16 57 1 1 0 1 0 16 55zM16 23A1 1 0 1 0 16 25 1 1 0 1 0 16 23z">
                          </path>
                          <path className="path-stroke-blue" fill="none" stroke="#000000" strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M19 16h-5c-1.657 0-3 1.343-3 3v43c0 1.657 1.343 3 3 3h5M61 16h5c1.657 0 3 1.343 3 3v43c0 1.657-1.343 3-3 3h-5">
                          </path>
                        </svg> <span>Smartphone Repair</span></a></li>
                        <li><a href="https://ifixscreens.com/tablets-repair/"><svg className="svg_icon_ifs"
                          fill="#000000" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 64 64" width="128px"
                          height="128px">
                          <path className="blue-fill"
                            d="M51,2H13c-2.757,0-5,2.243-5,5v50c0,2.757,2.243,5,5,5h38c2.757,0,5-2.243,5-5V7C56,4.243,53.757,2,51,2z M54,57c0,1.654-1.346,3-3,3H13c-1.654,0-3-1.346-3-3V7c0-1.654,1.346-3,3-3h38c1.654,0,3,1.346,3,3V57z">
                          </path>
                          <path className="red-fill"
                            d="M50,8H14c-1.103,0-2,0.897-2,2v40c0,1.103,0.897,2,2,2h36c1.103,0,2-0.897,2-2V10C52,8.897,51.103,8,50,8z M50,50H14V10h36V50z">
                          </path>
                          <path className="black-fill"
                            d="M17 48c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C16 47.552 16.447 48 17 48zM22 48c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C21 47.552 21.447 48 22 48zM27 48c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C26 47.552 26.447 48 27 48zM32 48c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C31 47.552 31.447 48 32 48zM37 48c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C36 47.552 36.447 48 37 48zM42 48c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C41 47.552 41.447 48 42 48zM47 48c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C46 47.552 46.447 48 47 48zM32 54A2 2 0 1 0 32 58 2 2 0 1 0 32 54z">
                          </path>
                        </svg> <span>Tablet Repair</span></a></li>
                        <li><a href="https://ifixscreens.com/game-console-repair/"><svg className="svg_icon_ifs"
                          fill="#000000" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 80 80" width="160px"
                          height="160px">
                          <path className="path-1" fill="none" stroke="#000000" strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M63,34c-0.5,0-0.964,0.134-1.379,0.35c-0.273-0.372-0.6-0.699-0.971-0.971C60.866,32.964,61,32.5,61,32c0-1.657-1.343-3-3-3s-3,1.343-3,3c0,0.5,0.134,0.964,0.35,1.379c-0.372,0.273-0.699,0.6-0.971,0.971C53.964,34.134,53.5,34,53,34c-1.657,0-3,1.343-3,3s1.343,3,3,3c0.5,0,0.964-0.134,1.379-0.35c0.273,0.372,0.6,0.699,0.971,0.971C55.134,41.036,55,41.5,55,42c0,1.657,1.343,3,3,3s3-1.343,3-3c0-0.5-0.134-0.964-0.35-1.379c0.372-0.273,0.699-0.6,0.971-0.971C62.036,39.866,62.5,40,63,40c1.657,0,3-1.343,3-3S64.657,34,63,34z">
                          </path>
                          <path className="path-2" fill="none" stroke="#000000" strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M70 23c0 0-14-4-30-4s-30 4-30 4S6 49 6 56c0 6.075 4.925 11 11 11s11-4.925 11-11h24c0 6.075 4.925 11 11 11s11-4.925 11-11C74 49 70 23 70 23zM40 19L40 12">
                          </path>
                          <path className="path-3" fill="none" stroke="#000000" strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M30 35h-5v-5c0-.552-.448-1-1-1h-2c-.552 0-1 .448-1 1v5h-5c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h5v5c0 .552.448 1 1 1h2c.552 0 1-.448 1-1v-5h5c.552 0 1-.448 1-1v-2C31 35.448 30.552 35 30 35zM33 60h-3c-1.105 0-2-.895-2-2v-2h7v2C35 59.105 34.105 60 33 60zM17 21v-2c0-1.105.895-2 2-2h5c1.105 0 2 .895 2 2v1M63 21v-2c0-1.105-.895-2-2-2h-5c-1.105 0-2 .895-2 2v1M50 60h-3c-1.105 0-2-.895-2-2v-2h7v2C52 59.105 51.105 60 50 60z">
                          </path>
                          <path className="path-1"
                            d="M28 51A1 1 0 1 0 28 53 1 1 0 1 0 28 51zM32 51A1 1 0 1 0 32 53 1 1 0 1 0 32 51zM36 51A1 1 0 1 0 36 53 1 1 0 1 0 36 51zM40 51A1 1 0 1 0 40 53 1 1 0 1 0 40 51zM44 51A1 1 0 1 0 44 53 1 1 0 1 0 44 51zM48 51A1 1 0 1 0 48 53 1 1 0 1 0 48 51zM52 51A1 1 0 1 0 52 53 1 1 0 1 0 52 51zM56 51A1 1 0 1 0 56 53 1 1 0 1 0 56 51zM24 51A1 1 0 1 0 24 53 1 1 0 1 0 24 51zM63 62A1 1 0 1 0 63 64 1 1 0 1 0 63 62zM56 55A1 1 0 1 0 56 57 1 1 0 1 0 56 55zM70 55A1 1 0 1 0 70 57 1 1 0 1 0 70 55z">
                          </path>
                          <path className="path-2" d="M66.5 61.062A1 1 0 1 0 66.5 63.062A1 1 0 1 0 66.5 61.062Z"
                            transform="rotate(-30 66.496 62.065)"></path>
                          <path className="path-3" d="M56.938 58.5A1 1 0 1 0 56.938 60.5A1 1 0 1 0 56.938 58.5Z"
                            transform="rotate(-30 56.934 59.502)"></path>
                          <path className="path-1" d="M69.062 58.5A1 1 0 1 0 69.062 60.5A1 1 0 1 0 69.062 58.5Z"
                            transform="rotate(-60 69.063 59.502)"></path>
                          <path className="path-2" d="M59.5 61.062A1 1 0 1 0 59.5 63.062A1 1 0 1 0 59.5 61.062Z"
                            transform="rotate(-60 59.5 62.064)"></path>
                          <path className="path-3"
                            d="M17 62A1 1 0 1 0 17 64 1 1 0 1 0 17 62zM10 55A1 1 0 1 0 10 57 1 1 0 1 0 10 55zM24 55A1 1 0 1 0 24 57 1 1 0 1 0 24 55z">
                          </path>
                          <path className="path-1" d="M20.5 61.062A1 1 0 1 0 20.5 63.062A1 1 0 1 0 20.5 61.062Z"
                            transform="rotate(-30 20.497 62.062)"></path>
                          <path className="path-2" d="M10.938 58.5A1 1 0 1 0 10.938 60.5A1 1 0 1 0 10.938 58.5Z"
                            transform="rotate(-30 10.935 59.5)"></path>
                          <path className="path-3" d="M23.062 58.5A1 1 0 1 0 23.062 60.5A1 1 0 1 0 23.062 58.5Z"
                            transform="rotate(-60 23.062 59.502)"></path>
                          <path className="path-1" d="M13.5 61.062A1 1 0 1 0 13.5 63.062A1 1 0 1 0 13.5 61.062Z"
                            transform="rotate(-60 13.5 62.064)"></path>
                        </svg> <span>Console Repair</span></a></li>
                        <li><a href="https://ifixscreens.com/drone-repairs/"><svg className="svg_icon_ifs"
                          fill="#000000" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 100 100" width="200px"
                          height="200px">
                          <path className="path-1" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10"
                            d="M26.5 70.5L34.5 70.5M34.5 74.5L26.5 74.5M65.5 70.5L73.5 70.5M73.5 74.5L65.5 74.5">
                          </path>
                          <path className="path-2" fill="none" stroke="#000000" strokeLinejoin="round"
                            strokeMiterlimit="10" strokeWidth="2"
                            d="M81,29H19.215c-2.611,0-4.943,1.909-5.191,4.509C13.739,36.491,16.077,39,19,39h10c4.418,0,8,3.582,8,8v2c0,1.105,0.895,2,2,2h22c1.105,0,2-0.895,2-2v-2c0-4.418,3.582-8,8-8h9.785c2.611,0,4.943-1.909,5.191-4.509C86.261,31.509,83.923,29,81,29z">
                          </path>
                          <path className="path-3" fill="none" stroke="#000000" strokeMiterlimit="10"
                            d="M36.72 44.929C28.249 49.621 22.5 58.65 22.5 69v9.5c0 1.104.896 2 2 2s2-.896 2-2V69c0-8.172 4.195-15.38 10.542-19.592M62.958 49.408C69.305 53.62 73.5 60.828 73.5 69v9.5c0 1.104.896 2 2 2s2-.896 2-2V69c0-10.35-5.749-19.379-14.22-24.071">
                          </path>
                          <path className="path-1" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10"
                            d="M56.5 47.5L59.5 47.5M41.5 47.5L53.5 47.5M32.5 32.5c0 1.105-.895 2-2 2s-2-.895-2-2 0-3 0-3h4C32.5 29.5 32.5 31.971 32.5 32.5zM72.5 32.5c0 1.105-.895 2-2 2s-2-.895-2-2 0-3 0-3h4C72.5 29.5 72.5 31.971 72.5 32.5z">
                          </path>
                          <path className="path-2" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10" strokeWidth="2"
                            d="M62,85H38c-1.657,0-3-1.343-3-3V66c0-1.657,1.343-3,3-3h24c1.657,0,3,1.343,3,3v16C65,83.657,63.657,85,62,85z">
                          </path>
                          <path className="path-3" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10"
                            d="M55.99 69.5c-.423-.562-.929-1.053-1.49-1.477M52.5 66.935C51.718 66.657 50.878 66.5 50 66.5c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c3.264 0 6.034-2.089 7.064-5M57.475 74.5c.011-.166.025-.331.025-.5 0-.878-.159-1.717-.436-2.5">
                          </path>
                          <path className="path-1" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10"
                            d="M50 69.5A4.5 4.5 0 1 0 50 78.5 4.5 4.5 0 1 0 50 69.5zM57.5 62.5h-15l1.727-3.543c.441-.904 1.234-1.457 2.09-1.457h7.365c.856 0 1.65.553 2.09 1.457L57.5 62.5z">
                          </path>
                          <path className="path-2" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10" d="M48 70.5A1.5 1.5 0 1 0 48 73.5A1.5 1.5 0 1 0 48 70.5Z">
                          </path>
                          <path className="path-3" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10" strokeWidth="2"
                            d="M25 29h-6v-2c0-1.105.895-2 2-2h2c1.105 0 2 .895 2 2V29zM82 29h-6v-2c0-1.105.895-2 2-2h2c1.105 0 2 .895 2 2V29zM22 17L22 15M22 25L22 21M79 17L79 15M79 25L79 21">
                          </path>
                          <path className="path-1" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10"
                            d="M36 17.5c-.734 0-27.266 0-28 0-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5c.734 0 27.266 0 28 0 .828 0 1.5-.672 1.5-1.5S36.828 17.5 36 17.5zM93 17.5c-.734 0-27.266 0-28 0-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5c.734 0 27.266 0 28 0 .828 0 1.5-.672 1.5-1.5S93.828 17.5 93 17.5z">
                          </path>
                        </svg> <span>Drones Repair</span></a></li>
                        <li><a href="https://ifixscreens.com/computer-repair/"><svg fill="#000000"
                          xmlns="https://www.w3.org/2000/svg" viewBox="0 0 64 64" width="128px" height="128px">
                          <path className="path-fill-blue"
                            d="M59,48H5c-1.654,0-3,1.346-3,3v8c0,1.654,1.346,3,3,3h54c1.654,0,3-1.346,3-3v-8C62,49.346,60.654,48,59,48z M60,59c0,0.551-0.448,1-1,1H5c-0.552,0-1-0.449-1-1v-8c0-0.551,0.448-1,1-1h54c0.552,0,1,0.449,1,1V59z">
                          </path>
                          <path className="path-fill-blue"
                            d="M53 52c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3S54.654 52 53 52zM53 56.458c-.805 0-1.458-.654-1.458-1.458 0-.804.654-1.458 1.458-1.458s1.458.654 1.458 1.458C54.458 55.804 53.805 56.458 53 56.458zM29 54H9c-.553 0-1 .448-1 1s.447 1 1 1h20c.553 0 1-.448 1-1S29.553 54 29 54zM59 2H5C3.346 2 2 3.346 2 5v38c0 1.654 1.346 3 3 3h54c1.654 0 3-1.346 3-3V5C62 3.346 60.654 2 59 2zM60 43c0 .551-.448 1-1 1H5c-.552 0-1-.449-1-1V5c0-.551.448-1 1-1h54c.552 0 1 .449 1 1V43z">
                          </path>
                          <path className="path-fill-red"
                            d="M55 8H9C8.447 8 8 8.448 8 9v30c0 .552.447 1 1 1h46c.553 0 1-.448 1-1V9C56 8.448 55.553 8 55 8zM54 38H10V10h44V38zM37 54h-4c-.553 0-1 .448-1 1s.447 1 1 1h4c.553 0 1-.448 1-1S37.553 54 37 54z">
                          </path>
                          <path className="path-fill-red"
                            d="M17 16c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C16 15.552 16.447 16 17 16zM12 16c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C11 15.552 11.447 16 12 16zM22 16c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C21 15.552 21.447 16 22 16zM27 16c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C26 15.552 26.447 16 27 16zM32 16c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C31 15.552 31.447 16 32 16zM42 16c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C41 15.552 41.447 16 42 16zM37 16c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C36 15.552 36.447 16 37 16zM47 16c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C46 15.552 46.447 16 47 16zM52 16c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1s-1 .448-1 1v2C51 15.552 51.447 16 52 16z">
                          </path>
                        </svg> <span>Desktop Repair</span></a></li>
                        <li><a href="https://ifixscreens.com/laptop-and-mac-repair/"><svg className="svg_icon_ifs"
                          fill="#000000" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 80 80" width="160px"
                          height="160px">
                          <path className="path-1"
                            d="M36 20A1 1 0 1 0 36 22 1 1 0 1 0 36 20zM40 20A1 1 0 1 0 40 22 1 1 0 1 0 40 20zM44 20A1 1 0 1 0 44 22 1 1 0 1 0 44 20zM48 20A1 1 0 1 0 48 22 1 1 0 1 0 48 20zM52 20A1 1 0 1 0 52 22 1 1 0 1 0 52 20zM56 20A1 1 0 1 0 56 22 1 1 0 1 0 56 20zM60 20A1 1 0 1 0 60 22 1 1 0 1 0 60 20zM16 20A1 1 0 1 0 16 22 1 1 0 1 0 16 20zM20 20A1 1 0 1 0 20 22 1 1 0 1 0 20 20zM24 20A1 1 0 1 0 24 22 1 1 0 1 0 24 20zM28 20A1 1 0 1 0 28 22 1 1 0 1 0 28 20zM32 20A1 1 0 1 0 32 22 1 1 0 1 0 32 20zM64 20A1 1 0 1 0 64 22 1 1 0 1 0 64 20zM12 28A1 1 0 1 0 12 30 1 1 0 1 0 12 28zM12 32A1 1 0 1 0 12 34 1 1 0 1 0 12 32zM12 36A1 1 0 1 0 12 38 1 1 0 1 0 12 36zM12 40A1 1 0 1 0 12 42 1 1 0 1 0 12 40zM12 24A1 1 0 1 0 12 26 1 1 0 1 0 12 24zM12 44A1 1 0 1 0 12 46 1 1 0 1 0 12 44zM12 48A1 1 0 1 0 12 50 1 1 0 1 0 12 48zM12 52A1 1 0 1 0 12 54 1 1 0 1 0 12 52zM12 20A1 1 0 1 0 12 22 1 1 0 1 0 12 20zM68 28A1 1 0 1 0 68 30 1 1 0 1 0 68 28zM68 32A1 1 0 1 0 68 34 1 1 0 1 0 68 32zM68 36A1 1 0 1 0 68 38 1 1 0 1 0 68 36zM68 40A1 1 0 1 0 68 42 1 1 0 1 0 68 40zM68 24A1 1 0 1 0 68 26 1 1 0 1 0 68 24zM68 44A1 1 0 1 0 68 46 1 1 0 1 0 68 44zM68 48A1 1 0 1 0 68 50 1 1 0 1 0 68 48zM68 52A1 1 0 1 0 68 54 1 1 0 1 0 68 52zM68 20A1 1 0 1 0 68 22 1 1 0 1 0 68 20z">
                          </path>
                          <path className="path-2" fill="none" stroke="#000000" strokeMiterlimit="10"
                            strokeWidth="2"
                            d="M71 59c1.657 0 3-1.343 3-3V18c0-1.657-1.343-3-3-3H9c-1.657 0-3 1.343-3 3v38c0 1.657 1.343 3 3 3M47 59L47 59c0 1.105-.895 2-2 2H35c-1.105 0-2-.895-2-2v0H2v2c0 2.209 1.791 4 4 4h68c2.209 0 4-1.791 4-4v-2H47z">
                          </path>
                        </svg> <span>Laptop Repair</span></a></li>
                        <li><a href="https://ifixscreens.com/smartwatch-repair/"><svg className="svg_icon_ifs"
                          fill="#000000" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 80 80" width="160px"
                          height="160px">
                          <path className="path-1"
                            d="M48 55A1 1 0 1 0 48 57 1 1 0 1 0 48 55zM44 55A1 1 0 1 0 44 57 1 1 0 1 0 44 55zM40 55A1 1 0 1 0 40 57 1 1 0 1 0 40 55zM36 55A1 1 0 1 0 36 57 1 1 0 1 0 36 55zM52 55A1 1 0 1 0 52 57 1 1 0 1 0 52 55zM32 55A1 1 0 1 0 32 57 1 1 0 1 0 32 55zM28 55A1 1 0 1 0 28 57 1 1 0 1 0 28 55zM48 23A1 1 0 1 0 48 25 1 1 0 1 0 48 23zM44 23A1 1 0 1 0 44 25 1 1 0 1 0 44 23zM40 23A1 1 0 1 0 40 25 1 1 0 1 0 40 23zM36 23A1 1 0 1 0 36 25 1 1 0 1 0 36 23zM52 23A1 1 0 1 0 52 25 1 1 0 1 0 52 23zM32 23A1 1 0 1 0 32 25 1 1 0 1 0 32 23zM28 23A1 1 0 1 0 28 25 1 1 0 1 0 28 23z">
                          </path>
                          <path className="path-2" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10" strokeWidth="2"
                            d="M40 36A4 4 0 1 0 40 44 4 4 0 1 0 40 36zM51 36A3 3 0 1 0 51 42 3 3 0 1 0 51 36zM45 29A2 2 0 1 0 45 33 2 2 0 1 0 45 29zM44.5 46.5A2.5 2.5 0 1 0 44.5 51.5 2.5 2.5 0 1 0 44.5 46.5zM35 47A2 2 0 1 0 35 51 2 2 0 1 0 35 47zM35 29A2 2 0 1 0 35 33 2 2 0 1 0 35 29zM30 37A3 3 0 1 0 30 43 3 3 0 1 0 30 37z">
                          </path>
                          <path className="path-3"
                            d="M52 46A2 2 0 1 0 52 50 2 2 0 1 0 52 46zM28 30A2 2 0 1 0 28 34 2 2 0 1 0 28 30z">
                          </path>
                          <path className="path-1" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10" strokeWidth="2"
                            d="M28,61h24c3.866,0,7-3.134,7-7V26c0-3.866-3.134-7-7-7H28c-3.866,0-7,3.134-7,7v28C21,57.866,24.134,61,28,61z">
                          </path>
                          <path className="path-2" fill="none" stroke="#000000" strokeLinecap="round"
                            strokeMiterlimit="10" strokeWidth="2"
                            d="M24.2 20.093c2.783-2.087 4.984-6.638 6.067-9.216.536-1.276 1.694-2.166 3.061-2.39C34.827 8.241 37.051 8 40 8s5.173.241 6.672.487c1.366.224 2.525 1.114 3.061 2.39 1.082 2.577 3.284 7.129 6.067 9.216M55.8 59.907c-2.783 2.087-4.984 6.638-6.067 9.216-.536 1.276-1.694 2.166-3.061 2.39C45.173 71.758 42.949 72 40 72s-5.173-.242-6.672-.487c-1.366-.224-2.525-1.114-3.061-2.39-1.082-2.577-3.284-7.129-6.067-9.216">
                          </path>
                          <path className="path-3"
                            d="M59 37h1c1.105 0 2-.895 2-2v-5c0-1.105-.895-2-2-2h-1V37zM59 51h1c.552 0 1-.448 1-1v-7c0-.552-.448-1-1-1h-1V51z">
                          </path>
                        </svg> <span>Watches Repair</span></a></li>

                      </ul>
                    </li>
                    <li><a href="https://ifixscreens.com/locations/">Locations</a></li>
                    <li><a href="https://ifixscreens.com/#business">Business</a></li>
                    <li><a href="https://ifixscreens.com/sell-your-device/">Sell your device</a></li>
                    <li className="ifx_searchli">
                      <form role="search" method="get" className="search-form" action="https://ifixscreens.com/">
                        <label aria-label="Search Repairs">
                          <input type="search" className="search-field" aria-label="Search for" placeholder="Search Here…" name="s" title="Search for:" />
                        </label>
                        <input type="submit" className="search-submit" value="Search" />
                      </form>
                    </li>


                  </ul>
                  <div className="custstartYrBtn"><a href="https://ifixscreens.com/start-repair/?">Start Your
                    Repair</a></div>
                </div>
              </div>
              <div className="ifslogo"><a href="https://ifixscreens.com/start-repair">
                <img alt="ifixscreens.com" src="https://ifixscreens.com/storage/2022/06/iFixScreens_4c_logo.svg"
                  width="350" height="115" sizes="(max-width: 629px) 100vw, 629px" /></a></div>
              <div className="custIfsloaction"> <a href="https://ifixscreens.com/locations/"
                aria-label="Map locations"><svg aria-hidden="true" focusable="false" data-prefix="fas"
                  data-icon="map-marker-alt" className="svg-inline--fa fa-map-marker-alt fa-w-12" role="img"
                  xmlns="https://www.w3.org/2000/svg" viewBox="0 0 384 512" width="120px">
                  <path fill="currentColor"
                    d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" />
                </svg></a>
              </div>
              <div className="custstartYrBtn"><a href="https://ifixscreens.com/start-repair/?">Start Your
                Repair</a>
              </div>
            </div>
          </div>
        </div>
      </header>


      {/*  <LoadScript googleMapsApiKey="AIzaSyApPSf4M6TEfJr1ZJrujR6K57bkIqpHm38" libraries={libraries}> </LoadScript> */}





      {/* <Autocomplete onLoad={onLoad}>
        <input type="text" placeholder="Search for a place" style={{ boxSizing: `border-box`, border: `1px solid
          transparent`, width: `240px`, height: `32px`, padding: `0 12px`, borderRadius: `3px`, boxShadow: `0 2px 6px
          rgba(0, 0, 0, 0.3)`, fontSize: `14px`, outline: `none`, textOverflow: `ellipses`, }} />
      </Autocomplete> */}
      {/* <LoadScript googleMapsApiKey="AIzaSyApPSf4M6TEfJr1ZJrujR6K57bkIqpHm38" libraries={libraries}>
        <GoogleMap mapContainerStyle={containerStyle} center={{ lat: -34.397, lng: 150.644 }} zoom={8}>
          <Autocomplete onLoad={onLoad}>
            <input type="text" placeholder="Search for a place" style={{ boxSizing: `border-box`, border: `1px solid
              transparent`, width: `240px`, height: `32px`, padding: `0 12px`, borderRadius: `3px`, boxShadow: `0 2px
              6px rgba(0, 0, 0, 0.3)`, fontSize: `14px`, outline: `none`, textOverflow: `ellipses`, }} />
          </Autocomplete>
        </GoogleMap>
      </LoadScript> */}

      {/*
      <PlacesAutocomplete apiKey="AIzaSyAqfkBIlaMWJ9c0WM7JbTkZL8_CU5xSSxs" onSelect={handleGoogleSearch} /> */}
      <div className="steps_list_main_wrap">

        {mainSkeletonData.show && (
          <section className="main_skeleton">

            <div className="wrapper">
              <div className="skeleton left_half_skeleton_one"></div>
              <div className="skeleton left_half_skeleton_two"></div>
              <div className="skeleton left_half_skeleton_three"></div>
              <div className="skeleton left_half_skeleton_three"></div>
            </div>
          </section>
        )}

        {skeletonData.show && (
          <>
            <div className="steps_list_main skelesec">
              <div className="wrapper">
                <div className="steps_list_item_row">
                  <div className="left_half">
                    <div className="skeleton left_half_skeleton_one"></div>
                    <div className="skeleton left_half_skeleton_two"></div>
                    <div className="skeleton left_half_skeleton_three"></div>
                    <div className="skeleton left_half_skeleton_three"></div>
                  </div>
                  <div className="fixed_side_half">
                    <div className="skeleton fixed_side_half_skeleton_one"></div>
                    <div className="skeleton fixed_side_half_skeleton_two"></div>
                    <div className="skeleton fixed_side_half_skeleton_two"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="loader-wrapper active">
              <div className="loader-inner">
                <div id="loader" className="loader"></div>
              </div>
            </div>
          </>


        )}





        {categoriesData.show && (
          <section className="steps_list_main">
            <div className="wrapper">
              <div className="steps_list">
                <div className="steps_list_item first">
                  <div className="steps_list_item_hdr">
                    <h1 className="h1">Select your device to get started</h1>
                    <input type="hidden" id="hidEle" />
                    <h3 className="h3">Reliable repair for the device you depend on most</h3>
                    <p className="text">We'll price match any local competiters published price for the same
                      repair
                      and
                      beat
                      it
                      by
                      5%</p>
                  </div>


                  <div className="devices_grid">


                    {categoriesData.data.map((item, index) => (
                      item.term_name != 'Other' ? (
                        <div className="devices_grid_item" key={item.id} onClick={(event) => onChangeCategory(event,
                          item.term_id, item.term_name)} nextstep={item.next_step}>
                          <div className="image_wrap" dangerouslySetInnerHTML={{ __html: item.term_image }}></div>
                          <div className="text">{item.term_name}</div>
                        </div>) : null


                    ))}
                  </div>




                  {categoriesData.data.map((item, index) => (
                    item.term_name == 'Other' ? (
                      <div className="dont_see" key={item.id}>
                        <p><b>Don't see your device? </b><a onClick={(event) => onChangeCategory(event, item.term_id,
                          item.term_name)} nextstep={item.next_step}>Click here
                          to
                          start
                          repair
                          for a different device</a>
                        </p>
                      </div>) : null

                  ))}


                </div>
              </div>
            </div>
          </section>
        )}

        {(postalData.show && !skeletonData.show) && (
          <section className="steps_list_main locationSec">


            <div className="wrapper">
              <div className="steps_list">
                <div className="steps_list_item second">
                  <div className="steps_list_item_row">
                    <div className="left_half">
                      <div className="steps_list_item_hdr">
                        <h1 className="h1">Where are you located? </h1>
                        <h3 className="h3">We'll show you the best options based on your location.</h3>
                      </div>
                      <div className="search_form">
                        <div className="input_wrap">
                          <div className="icon">
                            <svg id="Icons" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <defs></defs>
                              <path className="cls-1"
                                d="M2,10c0,8.491,9.126,13.658,9.514,13.874a1,1,0,0,0,.972,0C12.874,23.658,22,18.491,22,10A10,10,0,0,0,2,10ZM12,2a8.009,8.009,0,0,1,8,8c0,6.274-6.2,10.68-8,11.83C10.2,20.68,4,16.274,4,10A8.009,8.009,0,0,1,12,2Z" />
                              <path className="cls-1"
                                d="M12,15a5,5,0,1,0-5-5A5.006,5.006,0,0,0,12,15Zm0-8a3,3,0,1,1-3,3A3,3,0,0,1,12,7Z" />
                            </svg>
                          </div>
                          {/* <input type="text" className="text" placeholder="Enter ZIP code, area code or city"
                          value={postalData.value} onChange={(event)=> handlePostalChange(event)} /> */}

                          {/* <Autocomplete onLoad={onLoad}>
                            <input type="text" placeholder="Enter ZIP code, area code or city" className="text"
                              value={postalData.complete_address} onChange={(event) => handlePostalChange(event)}
                              id="search_address"

                            />
                          </Autocomplete> */}

                          <APIProvider apiKey={'AIzaSyA5VK83bOt8RaypPKrNEUcbKWLvg6QT9x0'}>
                            <PlaceAutocomplete />
                          </APIProvider>






                        </div>
                      </div>
                      <div className="or_divider">
                        <span>or</span>
                      </div>
                      <div className="use_location_toggle" onClick={onUseCurrentLocation}>
                        <div className="icon">
                          <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
                            <rect fill="none" height="256" width="256" />
                            <path
                              d="M236,120H223.7A96.2,96.2,0,0,0,136,32.3V20a8,8,0,0,0-16,0V32.3A96.2,96.2,0,0,0,32.3,120H20a8,8,0,0,0,0,16H32.3A96.2,96.2,0,0,0,120,223.7V236a8,8,0,0,0,16,0V223.7A96.2,96.2,0,0,0,223.7,136H236a8,8,0,0,0,0-16Zm-40,16h11.6A80.3,80.3,0,0,1,136,207.6V196a8,8,0,0,0-16,0v11.6A80.3,80.3,0,0,1,48.4,136H60a8,8,0,0,0,0-16H48.4A80.3,80.3,0,0,1,120,48.4V60a8,8,0,0,0,16,0V48.4A80.3,80.3,0,0,1,207.6,120H196a8,8,0,0,0,0,16Z" />
                            <circle cx="128" cy="128" r="40" />
                          </svg>
                        </div>
                        <span>Use current location</span>
                      </div>
                      <div className="step_navigation">
                        <div className="step_navigation_button back stepbackone" id="back_to_select_device"
                          onClick={handlePostalBack}> Back </div>
                        <div className={`step_navigation_button continue stepcontinueone ${enableDisablePostalClass()}`}
                          id="continue_to_select_brand" onClick={handlePostalContinue}>Continue</div>
                      </div>
                    </div>
                    <div className="fixed_side_half">
                      <div className="fixed_steps_list">
                        <div className="fixed_steps_list_item active">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>
                      </div>
                      <div className="summary_wrap">
                        <h3 className="heading">Summary</h3>
                        <div className="summary_wrap_row">
                          <div className="device_selected">
                            <div className="image_wrap" dangerouslySetInnerHTML={{ __html: deviceIcon() }}></div>
                            <div className="device_selectedTextCol">
                              <div className="service_title">Device Repair</div>
                              <div className="text">{repairdevicename}</div>
                            </div>
                          </div>
                          <div className="device_other_details">
                            <div className="inner">
                              <div className="change_button" onClick={changeDevice}>Change</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="visit_details">
                        <h3 className="heading">Visit Details</h3>
                        <div className="checkbox_list visit_details_checks">
                          <div className="checkbox_list_item location">
                            <input type="checkbox" checked={isStoreSelected()} readOnly />
                            <label>Store Location</label>
                          </div>
                          <div className="checkbox_list_item date">
                            <input type="checkbox" />
                            <label>Appointment Date & Time</label>
                          </div>
                          <div className="checkbox_list_item contact">
                            <input type="checkbox" />
                            <label>Contact Details</label>
                          </div>
                        </div>
                      </div>
                      <div className="about_our_repairs">
                        <h3 className="heading">About Our Repairs</h3>
                        <div className="checkbox_list">
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label htmlFor="check4">180 day warranty</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label htmlFor="check5">Fast turnaround</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label htmlFor="check6">Free diagnostics</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label htmlFor="check7">Price match guarantee</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {(devicemodelData.show && !skeletonData.show) && (
          <section className="steps_list_main hideSidebar">
            <div className="wrapper">
              <div className="steps_list">
                <div className="steps_list_item second">
                  <div className="steps_list_item_row">
                    <div className="left_half">
                      <div className="steps_list_item_hdr">
                        {repairdevicename == 'Other' ? (<h1 className="h1">Please share more details about the device</h1>
                        ) : (<h1 className="h1">Choose Your {repairdevicename} Model </h1>)}
                      </div>


                      {brandsData.show && (
                        <div className="step_brand_wrap">
                          <select value={brandsData.value} className="brand_model_change" id="brand_change"
                            onChange={(event) => onChangeBrand(event.target.value)}>
                            <option value="">Select a brand</option>
                            {brandsData.data.map((item, index) => (
                              <option key={item.brd_term_id} value={item.brd_term_id}>{item.brd_term_name}</option>
                            ))}
                          </select>
                        </div>
                      )}


                      {productsData.show && (
                        <div className="step_brand_wrap">

                          <select value={productsData.value} className="brand_model_change" id="model_change"
                            onChange={(event) => onChangeProduct(event.target.value)}>
                            <option value="" disabled>Select a model</option>
                            {productsData.data.map((item, itindex) => (
                              <option value={item.product_id} key={item.product_id}>{item.product_name}</option>
                            ))}
                          </select>

                        </div>
                      )}

                      <div className="step_navigation">
                        <div className="step_navigation_button back stepbacktwo" id="back_to_select_location"
                          onClick={handleDeviceBack}>
                          Back </div>
                        <div className={`step_navigation_button continue stepcontinuetwo ${enableDisableDeviceClass()}`}
                          id="continue_to_select_repairs" onClick={handleDeviceContinue}>Continue</div>
                      </div>
                    </div>

                    <div className="fixed_side_half">
                      <div className="fixed_steps_list">
                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item active">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>
                      </div>
                      <div className="summary_wrap">
                        <h3 className="heading">Summary</h3>
                        <div className="summary_wrap_row">
                          <div className="device_selected">
                            <div className="image_wrap" dangerouslySetInnerHTML={{ __html: deviceIcon() }}></div>
                            <div className="device_selectedTextCol">
                              <div className="service_title">Device Repair</div>
                              <div className="text">{repairdevicename}</div>
                            </div>
                          </div>
                          <div className="device_other_details">
                            <div className="inner">
                              {/* <div className="selected_model">iPhone 14 Pro Max</div> */}
                              <div className="change_button" onClick={changeDevice}>Change</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="visit_details">
                        <h3 className="heading">Visit Details</h3>
                        <div className="checkbox_list visit_details_checks">
                          <div className="checkbox_list_item location">
                            <input type="checkbox" checked={isStoreSelected()} readOnly />
                            <label>Store Location</label>
                          </div>
                          <div className="checkbox_list_item date">
                            <input type="checkbox" />
                            <label>Appointment Date & Time</label>
                          </div>
                          <div className="checkbox_list_item contact">
                            <input type="checkbox" />
                            <label>Contact Details</label>
                          </div>
                        </div>
                      </div>
                      <div className="about_our_repairs">
                        <h3 className="heading">About Our Repairs</h3>
                        <div className="checkbox_list">
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" checked readOnly />
                            <label>180 day warranty</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Fast turnaround</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Free diagnostics</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Price match guarantee</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {(variationsData.show && !skeletonData.show) && (
          <section className="steps_list_main">
            <div className="wrapper">
              <div className="steps_list">
                <div className="steps_list_item second">
                  <div className="steps_list_item_row">
                    <div className="left_half">
                      <div className="steps_list_item_hdr">
                        {repairdevicename == 'Other device' ?
                          (
                            <h1 className="h1">What's wrong with it?</h1>
                          ) :
                          (
                            <h1 className="h1">What's wrong with it?</h1>
                          )
                        }
                      </div>

                      <div className="issues_grid" data-variation-len={variationsData.data.length}>
                        {variationsData.data.map((item, index) => (
                          <div key={item.variation_term_id} className={toggleVariationActiveClass(item.variation_term_id, item.variation_slug)}
                            onClick={() => onVariationSelect(item.variation_term_id, item.variation_slug)} >
                            <div className="image_wrap">
                              <img src={item.variation_image} alt="" />
                            </div>
                            <div className="text" dangerouslySetInnerHTML={{ __html: item.variation_name }}></div>
                          </div>
                        ))}
                      </div>
                      {variationsData.data.length == 1 ?
                        (<h2 className="repOptTitle">Please share more details about the device</h2>) : null
                      }
                      <div className="optional_issues">
                        <div className="textarea_wrap">
                          {variationsData.data.length == 1 ?
                            (<textarea name="" id="repair_notes" cols="" rows="" placeholder="Anything else we should know"
                              value={variationsData.description}
                              onChange={(event) => RepairDescriptionChange(event)}></textarea>) : (<textarea name=""
                                id="repair_notes" cols="" rows="" placeholder="Anything else we should know (optional)"
                                value={variationsData.description}
                                onChange={(event) => RepairDescriptionChange(event)}></textarea>)
                          }

                          <div className="textarea_characters_limit">{variationsData.description.length}/500</div>
                        </div>
                      </div>
                      <div className="step_navigation">
                        <div className="step_navigation_button back stepbackthree" id="back_to_select_brand"
                          onClick={handleVariationBack}>
                          Back
                        </div>
                        <div className={`step_navigation_button continue stepcontinuethree
                        ${enableDisableVariationClass()}`} id="continue_to_service_options" onClick={() =>
                            handleVariationContinue(postalData.value)}>Continue</div>
                      </div>
                    </div>
                    <div className="fixed_side_half">
                      <div className="fixed_steps_list">
                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item active">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>
                      </div>
                      <div className="summary_wrap">
                        <h3 className="heading">Summary</h3>
                        <div className="summary_wrap_row">
                          <div className="device_selected">
                            <div className="image_wrap" dangerouslySetInnerHTML={{ __html: deviceIcon() }}></div>
                            <div className="device_selectedTextCol">
                              <div className="service_title">Device Repair</div>
                              <div className="text">{repairdevicename}</div>
                            </div>
                          </div>
                          <div className="device_other_details">
                            <div className="inner">
                              {/* <div className="selected_model">iPhone 14 Pro Max</div> */}
                              <div className="change_button" onClick={changeDevice}>Change</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="visit_details">
                        <h3 className="heading">Visit Details</h3>
                        <div className="checkbox_list visit_details_checks">
                          <div className="checkbox_list_item location">
                            <input type="checkbox" checked={isStoreSelected()} readOnly />
                            <label>Store Location</label>
                          </div>
                          <div className="checkbox_list_item date">
                            <input type="checkbox" />
                            <label>Appointment Date & Time</label>
                          </div>
                          <div className="checkbox_list_item contact">
                            <input type="checkbox" />
                            <label>Contact Details</label>
                          </div>
                        </div>
                      </div>
                      <div className="about_our_repairs">
                        <h3 className="heading">About Our Repairs</h3>
                        <div className="checkbox_list">
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Fast turnaround</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Free diagnostics</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Price match guarantee</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {(servicelocationsData.show && !skeletonData.show) && (
          <section className="steps_list_main">
            <div className="wrapper">
              <div className="steps_list">
                <div className="steps_list_item second">
                  <div className="steps_list_item_row">
                    <div className="left_half">
                      <div className="steps_list_item_hdr">

                        {servicelocationsData.data.length == '1' ? (<h1 className="h1">Following service is available</h1>
                        ) : null}
                        {servicelocationsData.data.length > '1' ? (<h1 className="h1">Choose your repair options</h1>) :
                          null}

                        {onlyMailin ? (<h3 className="h3 mailininfo">iFixScreens location not found near you, but our mail-in repair service is a great alternative.</h3>) : null}



                        {/* <h3 className="h3">We get it! Things happen. But we've seen everything.</h3> */}
                      </div>
                      <div className="nearest_locations">Near {postalData.value} <div className="change_location"
                        onClick={ChangeLocation}>Change location </div>
                      </div>





                      <div className="convenience_radio_list">
                        {servicelocationsData.data.map((item, index) => (
                          <div className={`convenience_radio_list_item ${serviceaccordianclass(item.id)}`} onClick={() =>
                            SelectService(item.id)} key={item.id}>
                            <div className="text">{item.text}</div>
                          </div>
                        ))}
                        {/* <div className="convenience_radio_list_item active">
                        <div className="text">Visit an iFixScreens Store</div>
                      </div>
                      <div className="convenience_radio_list_item">
                        <div className="text">Mail In</div>
                      </div>
                      <div className="convenience_radio_list_item">
                        <div className="text">We Come To You</div>
                      </div> */}
                      </div>

                      {servicelocationsData.data.map((item, index) => (
                        <div className={`stores_wrap ${serviceaccordianclass(item.id)}`} key={item.id}>
                          <>
                            <div className="stores_near_you">
                              <div className="stores_near_you_number">
                                <b>{item.locations.length}
                                  {item.locations.length == 1 ? ' Store' : ' Stores'}
                                </b> available
                              </div>
                              <div className="map_wrap">
                                {/* <GoogleMap mapContainerStyle={mapcontainerStyle} center={{
                                  lat:
                                    parseFloat(item.locations[0]['lat']), lng: parseFloat(item.locations[0]['long'])
                                }}
                                  zoom={9}>
                                  {item.locations.map((location, locationIdx) => (


                                    <Marker key={locationIdx} position={{
                                      lat: parseFloat(location.lat), lng:
                                        parseFloat(location.long)
                                    }} onClick={() => handleMarkerLocationClick(item, location)}
                                      // icon={createMarkerIcon(parseInt(locationIdx))} //
                                      label={(locationIdx + 1).toString()}
                                    />
                                  ))}
                                </GoogleMap> */}



                                <APIProvider apiKey={'AIzaSyA5VK83bOt8RaypPKrNEUcbKWLvg6QT9x0'}>
                                  <Map
                                    mapId={"b6cf103ea03d8aba"}
                                    defaultZoom={9}
                                    defaultCenter={{
                                      lat:
                                        parseFloat(item.locations[0]['lat']), lng: parseFloat(item.locations[0]['long'])
                                    }}
                                    gestureHandling={'greedy'}
                                    disableDefaultUI={true}
                                    style={mapcontainerStyle}
                                  >

                                    <MapControl position={ControlPosition.TOP_LEFT}>
                                      {item.locations.map((location, locationIdx) => (

                                        <AdvancedMarker key={locationIdx} ref={markerRef} position={{
                                          lat: parseFloat(location.lat), lng:
                                            parseFloat(location.long)
                                        }} onClick={() => handleMarkerLocationClick(item, location)}
                                          /* icon={createMarkerIcon(parseInt(locationIdx))} */
                                          label={(locationIdx + 1).toString()}
                                          title={location.title} />
                                      ))}
                                    </MapControl>
                                  </Map>
                                </APIProvider>



                              </div>
                            </div>
                            <div className="near_stores_list" ref={LocationscontainerRef}>
                              {item.locations.map((location, locationIdx) => (
                                <div id={`location${item.id}${location.id}`} className={`near_stores_list_item
                            ${activeStoreClass(location.id)} ${isPreferredClass(location.preferred_store)}`} onClick={() => SelectStore(location.id)}
                                  key={location.id}>
                                  <div className="store_name">{location.title}</div>
                                  <div className="store_distance">2.73 miles away</div>
                                  <div className="store_address">{location.address1}</div>
                                  {/* <div className="next_date_available">Next available appointment <b>tomorrow,
                                10:00am</b>
                            </div> */}
                                </div>
                              ))}
                            </div>
                          </>


                        </div>
                      ))}



                      <div className="step_navigation">
                        <div className="step_navigation_button back stepbackfour" id="back_to_select_repairs"
                          onClick={handleservicelocationBack}>
                          Back </div>
                        <div className={`step_navigation_button continue stepcontinuefour
                        ${enableDisableLocationClass()}`} id="continue_to_quote_or_booking_slot"
                          onClick={handleservicelocationContinue}>Continue</div>
                      </div>
                    </div>
                    <div className="fixed_side_half">
                      <div className="fixed_steps_list">
                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item active">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>
                      </div>
                      <div className="summary_wrap">
                        <h3 className="heading">Summary</h3>
                        <div className="summary_wrap_row">
                          <div className="device_selected">
                            <div className="image_wrap" dangerouslySetInnerHTML={{ __html: deviceIcon() }}></div>
                            <div className="device_selectedTextCol">
                              <div className="service_title">{repairdevicename}</div>
                              <div className="text" dangerouslySetInnerHTML={{ __html: repairname }}></div>

                            </div>
                          </div>
                          <div className="device_other_details">
                            <div className="inner">
                              <div className="change_button" onClick={changeDevice}>Change</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="visit_details">
                        <h3 className="heading">Visit Details</h3>
                        <div className="checkbox_list visit_details_checks">
                          <div className="checkbox_list_item location">
                            <input type="checkbox" checked={isStoreSelected()} readOnly />
                            <label>Store Location</label>
                          </div>
                          <div className="checkbox_list_item date">
                            <input type="checkbox" />
                            <label>Appointment Date & Time</label>
                          </div>
                          <div className="checkbox_list_item contact">
                            <input type="checkbox" />
                            <label>Contact Details</label>
                          </div>
                        </div>
                      </div>
                      <div className="about_our_repairs">
                        <h3 className="heading">About Our Repairs</h3>
                        <div className="checkbox_list">
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>180 day warranty</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Free diagnostics</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Price match guarantee</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {(calendarapptData.show && !skeletonData.show) && (
          <section className="steps_list_main">
            <div className="wrapper">
              <div className="steps_list">
                <div className="steps_list_item second">
                  <div className="steps_list_item_row">
                    <div className="left_half">
                      {/* <div className="steps_list_item_hdr">
                      <div className="store_selected"><b>Ronkonkoma:</b> Closed Now but the location open
                        at
                        10:00AM tomorrow</div>
                      <h1 className="h1">When should we expect you?</h1>
                    </div> */}
                      <div className="choose_a_date">
                        <h5>Choose a date</h5>
                        <div className="dates_list">
                          {calendarapptData.date_slots.map((item, idx) => (
                            <div className={dateSlotsClass(item)} onClick={() => selectAppDate(item)} key={idx}>

                              {item.title != '' ? (
                                <>
                                  <div className="today">{item.title}</div>
                                </>) :
                                (<></>)
                              }
                              <div className="day">{item.day_name}</div>
                              <div className="date">{item.show_date}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="choose_time">
                        <h5>Choose a time slot on <b>{get_date_str_time_slot()}</b></h5>
                        {calendarapptData.time_slots.length > 0 ? (
                          <>
                            <div className="time_list">
                              {calendarapptData.time_slots.map((item, idx) => (
                                <div className={timeSlotsClass(item)} onClick={() => selectAppTime(item)} key={idx}>
                                  <div className="time">{item.format_start_time}</div>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="slotserr">No slot is available</div>
                          </>)}

                      </div>
                      <div className="step_navigation">
                        <div className="step_navigation_button back stepbackfive" id="back_to_service_options"
                          onClick={handlecalendarapptBack}>
                          Back </div>
                        <div className={`step_navigation_button continue stepcontinuefive
                        ${enableDisableCalendarClass()}`} id="continue_to_checkout"
                          onClick={handlecalendarapptContinue}>Continue</div>
                      </div>
                    </div>
                    <div className="fixed_side_half">
                      <div className="fixed_steps_list">
                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item active">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>
                      </div>
                      <div className="summary_wrap">
                        <h3 className="heading">Summary</h3>
                        <div className="summary_wrap_row">
                          <div className="device_selected">
                            <div className="image_wrap" dangerouslySetInnerHTML={{ __html: deviceIcon() }}></div>
                            <div className="device_selectedTextCol">
                              <div className="service_title">{repairdevicename}</div>
                              <div className="text" dangerouslySetInnerHTML={{ __html: repairname }}></div>

                            </div>
                          </div>
                          <div className="device_other_details">
                            <div className="inner">
                              <div className="change_button" onClick={changeDevice}>Change</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="visit_details">
                        <h3 className="heading">Visit Details</h3>
                        <div className="checkbox_list visit_details_checks">

                          <div className="checkbox_list_item location">
                            {isStoreSelected() ? (
                              <>
                                <div className="">
                                  <input type="checkbox" checked readOnly />
                                  <label>Store Location <div className="change_location" onClick={ChangeLocation}>Change
                                  </div></label>
                                </div>
                                <div className="store_location_text">
                                  {get_store_location()}
                                </div>
                                <div className="store_location_links">
                                  <a target="_blank" href={get_store_direction_link()} className="store_location_link">Get
                                    directions</a>
                                  <a target="_blank" href={`tel:${get_store_phone()}`}
                                    className="store_location_link">{get_store_phone()}</a>
                                  <a onClick={() => openStoreHours()} className="store_location_link">Store Hours</a>
                                </div>
                              </>
                            ) : (
                              <>
                                <input type="checkbox" checked={isStoreSelected()} readOnly />
                                <label>Store Location</label>
                              </>
                            )}

                          </div>
                          <div className="checkbox_list_item date">
                            <input type="checkbox" name="" id="check2" />
                            <label htmlFor="check2">Appointment Date & Time</label>
                          </div>
                          <div className="checkbox_list_item contact">
                            <input type="checkbox" name="" id="check3" />
                            <label htmlFor="check3">Contact Details</label>
                          </div>
                        </div>
                      </div>
                      <div className="about_our_repairs">
                        <h3 className="heading">About Our Repairs</h3>
                        <div className="checkbox_list">
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" id="check4" />
                            <label htmlFor="check4">180 day warranty</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" id="check5" />
                            <label htmlFor="check5">Fast turnaround</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" id="check6" />
                            <label htmlFor="check6">Free diagnostics</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" id="check7" />
                            <label htmlFor="check7">Price match guarantee</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {(contactinfoData.show && !skeletonData.show) && (
          <section className="steps_list_main">
            <div className="wrapper">
              <div className="steps_list">
                <div className="steps_list_item second">
                  <div className="steps_list_item_row">
                    <div className="left_half">



                      {/* <div className="steps_list_item_hdr">
                        {servicelocationsData.service == 3 ?
                          (<>
                            <h1 className="h1">Skip the Trip, Get Your Phone Fixed in a Zip! ️</h1>

                            <div className="mailinContIns">
                              <b>Here’s why you’ll love our mobile repair service:
                              </b>
                            </div>
                            <ul className="mailinContIns">
                              <li>Expert technicians come directly to you! No need to travel or leave your comfort zone.
                              </li>
                              <li>Schedule your appointment for a time that works for you. Choose a convenient slot without
                                disrupting your day.</li>
                              <li>Relax and enjoy the peace of mind knowing your phone is in safe hands.</li>
                              <li>Get real-time updates on the repair progress via text or call.</li>
                              <li>Pay securely online and avoid any payment hassles.</li>
                              <li>Skip the wait, skip the hassle, and skip the trip! Get your phone fixed like magic, right
                                where you are!</li>
                            </ul>


                            <h3 className="h3">Enter Your Info & We'll Zoom to You!</h3>
                          </>)
                          : null
                        }


                        {servicelocationsData.service == 2 ?
                          (<>
                            <h1 className="h1">Get Your Repair Quote in Minutes!</h1>




                            <div className="mailinContIns mailinContInsfirst">
                              <b>We’ll make it super easy for you to:</b>
                            </div>
                            <ul className="mailinContIns">
                              <li>Receive a fast, accurate quote for your device’s repair.</li>
                              <li>Book a mail-in repair hassle-free (no waiting in lines!).</li>
                              <li>Stay informed every step of the way with personalized updates.</li>
                            </ul>
                            <div className="mailinContIns">
                              <b>Plus, we’ll:</b>
                            </div>
                            <ul className="mailinContIns">
                              <li>Greet your device upon arrival and get to work ASAP!</li>
                              <li>Rest easy knowing your information is guarded like priceless treasure.</li>
                              <li>Return it to you quickly and safely, ready for action!</li>
                            </ul>

                            <h3 className="h3">Enter Your Contact Info & Let’s Get Started</h3>
                          </>)
                          : null
                        }

                        {servicelocationsData.service == 1 ?
                          (<>
                            <h1 className="h1">Enter your contact info</h1>
                            <h3 className="h3">This’ll speed up check-in when you get here.</h3>
                          </>)
                          : null
                        }

                      </div> */}


                      <div className="steps_list_item_hdr">
                        {servicelocationsData.service == 3 ?
                          (<>
                            <h1 className="h1">Enter your contact info</h1>
                            <h3 className="h3">This’ll speed up check-in when you get here.</h3>
                          </>)
                          : null
                        }


                        {servicelocationsData.service == 2 ?
                          (<>
                            <h1 className="h1">Please share your contact details</h1>
                          </>)
                          : null
                        }

                        {servicelocationsData.service == 1 ?
                          (<>
                            <h1 className="h1">Enter your contact info</h1>
                            <h3 className="h3">This’ll speed up check-in when you get here.</h3>
                          </>)
                          : null
                        }

                      </div>

                      {/* <div className="steps_list_item_hdr">
                      <h1 className="h1">Enter your contact info</h1>
                      <h3 className="h3">This’ll speed up check-in when you get here.</h3>
                    </div> */}




                      <div className="contact_form">
                        <div className="form">
                          <div className="input_row">
                            <div className="input_column">
                              <input type="text" className="input" name="firstName" placeholder="First name"
                                value={contactinfoData.firstName.value} onChange={handleContactInput} />

                              {contactinfoData.firstName.error == 1 && (
                                <>
                                  <span className="error">{contactinfoData.firstName.error_msg}</span>
                                </>
                              )}
                            </div>
                            <div className="input_column">
                              <input type="text" className="input" placeholder="Last name" name="lastName"
                                value={contactinfoData.lastName.value} onChange={handleContactInput} />


                              {contactinfoData.lastName.error == 1 && (
                                <>
                                  <span className="error">{contactinfoData.lastName.error_msg}</span>
                                </>
                              )}
                            </div>
                          </div>

                          <div className="input_row">
                            <div className="input_column">
                              <input type="text" className="input" placeholder="Zip code" name="postalCode"
                                value={contactinfoData.postalCode.value} onChange={handleContactInput} />

                              {contactinfoData.postalCode.error == 1 && (
                                <>
                                  <span className="error">{contactinfoData.postalCode.error_msg}</span>
                                </>
                              )}
                            </div>
                            <div className="input_column">
                              <input type="text" className="input" placeholder="Phone" name="phone"
                                value={contactinfoData.phone.value} onChange={handleContactInput} />

                              {contactinfoData.phone.error == 1 && (
                                <>
                                  <span className="error">{contactinfoData.phone.error_msg}</span>
                                </>
                              )}
                            </div>
                          </div>

                          <div className="input_row">
                            <div className="input_column">
                              <input type="text" className="input" placeholder="Email address" name="email"
                                value={contactinfoData.email.value} onChange={handleContactInput} />

                              {contactinfoData.email.error == 1 && (
                                <>
                                  <span className="error">{contactinfoData.email.error_msg}</span>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="input_row">
                            <div className=" input_column">
                              <textarea className="input" placeholder="Notes" name="notes"
                                value={contactinfoData.notes.value} onChange={handleContactInput}></textarea>
                            </div>
                          </div>
                          <div className="checkbox_list">
                            <h4 className="heading">Please choose your approved contact methods</h4>

                            {contactinfoData.contact_methods.map((contact_method) => (
                              <div className="checkbox_list_item" key={contact_method.id}>
                                <input id={`con${contact_method.id}`} type="checkbox" checked={contact_method.checked}
                                  onChange={() => changeContactMethod(contact_method.id)} />
                                <label htmlFor={`con${contact_method.id}`}>{contact_method.label}</label>
                              </div>
                            ))}

                            {contactinfoData.contactMethod.error == 1 && (
                              <>
                                <span className="error">{contactinfoData.contactMethod.error_msg}</span>
                              </>
                            )}


                          </div>
                          <div className="input_row">
                            <div className=" input_column">
                              <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey="6LdvZU8qAAAAAEoL5eHORjUSHfcUQdndd_JGqfS4"
                                onChange={RecaptchonChange} />

                              {contactinfoData.recaptcha.error == 1 && (
                                <>
                                  <span className="error">{contactinfoData.recaptcha.error_msg}</span>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="agree_row">
                            <p>By continuing, you agree to the <a className="termstrigger" onClick={openTermsPop}>Terms of
                              Service</a> and <a className="privacytrigger" onClick={openprivacyPopup}>Privacy
                                Policy</a>
                            </p>
                          </div>



                          {contactinfoData.errors.length > 0 ? (
                            <>
                              <div className="errorSec">
                                <ul>
                                  {contactinfoData.errors.map((error, erridx) => (
                                    <li key={erridx}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            </>) : (<></>)}













                          {/* <div className="checkbox_list">
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" id="exclusive_offers" />
                            <label htmlFor="exclusive_offers">Send me exclusive offers and free tech
                              tips.</label>
                          </div>
                        </div> */}

                        </div>
                      </div>
                      <div className="step_navigation">
                        <div className="step_navigation_button back stepbacksix" id="back_to_service_options"
                          onClick={handlecontactinfoBack}>
                          Back </div>
                        {servicelocationsData.service == 1 ? (
                          <div className="step_navigation_button continue stepcontinuesix" id="continue_to_book_now"
                            onClick={handleSubmit}>Continue</div>
                        ) : (<div className="step_navigation_button continue stepcontinuesix" id="continue_to_book_now"
                          onClick={handleSubmit}>Continue</div>)
                        }
                      </div>
                    </div>
                    <div className="fixed_side_half">
                      <div className="fixed_steps_list">
                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item active">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>
                      </div>
                      <div className="summary_wrap">
                        <h3 className="heading">Summary</h3>
                        <div className="summary_wrap_row">
                          <div className="device_selected">
                            <div className="image_wrap" dangerouslySetInnerHTML={{ __html: deviceIcon() }}></div>
                            <div className="device_selectedTextCol">
                              <div className="service_title">{repairdevicename}</div>
                              <div className="text" dangerouslySetInnerHTML={{ __html: repairname }}></div>
                            </div>
                          </div>
                          <div className="device_other_details">
                            <div className="inner">
                              {instorepriceData.state ? (<div className="price">${instorepriceData.value}</div>) : (<></>)}
                              <div className="change_button" onClick={changeDevice}>Change</div>
                            </div>
                          </div>
                        </div>
                      </div>



                      <div className="visit_details">

                        {servicelocationsData.service == 2 ? (<h3 className="heading">Mail-in Address</h3>) : (<h3 className="heading">Visit Details</h3>)}
                        <div className="checkbox_list visit_details_checks">
                          <div className="checkbox_list_item location">
                            {isStoreSelected() ? (
                              <>
                                <div className="">
                                  <input type="checkbox" checked readOnly />
                                  <label>Store Location <div className="change_location" onClick={ChangeLocation}>Change
                                  </div></label>
                                </div>
                                <div className="store_location_text">
                                  {get_store_location()}
                                </div>
                                <div className="store_location_links">
                                  <a target="_blank" href={get_store_direction_link()} className="store_location_link">Get
                                    directions</a>
                                  <a target="_blank" href={`tel:${get_store_phone()}`}
                                    className="store_location_link">{get_store_phone()}</a>
                                  <a onClick={() => openStoreHours()} className="store_location_link">Store Hours</a>
                                </div>
                              </>
                            ) : (
                              <>
                                <input type="checkbox" checked={isStoreSelected()} readOnly />
                                <label>Store Location</label>
                              </>
                            )}

                          </div>
                          <div className="checkbox_list_item contact">
                            <input type="checkbox" />
                            <label>Contact Details</label>
                          </div>
                        </div>
                      </div>
                      <div className="about_our_repairs">
                        <h3 className="heading">About Our Repairs</h3>
                        <div className="checkbox_list">
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label htmlFor="check4">180 day warranty</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label htmlFor="check5">Fast turnaround</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Free diagnostics</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" checked readOnly />
                            <label>Price match guarantee</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}



        {(calendarCarryapptData.show && !skeletonData.show) && (
          <section className="steps_list_main">
            <div className="wrapper">
              <div className="steps_list">
                <div className="steps_list_item second">
                  <div className="steps_list_item_row">
                    <div className="left_half">
                      <div className="steps_list_item_hdr">
                        <h1 className="h1">Book now and get 10% off your repair</h1>
                      </div>
                      <div className="choose_a_date">
                        <h5>Choose a date</h5>
                        <div className="dates_list">
                          {calendarCarryapptData.date_slots.map((item, idx) => (
                            <div className={dateCarrySlotsClass(item)} onClick={() => selectCarryAppDate(item)} key={idx}>

                              {item.title != '' ? (
                                <>
                                  <div className="today">{item.title}</div>
                                </>) :
                                (<></>)
                              }
                              <div className="day">{item.day_name}</div>
                              <div className="date">{item.show_date}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="choose_time">
                        <h5>Choose a time slot on <b>{get_carry_date_str_time_slot()}</b></h5>
                        {calendarCarryapptData.time_slots.length > 0 ? (
                          <>
                            <div className="time_list">
                              {calendarCarryapptData.time_slots.map((item, idx) => (
                                <div className={timeCarrySlotsClass(item)} onClick={() => selectCarryAppTime(item)} key={idx}>
                                  <div className="time">{item.format_start_time}</div>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="slotserr">No slot is available</div>
                          </>)}


                        {calendarCarryapptData.errors.length > 0 ? (<>
                          <ul>
                            {calendarCarryapptData.errors.map((erritm, erridx) => (
                              <li key={erridx}>{erritm}</li>
                            ))}
                          </ul>
                        </>) : (<></>)}


                      </div>




                      {calendarCarryapptData.redu || calendarCarryapptData.instore ? (
                        <div className="step_navigation">
                          <div className={`step_navigation_button continue stepcontinuesix
                    ${enableDisableCarryCalendarClass()}`} id="continue_to_success_screen"
                            onClick={handleReduCarrycalendarapptContinue}>Book Now</div>
                        </div>
                      )
                        :
                        (
                          <div className="step_navigation">
                            <div className="step_navigation_button back stepbackseven" id="skip_carryin_appoitment"
                              onClick={handleCarrySkip}>
                              Skip </div>
                            <div className={`step_navigation_button continue stepcontinuesix
                        ${enableDisableCarryCalendarClass()}`} id="continue_to_success_screen"
                              onClick={handleCarrycalendarapptContinue}>Book Now</div>
                          </div>
                        )
                      }
                    </div>
                    <div className="fixed_side_half">
                      <div className="fixed_steps_list">
                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item active">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>
                      </div>
                      <div className="summary_wrap">
                        <h3 className="heading">Summary</h3>
                        <div className="summary_wrap_row">
                          <div className="device_selected">
                            <div className="image_wrap" dangerouslySetInnerHTML={{ __html: deviceIcon() }}></div>
                            <div className="device_selectedTextCol">
                              <div className="service_title">{repairdevicename}</div>
                              <div className="text" dangerouslySetInnerHTML={{ __html: repairname }}></div>

                            </div>
                          </div>

                          <div className="device_other_details">
                            <div className="inner">
                              {instorepriceData.state ? (<div className="price">${instorepriceData.value}</div>) : (<></>)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="visit_details">
                        <h3 className="heading">Visit Details</h3>
                        <div className="checkbox_list visit_details_checks">

                          <div className="checkbox_list_item location">
                            {isStoreSelected() ? (
                              <>
                                <div className="">
                                  <input type="checkbox" checked readOnly />
                                  <label>Store Location </label>
                                </div>
                                <div className="store_location_text">
                                  {get_store_location()}
                                </div>
                                <div className="store_location_links">
                                  <a target="_blank" href={get_store_direction_link()} className="store_location_link">Get
                                    directions</a>
                                  <a target="_blank" href={`tel:${get_store_phone()}`}
                                    className="store_location_link">{get_store_phone()}</a>
                                  <a onClick={() => openStoreHours()} className="store_location_link">Store Hours</a>
                                </div>
                              </>
                            ) : (
                              <>
                                <input type="checkbox" checked={isStoreSelected()} readOnly />
                                <label>Store Location</label>
                              </>
                            )}

                          </div>
                          <div className="checkbox_list_item date">
                            <input type="checkbox" name="" id="check2" />
                            <label htmlFor="check2">Appointment Date & Time</label>
                          </div>
                          <div className="checkbox_list_item contact">
                            <div className="">
                              <input type="checkbox" name="" id="check3" />
                              <label htmlFor="check3">Contact Details</label>
                            </div>
                            <div className="store_location_text">
                              <p>{contactinfoData.firstName.value} {contactinfoData.lastName.value}</p>
                              <p>{contactinfoData.email.value}</p>
                              <p>{contactinfoData.phone.value}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="about_our_repairs">
                        <h3 className="heading">About Our Repairs</h3>
                        <div className="checkbox_list">
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" id="check4" />
                            <label htmlFor="check4">180 day warranty</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" id="check5" />
                            <label htmlFor="check5">Fast turnaround</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" id="check6" />
                            <label htmlFor="check6">Free diagnostics</label>
                          </div>
                          <div className="checkbox_list_item">
                            <input type="checkbox" name="" id="check7" />
                            <label htmlFor="check7">Price match guarantee</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {(brokenScreensData.show && !skeletonData.show) && (
          <div className="glass_issues_popup_main active">
            <div className="glass_issues_popup_inner">

              <h2>Please select a Broken Screen</h2>
              <div className="issues_grid" data-variation-len={brokenScreensData.data.length}>
                {brokenScreensData.data.map((item, index) => (
                  <div key={item.variation_term_id} className={toggleBrokenVariationActiveClass(item.variation_term_id, item.variation_slug)}
                    onClick={() => onBrokenVariationSelect(item.variation_term_id, item.variation_slug)} >
                    <div className="image_wrap">
                      <img src={item.variation_image} alt="" />
                    </div>
                    <div className="text" dangerouslySetInnerHTML={{ __html: item.variation_name }}></div>
                  </div>
                ))}
              </div>
              <div className="submit_wrap">
                <div className="step_navigation_button back stepbackthree" id="back_to_select_brand"
                  onClick={handleBrokenScreenBack}>Back</div>


                <button type="button" className={toggleBrokenContinueBtnClass()} onClick={() => handlesubmitBrokenScreen()}>
                  <span>Submit</span>
                </button>
              </div>
            </div>
          </div>
        )}

        {(quoteSuccessData.show && !skeletonData.show) && (
          <section className="steps_list_main">
            <div className="wrapper">
              <div className="steps_list">
                <div className="steps_list_item second">
                  <div className="steps_list_item_row">
                    <div className="left_half">

                      {calendarCarryapptData.quote_id != '' && quoteSuccessData.leadDetailsUrl != '' ? (<button
                        type="button" name="cancelAppt" className="cancel-button" onClick={() =>
                          showCancelApptPop()}>Cancel Appointment</button>) : null}
                      <div className="steps_list_item_hdr">

                        {quoteSuccessData.leadDetailsUrl != '' ? (
                          <>
                            <h1 className="h1">Your appointment has been booked!!.</h1>
                            <h3 className="h3">Life happens! Need to reschedule ? <a target="_blank"
                              href={quoteSuccessData.leadRescheduleUrl}> Click here to reschedule.</a></h3>
                          </>
                        ) : null
                        }



                        {servicelocationsData.service == 2 ? (
                          <>
                            <h1 className="h1">Your Repair Request is On Its Way! </h1>
                            <h3 className="h3">We’ve received your mail-in repair request and our tech team is eager to
                              help!
                              <div className="nextTetx">One of our expert technicians will be reaching out to you shortly
                                to:</div>
                            </h3>

                            <ul className="mailinContIns mailinContInsnomar">
                              <li>Discuss your device’s specific needs in detail.</li>
                              <li>Provide a personalized repair quote.</li>
                              <li>Answer any questions you may have.</li>
                            </ul>


                            <div className="h3">
                              <div className="nextTetx">In the meantime, here’s what you can do:</div>
                            </div>


                            <div className="box_ifscss">
                              <div className="box_ifsc">
                                <p>Review your email inbox for our technician’s message.
                                  Gather any relevant information about your device’s issue.
                                  Relax and let us handle the rest!</p>
                              </div>
                              <div className="box_ifsc">
                                <p>We’re committed to making your repair experience as seamless and stress-free as possible.
                                  Stay tuned for our expert’s call, and we’ll get your device back in tip-top shape in no
                                  time! ️</p>
                              </div>
                            </div>

                          </>
                        ) : null
                        }

                        {servicelocationsData.service != 2 && quoteSuccessData.leadDetailsUrl == '' ? (
                          <>
                            <h1 className="h1">Your request is received</h1>
                            <h3 className="h3">Our experts will contact you shortly</h3>
                          </>
                        ) : null
                        }


                        {servicelocationsData.service == 3 ?
                          (<>
                            <div className="h3">
                              <div className="nextTetx">Here’s what happens next:
                              </div>
                            </div>

                            <ul className="mailinContIns mailinContInsnomar">
                              <li>One of our friendly specialists will call you shortly to discuss your device’s specific
                                needs
                                and provide a personalized quote.</li>
                              <li>We’ll work with you to schedule a convenient appointment time that fits your busy
                                schedule.</li>
                              <li>Our skilled technician will arrive at your doorstep right on time and fix your phone like
                                magic.</li>
                              <li>You’ll enjoy real-time updates on the repair progress via text or call.</li>
                              <li>Once your phone is back in tip-top shape, you’ll pay securely online with no hassle.</li>
                              <li>In the meantime, sit back, relax, and let us handle the rest. We’re committed to making
                                your
                                mobile repair experience smooth and effortless.</li>
                            </ul>

                            <div className="h3">
                              <div className="nextTetx">P.S. Keep an eye on your phone for our specialist’s call—they’re
                                excited to help you get back to enjoying your fully functional device!
                              </div>
                            </div>
                          </>)
                          : null}

                      </div>
                      <div className="succes_banner">
                        <div className="image_wrap">
                          <img src={quoteSuccessData.data.store_image} alt="" />
                        </div>

                        {servicelocationsData.service == 2 ?
                          (<p className="need_help_text">Need help? Call the store for further instructions</p>) : null
                        }

                        <div className="action_button_list">



                          {(Object.keys(quoteSuccessData.addToCalendarBtns).length > 0) && (

                            <div className="action_button">
                              <div className="icon">
                                <svg height="24" id="svg958" version="1.1" viewBox="0 0 6.3499999 6.3500002" width="24"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <defs id="defs952"></defs>
                                  <g id="layer1">
                                    <path
                                      d="M 1.5856425,0.79421825 V 1.0577163 H 0.79277259 c -0.146148,5.819e-4 -0.264159,0.1194736 -0.263601,0.2655647 v 4.2314692 c -8.47e-4,0.1462924 0.11725,0.2654978 0.263601,0.2660812 H 5.5551606 C 5.7023194,5.821387 5.8216775,5.7018504 5.8208285,5.5547502 V 1.323281 C 5.8213845,1.1763822 5.7021165,1.0571563 5.5551606,1.0577163 h -0.79287 V 0.79421825 c -0.0046,-0.3554151 -0.533567,-0.3513831 -0.5297861,0 V 1.0577163 H 2.1149115 V 0.79421825 c 5.451e-4,-0.3536541 -0.52862,-0.3531411 -0.529269,0 z M 1.0584406,1.5867791 h 0.5272019 v 0.2660812 c 0,0.3539807 0.529269,0.3489553 0.529269,0 V 1.5867791 h 2.117593 v 0.2660812 c 0,0.3571489 0.5297861,0.3487308 0.5297861,0 V 1.5867791 h 0.529269 v 0.7951442 h -4.233119 z m 0,1.3221405 h 4.233119 V 5.291252 h -4.233119 z m 0.5272019,0.2655646 c -0.3299719,0 -0.3510829,0.5295794 0,0.5295794 h 0.529269 c 0.360394,5.557e-4 0.368686,-0.5284972 0,-0.5295794 z m 1.324723,0 c -0.352377,0.00103 -0.360659,0.530147 0,0.5295794 h 0.529269 c 0.354453,5.557e-4 0.3751231,-0.5284708 0,-0.5295794 z m 1.322139,0 c -0.347477,0.00102 -0.351613,0.5301343 0,0.5295794 h 0.5297861 c 0.3507978,0 0.3712498,-0.5284832 0,-0.5295794 z m -2.646862,1.0586421 c -0.345646,0 -0.3456439,0.529063 0,0.529063 h 0.529269 c 0.347176,9.525e-4 0.358879,-0.5282872 0,-0.529063 z m 1.324723,0 c -0.36534,0 -0.359107,0.529063 0,0.529063 h 0.529269 c 0.339507,9.525e-4 0.345395,-0.529063 0,-0.529063 z m 1.322139,0 c -0.3524811,7.673e-4 -0.3525189,0.529063 0,0.529063 h 0.5297861 c 0.3504969,9.789e-4 0.3638629,-0.5282719 0,-0.529063 z"
                                      id="path2546"></path>
                                  </g>
                                </svg>
                              </div>
                              <div className="text">Add to calender</div>
                              <ul className="apptul">

                                {Object.keys(quoteSuccessData.addToCalendarBtns).map((btnkey, index) => (

                                  <li key={btnkey}>
                                    {btnkey === 'addtogooglecal' && (
                                      <a target="_blank" href={quoteSuccessData.addToCalendarBtns[btnkey]}>Add to Google
                                        Calendar</a>
                                    )}
                                    {btnkey === 'addtoical' && (
                                      <a target="_blank" href={quoteSuccessData.addToCalendarBtns[btnkey]}>Add to iCal</a>
                                    )}
                                    {btnkey === 'addtooutlook' && (
                                      <a target="_blank" href={quoteSuccessData.addToCalendarBtns[btnkey]}>Add to Outlook
                                        Calendar</a>
                                    )}
                                  </li>

                                ))}
                              </ul>
                            </div>
                          )}
                          {/* <div className="action_button active">
                          <div className="icon">
                            <svg className="svg_icon_ifs" fill="#000000" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 80 80" width="160px" height="160px">
                              <path className="path-1"
                                d="M48 55A1 1 0 1 0 48 57 1 1 0 1 0 48 55zM44 55A1 1 0 1 0 44 57 1 1 0 1 0 44 55zM40 55A1 1 0 1 0 40 57 1 1 0 1 0 40 55zM36 55A1 1 0 1 0 36 57 1 1 0 1 0 36 55zM52 55A1 1 0 1 0 52 57 1 1 0 1 0 52 55zM32 55A1 1 0 1 0 32 57 1 1 0 1 0 32 55zM28 55A1 1 0 1 0 28 57 1 1 0 1 0 28 55zM48 23A1 1 0 1 0 48 25 1 1 0 1 0 48 23zM44 23A1 1 0 1 0 44 25 1 1 0 1 0 44 23zM40 23A1 1 0 1 0 40 25 1 1 0 1 0 40 23zM36 23A1 1 0 1 0 36 25 1 1 0 1 0 36 23zM52 23A1 1 0 1 0 52 25 1 1 0 1 0 52 23zM32 23A1 1 0 1 0 32 25 1 1 0 1 0 32 23zM28 23A1 1 0 1 0 28 25 1 1 0 1 0 28 23z">
                              </path>
                              <path className="path-2" fill="none" stroke="#000000" strokeLinecap="round"
                                strokeMiterlimit="10" strokeWidth="2"
                                d="M40 36A4 4 0 1 0 40 44 4 4 0 1 0 40 36zM51 36A3 3 0 1 0 51 42 3 3 0 1 0 51 36zM45 29A2 2 0 1 0 45 33 2 2 0 1 0 45 29zM44.5 46.5A2.5 2.5 0 1 0 44.5 51.5 2.5 2.5 0 1 0 44.5 46.5zM35 47A2 2 0 1 0 35 51 2 2 0 1 0 35 47zM35 29A2 2 0 1 0 35 33 2 2 0 1 0 35 29zM30 37A3 3 0 1 0 30 43 3 3 0 1 0 30 37z">
                              </path>
                              <path className="path-3"
                                d="M52 46A2 2 0 1 0 52 50 2 2 0 1 0 52 46zM28 30A2 2 0 1 0 28 34 2 2 0 1 0 28 30z">
                              </path>
                              <path className="path-1" fill="none" stroke="#000000" strokeLinecap="round"
                                strokeMiterlimit="10" strokeWidth="2"
                                d="M28,61h24c3.866,0,7-3.134,7-7V26c0-3.866-3.134-7-7-7H28c-3.866,0-7,3.134-7,7v28C21,57.866,24.134,61,28,61z">
                              </path>
                              <path className="path-2" fill="none" stroke="#000000" strokeLinecap="round"
                                strokeMiterlimit="10" strokeWidth="2"
                                d="M24.2 20.093c2.783-2.087 4.984-6.638 6.067-9.216.536-1.276 1.694-2.166 3.061-2.39C34.827 8.241 37.051 8 40 8s5.173.241 6.672.487c1.366.224 2.525 1.114 3.061 2.39 1.082 2.577 3.284 7.129 6.067 9.216M55.8 59.907c-2.783 2.087-4.984 6.638-6.067 9.216-.536 1.276-1.694 2.166-3.061 2.39C45.173 71.758 42.949 72 40 72s-5.173-.242-6.672-.487c-1.366-.224-2.525-1.114-3.061-2.39-1.082-2.577-3.284-7.129-6.067-9.216">
                              </path>
                              <path className="path-3"
                                d="M59 37h1c1.105 0 2-.895 2-2v-5c0-1.105-.895-2-2-2h-1V37zM59 51h1c.552 0 1-.448 1-1v-7c0-.552-.448-1-1-1h-1V51z">
                              </path>
                            </svg>
                          </div>
                          <div className="text">Add to calender</div>
                        </div> */}


                          <a target="_blank" className="action_button" href={`tel:${quoteSuccessData.data.store_phone}`}>
                            <div className="icon">
                              <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                <title />
                                <g data-name="phone celuler contact call" id="phone_celuler_contact_call">
                                  <path
                                    d="M27.36,6.15,25.09,3.88a3,3,0,0,0-4.54.35l-2.21,3a3,3,0,0,0-.44,2.66l.13.38c.27.89.62,2,.84,2.74a1,1,0,0,1-.05.7,12.44,12.44,0,0,1-2.08,3,1,1,0,0,0,0,1.42,1,1,0,0,0,1.41,0,14.14,14.14,0,0,0,2.46-3.51,2.92,2.92,0,0,0,.17-2.17c-.21-.72-.57-1.86-.85-2.75l-.12-.39A1,1,0,0,1,20,8.44l2.21-3a1,1,0,0,1,1.51-.12l.67.67-2,3.1a1,1,0,0,0,.84,1.54,1,1,0,0,0,.84-.45l1.77-2.74.16.15a2.59,2.59,0,0,1,.68,1.88c0,1.76-1.19,5-6.73,10.44-5.81,5.7-10.42,8-12.33,6.07L5.29,23.68A1,1,0,0,1,5,22.9a1,1,0,0,1,.41-.73l3-2.21a1,1,0,0,1,.88-.15l1.89.59L9.05,21.91a1,1,0,0,0-.24,1.4,1,1,0,0,0,.82.42,1,1,0,0,0,.57-.18L14,20.88a1,1,0,0,0,.25-1.4,1,1,0,0,0-.53-.36v0L9.92,17.9a3,3,0,0,0-2.66.44l-3,2.21a3,3,0,0,0-.35,4.54l2.27,2.28A4.31,4.31,0,0,0,9.3,28.63c2.52,0,6.32-1.75,12-7.32,4.84-4.75,7.31-8.74,7.33-11.86A4.46,4.46,0,0,0,27.36,6.15Z" />
                                </g>
                              </svg>
                            </div>
                            <div className="text">{quoteSuccessData.data.store_phone}</div>
                          </a>


                          {servicelocationsData.service != 2 ? (
                            <a className="action_button" target="_blank" href={quoteSuccessData.data.direction_link}>
                              <div className="icon">
                                <svg enableBackground="new 0 0 32 32" height="32px" id="Layer_1" version="1.1"
                                  viewBox="0 0 32 32" width="32px" xmlns="http://www.w3.org/2000/svg">
                                  <g>
                                    <polyline fill="none" points="   649,137.999 675,137.999 675,155.999 661,155.999  "
                                      stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"
                                      strokeWidth="2" />
                                    <polyline fill="none" points="   653,155.999 649,155.999 649,141.999  " stroke="#FFFFFF"
                                      strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" />
                                    <polyline fill="none" points="   661,156 653,162 653,156  " stroke="#FFFFFF"
                                      strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" />
                                  </g>
                                  <g>
                                    <g>
                                      <path
                                        d="M16,27c-0.23,0-0.461-0.079-0.648-0.238c-0.242-0.206-5.942-5.1-8.32-10.438c-0.225-0.504,0.002-1.096,0.507-1.32    c0.503-0.224,1.095,0.002,1.32,0.507c1.739,3.905,5.577,7.699,7.124,9.13C18.713,21.991,24,16.069,24,12.23    C24,7.692,20.411,4,16,4s-8,3.692-8,8.23c0,0.552-0.448,1-1,1s-1-0.448-1-1C6,6.589,10.486,2,16,2c5.514,0,10,4.589,10,10.23    c0,5.912-8.944,14.159-9.325,14.508C16.484,26.912,16.242,27,16,27z" />
                                    </g>
                                    <g>
                                      <path
                                        d="M16,16c-2.206,0-4-1.794-4-4s1.794-4,4-4c2.206,0,4,1.794,4,4S18.206,16,16,16z M16,10c-1.103,0-2,0.897-2,2s0.897,2,2,2    c1.103,0,2-0.897,2-2S17.103,10,16,10z" />
                                    </g>
                                    <g>
                                      <path
                                        d="M29,30H3c-0.356,0-0.686-0.189-0.865-0.498c-0.179-0.309-0.18-0.688-0.003-0.998l4-7c0.274-0.479,0.885-0.647,1.364-0.372    c0.479,0.274,0.646,0.885,0.372,1.364L4.723,28h22.553l-3.145-5.504c-0.274-0.479-0.107-1.09,0.372-1.364    c0.479-0.276,1.09-0.107,1.364,0.372l4,7c0.177,0.31,0.176,0.689-0.003,0.998C29.686,29.811,29.356,30,29,30z" />
                                    </g>
                                  </g>
                                </svg>
                              </div>
                              <div className="text">Get directions</div>
                            </a>
                          ) : null}



                          <a className="action_button" href="https://ifixscreens.com/start-repair">
                            <div className="icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 20.283c0 .934-.355 1.869-1.07 2.599-.705.721-1.649 1.118-2.658 1.118-.993 0-1.927-.387-2.629-1.089l-1.842-1.842c.241-.972.252-1.839.088-2.736l3.166 3.166c.655.656 1.8.649 2.447-.013.326-.333.501-.774.49-1.241-.01-.444-.188-.864-.504-1.179l-8.858-8.858c-.813-.812-1.23-1.938-1.143-3.087.107-1.391-.395-2.752-1.379-3.737-.758-.76-1.731-1.23-2.785-1.354l2.163 2.163c.23 1.065.137 2.147-.93 3.468-1.105 1.371-2.59 2.222-4.373 1.833l-2.162-2.162c.125 1.039.59 2.023 1.352 2.786 1.521 1.521 3.038 1.368 4.039 1.368 1.037 0 2.052.421 2.785 1.154l.471.471c-1.302-.236-2.538-.079-3.655.385-1.881.075-3.713-.625-5.053-1.966-1.519-1.52-1.96-3.282-1.96-4.806 0-1.649.518-3.018.743-3.496l4.39 4.389c.558-.044 1.328-.54 1.869-1.21.355-.44.576-.909.605-1.267l-4.388-4.39c.99-.422 2.342-.75 3.538-.75 1.802 0 3.493.699 4.765 1.969 1.396 1.399 2.111 3.332 1.959 5.304-.044.565.161 1.12.562 1.521l8.859 8.859c.732.733 1.098 1.681 1.098 2.63zm-2.842-.033c0-.507-.409-.916-.916-.916s-.917.41-.917.917.41.917.917.917c.507 0 .916-.411.916-.918zm-7.158-.75c0 2.485-2.017 4.5-4.5 4.5s-4.5-2.015-4.5-4.5 2.017-4.5 4.5-4.5 4.5 2.015 4.5 4.5zm-2-.5h-2v-2h-1v2h-2v1h2v2h1v-2h2v-1z" /></svg>
                            </div>
                            <div className="text">Book Another Repair</div>
                          </a>


                        </div>
                      </div>
                      <div className="about_our_repairs_sec">
                        <h4 className="heading">About our repairs</h4>
                        <div className="about_our_repairs_cards">
                          <div className="about_our_repairs_card">
                            <div className="icon">
                              <svg enableBackground="new 0 0 512 512" height="512px" id="Medical_x5F_checkup"
                                version="1.1" viewBox="0 0 512 512" width="512px" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                  <g>
                                    <path
                                      d="M500.519,423.154V53.34h-70.23v-0.002h-28.913c-2.255-9.218-10.563-16.088-20.466-16.088h-47.82    c-9.902,0-18.211,6.87-20.466,16.088h-28.714v0.002h-70.221v284.91h10V63.34h60.221v38.41h146.379V63.34h60.23v352.744h-48.667    v48.666H223.688v-75h-10v85h235.233L500.519,423.154z M333.089,47.25h47.82c4.316,0,8.064,2.479,9.896,6.088h-67.613    C325.024,49.729,328.772,47.25,333.089,47.25z M420.288,91.75H293.909V63.34h18.09h90h18.289V91.75z M483.446,426.084    l-31.595,31.594v-31.594H483.446z" />
                                    <rect height="10" width="80" x="316.999" y="72.544" />
                                    <path
                                      d="M419.401,123.82v23.645h-23.645v29h23.645v23.645h29v-23.645h23.645v-29h-23.645V123.82H419.401z M462.046,157.465v9    h-23.645v23.645h-9v-23.645h-23.645v-9h23.645V133.82h9v23.645H462.046z" />
                                    <rect height="10" width="60.937" x="243.352" y="440.416" />
                                    <g>
                                      <rect height="10" width="100.258" x="366.788" y="229.889" />
                                      <rect height="10" width="14.204" x="340.834" y="229.889" />
                                      <rect height="10" width="158.758" x="308.288" y="247.417" />
                                      <rect height="10" width="100.258" x="366.788" y="343.23" />
                                      <rect height="10" width="14.204" x="340.834" y="343.23" />
                                      <rect height="10" width="158.758" x="308.288" y="360.758" />
                                      <rect height="10" width="100.258" x="366.788" y="286.56" />
                                      <rect height="10" width="14.204" x="340.834" y="286.56" />
                                      <rect height="10" width="158.758" x="308.288" y="304.088" />
                                    </g>
                                    <g>
                                      <path
                                        d="M92.006,353.961v64.744c0,28.082,22.847,50.93,50.929,50.93s50.929-22.848,50.929-50.93v-9.756     c0-15.357,12.494-27.852,27.851-27.852c32.786,0,59.459-26.673,59.459-59.459v-91.75h-10.89v-19.071     c16.392-2.426,29.012-16.586,29.012-33.642c0-18.754-15.258-34.012-34.012-34.012s-34.012,15.258-34.012,34.012     c0,17.056,12.62,31.216,29.012,33.642v19.071h-10.718v91.75c0,15.357-12.494,27.852-27.852,27.852     c-32.785,0-59.458,26.674-59.458,59.459v9.756c0,10.654-8.668,19.321-19.321,19.321s-19.321-8.667-19.321-19.321v-64.744     c46.213-7.631,80.524-47.721,80.524-95.025v-86.759h-11.046V112.77h-18.084c-1.014-10.551-5.329-16.91-11.771-16.91     c-12.081,0-21.91,9.829-21.91,21.91s9.829,21.911,21.91,21.911c2.538,0,7.204-1.112,9.945-8.557     c0.873-2.374,1.482-5.245,1.802-8.354h8.107v49.407H172.53v86.759c0,35.687-29.033,64.72-64.721,64.72     s-64.721-29.033-64.721-64.72V218.75h-10v40.186c0,41.2,33.52,74.72,74.721,74.72s74.721-33.52,74.721-74.72v-76.759h11.607     v76.759c0,43.73-32.722,80.582-76.112,85.721l-4.412,0.521v73.527c0,16.168,13.153,29.321,29.321,29.321     s29.321-13.153,29.321-29.321v-9.756c0-27.271,22.187-49.459,49.458-49.459c20.871,0,37.852-16.979,37.852-37.852v-81.75h11.607     v81.75c0,27.272-22.188,49.459-49.459,49.459c-20.871,0-37.851,16.98-37.851,37.852v9.756c0,22.568-18.36,40.93-40.929,40.93     s-40.929-18.361-40.929-40.93v-73.527l-4.412-0.521c-43.391-5.139-76.112-41.99-76.112-85.721v-76.759h11.607v24.011h10v-34.011     H32.131V122.77h8.083c1.014,10.551,5.329,16.911,11.771,16.911c12.081,0,21.91-9.829,21.91-21.911s-9.829-21.91-21.91-21.91     c-2.538,0-7.204,1.112-9.945,8.557c-0.874,2.374-1.482,5.244-1.802,8.353H22.131v59.407H11.481v86.759     C11.481,306.24,45.793,346.33,92.006,353.961z M241.271,177.176c0-13.24,10.771-24.012,24.012-24.012     s24.012,10.771,24.012,24.012s-10.771,24.012-24.012,24.012S241.271,190.417,241.271,177.176z M162.79,129.672     c-6.36-0.236-11.463-5.485-11.463-11.902s5.103-11.666,11.463-11.902c0.949,1.101,2.451,5.27,2.451,11.902     C165.241,124.402,163.739,128.571,162.79,129.672z M52.432,105.868c6.36,0.236,11.463,5.484,11.463,11.902     s-5.103,11.666-11.463,11.902c-0.949-1.101-2.451-5.27-2.451-11.902C49.98,111.138,51.482,106.968,52.432,105.868z" />
                                      <path
                                        d="M282.014,177.176c0-9.225-7.505-16.73-16.73-16.73s-16.73,7.505-16.73,16.73s7.505,16.73,16.73,16.73     S282.014,186.401,282.014,177.176z M258.553,177.176c0-3.711,3.02-6.73,6.73-6.73s6.73,3.019,6.73,6.73s-3.02,6.73-6.73,6.73     S258.553,180.888,258.553,177.176z" />
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </div>
                            <div className="name">Free diagnostics</div>
                            <div className="desc">
                              <p>We'll figure out what's wrong so we fix it the first time.</p>
                            </div>
                          </div>
                          <div className="about_our_repairs_card">
                            <div className="icon">
                              <svg enableBackground="new 0 0 100 100" id="Layer_1" version="1.1" viewBox="0 0 100 100"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M66.958,54.602c-1.821-1.821-4.786-1.821-6.608,0l-0.066,0.066l-1.298-1.298l12.849-12.848  c6.649,2.043,13.76,0.297,18.692-4.635c4.337-4.337,6.27-10.528,5.17-16.56c-0.067-0.366-0.331-0.665-0.686-0.775  c-0.354-0.111-0.741-0.015-1.005,0.248l-8.954,8.953l-11.038-1.767l-1.767-11.038L81.2,5.994c0.263-0.263,0.358-0.65,0.248-1.005  s-0.409-0.619-0.775-0.686c-6.031-1.098-12.223,0.833-16.56,5.17c-4.932,4.932-6.679,12.042-4.635,18.692L46.63,41.015  L19.821,14.206c-0.101-0.101-0.223-0.179-0.356-0.229l-6.717-2.516c-0.368-0.137-0.781-0.048-1.058,0.229  c-0.277,0.277-0.367,0.691-0.229,1.058l2.516,6.717c0.05,0.134,0.128,0.255,0.229,0.356L41.015,46.63L28.166,59.478  c-6.65-2.044-13.761-0.296-18.692,4.635c-4.338,4.337-6.271,10.528-5.171,16.56c0.067,0.366,0.331,0.665,0.686,0.775  c0.355,0.112,0.742,0.016,1.005-0.248l8.954-8.953l11.038,1.767l1.767,11.038L18.8,94.006c-0.263,0.263-0.358,0.65-0.248,1.005  s0.409,0.619,0.775,0.686C20.442,95.9,21.563,96,22.676,96c4.909,0,9.676-1.938,13.211-5.474c4.932-4.931,6.679-12.042,4.635-18.692  L53.37,58.985l1.298,1.298l-0.066,0.066c-1.822,1.822-1.822,4.786,0,6.608L78.84,91.195c0.906,0.906,2.096,1.358,3.288,1.358  c1.197,0,2.396-0.457,3.309-1.37l5.748-5.748c1.822-1.822,1.827-4.781,0.011-6.596L66.958,54.602z M63.693,73.221l1.941-1.941  l8.877,8.877l-1.941,1.941L63.693,73.221z M71.806,62.28l-2.647,2.647l-4.232,4.232l-2.647,2.647l-2.818-2.818l9.526-9.526  L71.806,62.28z M69.866,67.048l8.877,8.877l-2.818,2.818l-8.877-8.877L69.866,67.048z M73.985,83.511l2.647-2.647l4.232-4.232  l2.647-2.647l2.818,2.818l-9.526,9.526L73.985,83.511z M80.157,74.511l-8.877-8.877l1.941-1.941l8.877,8.878L80.157,74.511z   M61.326,29.147c0.27-0.27,0.363-0.67,0.239-1.032c-2.091-6.091-0.573-12.692,3.962-17.228c3.4-3.399,8.075-5.144,12.808-4.856  l-7.863,7.863c-0.227,0.227-0.331,0.548-0.28,0.865l1.962,12.257c0.068,0.426,0.403,0.761,0.829,0.829l12.257,1.962  c0.316,0.051,0.638-0.054,0.865-0.28l7.863-7.863c0.289,4.734-1.457,9.409-4.856,12.808c-4.535,4.536-11.136,6.054-17.228,3.962  c-0.363-0.126-0.763-0.032-1.032,0.239L57.571,51.956l-2.822-2.822l10.246-10.246c0.519-0.518,0.804-1.208,0.804-1.942  s-0.286-1.424-0.803-1.942c-1.036-1.036-2.849-1.036-3.884,0L50.866,45.25l-2.822-2.822L61.326,29.147z M52.28,46.665l10.247-10.246  c0.28-0.281,0.774-0.282,1.055,0c0.141,0.14,0.218,0.328,0.218,0.527s-0.077,0.387-0.218,0.527c0,0,0,0,0,0L53.335,47.72  L52.28,46.665z M38.674,70.853c-0.27,0.27-0.363,0.67-0.239,1.032c2.091,6.091,0.573,12.692-3.962,17.227  c-3.399,3.399-8.069,5.146-12.808,4.857l7.863-7.863c0.227-0.227,0.331-0.548,0.28-0.865l-1.962-12.257  c-0.068-0.426-0.403-0.761-0.829-0.829L14.76,70.192c-0.317-0.053-0.639,0.053-0.865,0.28l-7.863,7.863  c-0.289-4.734,1.457-9.409,4.857-12.808c4.536-4.535,11.138-6.052,17.227-3.962c0.361,0.123,0.761,0.031,1.032-0.239l13.282-13.282  l2.822,2.822L35.004,61.111c-0.518,0.518-0.804,1.208-0.804,1.942s0.286,1.424,0.803,1.942c0.518,0.518,1.208,0.804,1.942,0.804  s1.424-0.286,1.942-0.804L49.134,54.75l2.822,2.822L38.674,70.853z M47.72,53.335L37.474,63.582c-0.28,0.281-0.774,0.282-1.055,0  c-0.141-0.14-0.218-0.328-0.218-0.527s0.077-0.387,0.218-0.528L46.665,52.28L47.72,53.335z M54.077,56.864l-4.236-4.236l-2.47-2.47  l-4.236-4.236L15.773,18.561l-1.669-4.456l4.456,1.669l27.362,27.362l4.236,4.236l2.47,2.47l4.236,4.236l2.005,2.005l-2.787,2.787  L54.077,56.864z M56.016,61.764l0.773-0.773l4.201-4.201l0.773-0.773c0.521-0.521,1.206-0.781,1.89-0.781  c0.685,0,1.369,0.26,1.89,0.781l2.031,2.031l-9.528,9.528l-2.031-2.031C54.974,64.502,54.974,62.806,56.016,61.764z M89.77,84.022  l-5.748,5.748c-0.505,0.505-1.175,0.784-1.887,0.786c-0.708,0.007-1.379-0.273-1.881-0.775l-2.037-2.037l9.527-9.527l2.037,2.037  c0.502,0.502,0.777,1.17,0.775,1.881C90.554,82.847,90.275,83.517,89.77,84.022z" />
                              </svg>
                            </div>
                            <div className="name">Fast repairs</div>
                            <div className="desc">
                              <p>We'll let you know how long it should take at your appointment.
                              </p>
                            </div>
                          </div>
                          <div className="about_our_repairs_card">
                            <div className="icon">
                              <svg id="Layer_1" version="1.1" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                  <path
                                    d="M174,175.3c0.8,0.3,2.1,0.7,3.6,0.6c2.4-0.1,4.6-1.1,6.2-2.7c1.8-1.8,2.7-4.2,2.7-6.7c-0.2-15.1,9.4-28.3,23.7-32.8   c1-0.3,2-0.8,2.9-1.5c2-1.5,3.3-3.7,3.6-6c0.4-2.5-0.2-5-1.7-7.1c-9-12.1-9.1-28.4-0.1-40.5l1.1-1.4l0.5-1.5c0.8-2.4,0.5-5-0.6-7   c-1.1-2.3-3.1-4-5.5-4.7c-14.3-4.6-23.9-17.7-23.7-32.7c0-1.2-0.2-2.2-0.5-3.2c-0.8-2.3-2.5-4.2-4.8-5.4c-2.2-1-4.7-1.2-7-0.4   c-3.5,1.2-7.2,1.8-10.9,1.8c-11,0-21.4-5.3-27.7-14.3c-0.7-0.9-1.5-1.7-2.2-2.2c-4.2-3-10-2-13,2.2c-6.4,9-16.7,14.3-27.7,14.3   c-3.8,0-7.4-0.6-10.8-1.8c-3.2-1.1-7.3-0.3-9.7,2.2c-1.8,1.8-2.7,4.2-2.7,6.6c0.2,15.1-9.4,28.3-23.7,32.7c-1.1,0.3-2,0.8-3,1.5   c-4.1,3.1-4.9,8.9-1.9,13.1c9,12.1,9,28.4,0,40.6c-0.6,0.8-1.1,1.8-1.4,2.7c-0.7,2.4-0.5,4.8,0.6,7.2c1.2,2.2,3.2,3.8,5.4,4.5   c14.4,4.6,23.9,17.8,23.7,32.6c-0.1,1.2,0.1,2.3,0.5,3.4c0.8,2.3,2.5,4.2,4.8,5.4c2.3,1,4.7,1.2,7,0.4c3.6-1.2,7.4-1.8,11.1-1.8   c11.1,0,21.1,5.2,27.6,14.3c0.6,0.8,1.4,1.6,2.2,2.2c1.6,1.1,3.5,1.7,5.4,1.7c0.5,0,1.1,0,1.6-0.1c2.5-0.4,4.6-1.8,6-3.8   C144.3,175.6,159.7,170.5,174,175.3z M127.9,181.7c-8.2-11.3-21.3-18-35.2-18c-4.6,0-9.3,0.7-13.6,2.2c0-19-12.1-35.7-30-41.4   c11.2-15.4,11.2-35.9,0.1-51.3c18-5.9,30-22.4,30.1-41.4c4.3,1.4,8.8,2.1,13.4,2.1c13.9,0,27.1-6.7,35.3-17.9   c8.2,11.2,21.4,17.9,35.4,17.9c4.7,0,9.3-0.7,13.4-2.2c0,18.8,11.9,35.3,29.9,41.4c-11.1,15.4-11.1,35.8,0,51.3   c-18,5.9-29.9,22.4-30,41.4C158.6,160,139.2,166.3,127.9,181.7z" />
                                  <path
                                    d="M168.4,92.1c-15.3-6.4-27.3-18.3-33.8-33.6c-1.1-2.7-3.8-4.5-6.7-4.5c-2.9,0-5.6,1.8-6.7,4.4   c-6.5,15.2-18.4,27.1-33.6,33.6c-2.7,1.1-4.5,3.7-4.5,6.6c0,2.9,1.7,5.5,4.4,6.7c14.7,6.4,26.9,18.8,33.6,34   c1.2,2.7,3.8,4.4,6.6,4.4c0,0,0,0,0,0c2.9,0,5.5-1.7,6.6-4.4c6.4-14.8,18.8-27.1,34.1-33.9c2.6-1.2,4.3-3.8,4.3-6.7   C172.8,95.8,171.1,93.2,168.4,92.1z M127.8,130.6c-7.2-13.6-18.3-24.8-31.5-31.9c13.6-7,24.6-17.9,31.6-31.5   c7,13.7,18.1,24.7,31.8,31.6C146,106.1,134.8,117.3,127.8,130.6z" />
                                  <path
                                    d="M98.6,188.8c-2.3-1.5-5.3-0.8-6.8,1.4l-26.2,40.1l-13.1-26.9l-27.3-0.1l27.4-42c1.5-2.3,0.8-5.3-1.4-6.8   c-2.3-1.5-5.3-0.8-6.8,1.4L7.1,213.1l39.3,0.1l18,36.9l35.6-54.5C101.5,193.3,100.9,190.2,98.6,188.8z" />
                                  <path
                                    d="M211.5,155.9c-1.5-2.3-4.5-2.9-6.8-1.4c-2.3,1.5-2.9,4.5-1.4,6.8l27.5,42l-27.4,0.1l-13.1,26.9l-26.2-40.1   c-1.5-2.3-4.5-2.9-6.8-1.4c-2.3,1.5-2.9,4.5-1.4,6.8l35.7,54.5l18-36.9l39.3-0.1L211.5,155.9z" />
                                </g>
                              </svg>
                            </div>
                            <div className="name">180 Day Warranty</div>
                            <div className="desc">
                              <p>Our highly-trained experts stand behind their repairs</p>
                            </div>
                          </div>

                          <div className="about_our_repairs_card">
                            <div className="icon">
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1_2)">
                                  <path fillRule="evenodd" clipRule="evenodd" d="M35.3167 11.6667H40V36.6667H5V28.3333H0.316666V3.33334H35.3167V11.6667ZM38.3333 13.3333H6.66667V35H38.3333V13.3333ZM22.5 15C27.56 15 31.6667 19.1067 31.6667 24.1667C31.6667 29.2267 27.56 33.3333 22.5 33.3333C17.44 33.3333 13.3333 29.2267 13.3333 24.1667C13.3333 19.1067 17.44 15 22.5 15ZM22.5 16.6667C26.64 16.6667 30 20.0267 30 24.1667C30 28.3067 26.64 31.6667 22.5 31.6667C18.36 31.6667 15 28.3067 15 24.1667C15 20.0267 18.36 16.6667 22.5 16.6667ZM23.3333 30H21.6667V28.66C20.3883 28.3933 19.2033 27.5117 19.2033 25.82H20.9067C20.9067 26.805 21.45 27.2967 22.5367 27.2967C23.8983 27.2967 24.7483 25.7717 22.2583 24.8983C20.9783 24.4483 19.4583 23.7717 19.4583 22.0767C19.4583 20.75 20.4133 19.915 21.6667 19.6633V18.3333H23.3333V19.6767C24.5067 19.945 25.5217 20.7983 25.5217 22.34H23.825C23.825 21.0267 22.6133 21.0467 22.4667 21.0467C21.55 21.0467 21.155 21.5317 21.155 22.0833C21.155 22.495 21.3783 22.9117 22.75 23.3633C24.51 23.9367 25.5217 24.7717 25.5217 26.2733C25.5217 27.3583 24.895 28.42 23.3333 28.6867V30ZM33.65 11.6667V5H1.98333V26.6667H5V11.6667H33.65Z" fill="black" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1_2">
                                    <rect width="40" height="40" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>

                            </div>
                            <div className="name">Most Affordable Repairs</div>
                            <div className="desc">
                              <p>Get the best price for OEM quality parts</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="h3"><div className="nextTetx22"><a href="https://ifixscreens.com/start-repair/">Get a Quote</a></div></div>
                      <div className="h3"><div className="nextTetx22">Have questions? Read our <a href="https://ifixscreens.com/about-us/faq/">FAQs</a></div></div>
                    </div>
                    <div className="fixed_side_half">
                      <div className="fixed_steps_list">
                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>
                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item activechecked">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>

                        <div className="fixed_steps_list_item active">
                          <div className="circle">
                            <div className="circle_fill"></div>
                          </div>
                        </div>
                      </div>
                      <div className="summary_wrap">
                        <h3 className="heading">Summary</h3>
                        <div className="summary_wrap_row">
                          <div className="device_selected">
                            <div className="image_wrap" dangerouslySetInnerHTML={{ __html: deviceIcon() }}></div>
                            <div className="device_selectedTextCol">
                              <div className="service_title">{repairdevicename}</div>
                              <div className="text" dangerouslySetInnerHTML={{ __html: repairname }}></div>

                            </div>
                          </div>
                          <div className="device_other_details">
                            <div className="inner">
                              {instorepriceData.state ? (<div className="price">${instorepriceData.value}</div>) : (<></>)}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="visit_details">
                        <h3 className="heading">Service</h3>
                        {servicelocationsData.service == 1 ? <p>Carry In / Curbside Service</p> : null}
                        {servicelocationsData.service == 2 ? <p>Mail-In Repair</p> : null}
                        {servicelocationsData.service == 3 ? <p>Mobile Repair</p> : null}
                      </div>
                      {/* <div className="pricing_details">
                      <h3 className="heading">Pricing Details</h3>
                      <div className="pricing">
                        <div className="label">Due Now
                          <div className="help_text">No payment until after the repair. We'll diagnose
                            it
                            for free, then go through your options with you.</div>
                        </div>
                        <div className="value">$ 0.00</div>
                      </div>
                    </div> */}
                      <div className="visit_details">
                        <h3 className="heading">Visit Details</h3>
                        <div className="checkbox_list visit_details_checks">
                          <div className="checkbox_list_item location">
                            {isStoreSelected() ? (
                              <>
                                <div className="">
                                  <input type="checkbox" checked readOnly />
                                  <label>Store Location </label>
                                </div>
                                <div className="store_location_text">
                                  {get_store_location()}
                                </div>
                                <div className="store_location_links">
                                  <a target="_blank" href={get_store_direction_link()} className="store_location_link">Get
                                    directions</a>
                                  <a target="_blank" href={`tel:${get_store_phone()}`}
                                    className="store_location_link">{get_store_phone()}</a>
                                  <a onClick={() => openStoreHours()} className="store_location_link">Store Hours</a>
                                </div>
                              </>
                            ) : (
                              <>
                                <input type="checkbox" checked={isStoreSelected()} readOnly />
                                <label>Store Location</label>
                              </>
                            )}

                          </div>
                          {quoteSuccessData.leadDetailsUrl != '' && (
                            <div className="checkbox_list_item date">

                              <div className="">
                                <input type="checkbox" name="" id="check2" />
                                <label>Appointment Date & Time</label>
                              </div>
                              <div className="store_location_text">
                                <p>{formatDate(calendarCarryapptData.date)}</p>
                                <p>{formatTimeRange(calendarCarryapptData.time)}</p>
                              </div>
                            </div>
                          )}
                          <div className="checkbox_list_item contact">

                            <div className="">
                              <input type="checkbox" checked readOnly />
                              <label>Contact Details</label>
                            </div>
                            <div className="store_location_text">
                              <p>{contactinfoData.firstName.value} {contactinfoData.lastName.value}</p>
                              <p>{contactinfoData.email.value}</p>
                              <p>{contactinfoData.phone.value}</p>
                            </div>

                          </div>
                        </div>
                      </div>
                      {/* <div className="need_to_schedule">
                      <h3 className="heading">Need To Re-schedule</h3>
                      <div className="desc">
                        <p>We get it! No need to cancel- just walk in anytime if you still need
                          help.
                        </p>
                      </div>
                    </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}


        {(cancelApptData.show) && (
          <div className="reschedule-popup active">
            <div className="popup-inner">
              <div className="popup-close" onClick={() => hideCancelApptPop()}><span></span></div>
              <h2>Would you like to re-schedule?</h2>
              <div className="reschedule-actions">

                {quoteSuccessData.leadDetailsUrl != '' ? (
                  <>
                    <a href={quoteSuccessData.leadRescheduleUrl} className="reschedule-action">
                      <span>Reschedule</span>
                    </a>
                  </>
                ) : null
                }

                <a onClick={() => handleCancelCarryinAppt()} className="reschedule-action">
                  <span>Cancel Booking</span>
                </a>
              </div>
            </div>
          </div>
        )}


      </div>

      {isStoreSelected() && Object.keys(store_hours).length > 0 && (
        <div className={storePopupToggleClass()}>
          <div className="inner">
            <div className="store-hours-popup-header">
              <h3>Store Hours</h3>
              <div className="close" onClick={() => closeStoreHours()}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd"
                    d="M5.70718 4.29297L19.7072 18.293L18.293 19.7072L4.29297 5.70718L5.70718 4.29297Z" fill="black">
                  </path>
                  <path fillRule="evenodd" clipRule="evenodd"
                    d="M19.7072 5.70718L5.70718 19.7072L4.29297 18.293L18.293 4.29297L19.7072 5.70718Z" fill="black">
                  </path>
                </svg>
              </div>
            </div>


            <div className="hours-list">
              <ul>
                {Object.keys(store_hours).map((btnkey, index) => (
                  <li key={index}>
                    <span className="day">{btnkey}</span>
                    {!store_hours[btnkey].close ? (
                      <span
                        className="time">{formatTime(store_hours[btnkey].start)}-{formatTime(store_hours[btnkey].end)}</span>
                    ) : <span className="closedHour">Closed</span>
                    }

                  </li>
                ))}

              </ul>
            </div>
            <div className="close-bottom">
              <a onClick={() => closeStoreHours()}>close</a>
            </div>
          </div>
        </div>
      )}



      {isprivacyPopupOpen() && (
        <div className="terms-popupmain active">
          <div className="terms-popupoverlay"></div>
          <div className="terms-popupinner">
            <div className="close" onClick={closeprivacyPopup}>
              <svg clip-rule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" />
              </svg>
            </div>
            <div className="scrollinner">
              <div className="repair-terms-and-conditions2">
                <div className="wrapper">
                  <div className="inner">
                    <p><i>Modified on January 1, 2023</i><br /><a href="https://ifixscreens.com/" target="_blank"
                      className="">iFixScreens.com</a>, or the terms "us", "we", or
                      "our" refer to the owner of this website and provider of the services. The term "you"
                      refers to the user or viewer of this website or any of the services provided by
                      iFixScreens.com. This page sets forth our policies regarding the collection, use, and
                      disclosure of personal information that we receive from you. In order for our sites,
                      products, and services (collectively "services") to function properly, it is necessary
                      for us to collect and use certain personal information. We desire for you to understand
                      what personal information we collect and how it is utilized. This notice does not cover,
                      and we are not responsible for, third-party websites or applications that may be linked
                      from our services; linking to them does not imply an endorsement. We are not responsible
                      for these websites or applications or any information they may collect. It is advisable
                      for you to review the privacy notice of any third-party website or application that
                      collects your personal information.</p>
                    <p><br /></p>
                    <h2 className="align-left">Personal Information We Collect</h2>
                    <p>While using our services or visiting any of our stores, we may request that you provide
                      us with certain Personal Information. For purposes of this Agreement, "Personal
                      Information" shall refer to information that is linked or linkable to you, including,
                      but not limited to, the enumerated data depending upon which of our services you choose
                      to use.</p>
                    <ol className="">
                      <li><strong>online </strong>By visiting our websites or using our mobile
                        applications, the user consents to the collection and use of the user's Internet
                        Protocol address/location, any information provided by the user's internet
                        browser or mobile device, and any information that is entered while visiting our
                        websites or using our mobile applications, in accordance with this Privacy
                        Notice. The definitions of any terms utilized in this Privacy Notice shall be
                        the same as those provided in the Terms and Conditions.<br /><br /></li>
                      <li><b>Log Information</b><br />iFixScreens.com automatically collects and stores
                        certain data in its server logs concerning the utilization of its services,
                        including the number of distinct visitors, the frequency of visits, how users
                        interact with its services, user experience preferences, and other information
                        which may help with improving the user experience, marketing its products,
                        combating fraudulent activities, and fulfilling legal requirements. Such
                        information may comprise personal data, such as IP address, Unique Device
                        Identifier, web page content, transactions with APIs (Application Program
                        Interface), transactions with IVR (Interactive Voice Response) systems, activity
                        and content of visitor interaction with call center representatives, application
                        usage activity, hardware information, hardware and system settings, browser
                        type, browser language, the date and time of the request, or referral URL.
                        Additionally, search queries may be saved and data later used to identify which
                        pages on the website receive the most attention from
                        customers.<br /><br /><b>Cookies, Pixel Tags, and Using a Third-Party
                          Account</b><br />IFixScreens.com and its Partners utilize Cookies or similar
                        technologies on our Websites to analyze trends, administer the Site, track
                        Users' movements around the Site, tailor and deliver advertising that may be
                        more relevant or interesting to Users, and to gather demographic information
                        about our User base as a whole.<br /><br /><b>Cookies</b><br />Upon visiting
                        iFixScreens.com, a small data file (known as a "cookie") is managed by a web
                        browser or other application and stored on the user's local system. We use
                        session and persistent cookies to, among other things, identify the user's
                        device during a particular interaction and analyze their behavior during a
                        particular visit. Most web browsers offer the user the ability to accept or
                        decline cookies, as well as to be advised each time a cookie is being sent. If
                        the user chooses to decline cookies, they may not be able to fully utilize our
                        services. Additionally, we engage in tracking processes that may not identify
                        the user specifically, but rather the device they are using; users may opt out
                        of this type of tracking by toggling off certain cookies or other similar
                        technologies, by navigating to the “Do Not Sell My Personal Information” link on
                        our homepage and toggling off “Targeting Cookies” in the iFixScreens.com Privacy
                        Preference Center, or by blocking and deleting cookies or similar technologies
                        in their browser. However, please note that if the user does decide to block
                        cookies or similar tracking technologies, some parts of our sites may not
                        function correctly.<br /><br /><b>Pixel Tags</b><br />Pixel Tags, also known as Web
                        Beacons, are utilized to better manage user experience and content tracking.
                        These Tags are used to engage users who have searched for, viewed, and/or
                        purchased services or similar services offered by either ourselves, an affiliate
                        organization, or a non-affiliated company. Pixel Tags are tiny graphics with a
                        unique identifier, which perform a similar role to that of Cookies; they are
                        used to track user interaction with content provided by us. Unlike Cookies,
                        which are stored on a user's device hard drive, Pixel Tags are embedded within
                        content. The small size and transparency of Pixel Tags is not meant to deceive
                        content recipients, but rather to minimize distraction.<br /><br /><b>Do Not
                          Track</b><br />Do-Not-Track is a public-private initiative,
                        https://www.w3.org/2011/tracking-protection/, that has developed a technical
                        “flag” or signal that an end-user may be able to activate within their browser
                        software to notify sites that they do not wish to be “tracked” by third parties
                        as defined by the initiative. The initiative, however, has not reached a
                        consensus as to exactly what technical or other actions those parties receiving
                        the signal should take. As a result, Do-Not-Track has not yet been standardized
                        and most sites, including our sites, do not alter their behavior or change their
                        services when they receive a “do-not-track” flag or signal. You can, however,
                        make decisions about your privacy and the advertisements you receive.<br />The
                        methods for doing so vary from browser to browser, and from version to version.
                        You can obtain up-to-date information about blocking and deleting cookies via
                        these links:</li>
                    </ol>
                    <p><a href="https://support.google.com/chrome/answer/95647" target="_blank" className=""
                      rel="noopener">https://support.google.com/chrome/answer/95647</a></p>
                    <p><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                      target="_blank" className=""
                      rel="noopener"><u>https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences</u></a>
                    </p>
                    <p><a href="https://www.opera.com/help/tutorials/security/cookies/" target="_blank" className=""
                      rel="noopener"><u>https://www.opera.com/help/tutorials/security/cookies/</u></a>
                    </p>
                    <p><a
                      href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies"
                      target="_blank" className=""
                      rel="noopener"><u>https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies</u></a>
                    </p>
                    <p><a href="https://support.apple.com/en-us/HT201265" target="_blank" className=""
                      rel="noopener"><u>https://support.apple.com/en-us/HT201265</u></a></p>
                    <p><a href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy" target="_blank"
                      className=""
                      rel="noopener"><u>https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy</u></a>
                    </p>
                    <p>Associations in the digital advertising ecosystem provide methods for specifically
                      opting out of interest-based advertising, including the Digital Advertising Alliance
                      <a href="https://optout.aboutads.info/?c=2&amp;lang=EN" className="" target="_blank"
                        rel="noopener">click here</a> and the
                      YourOnlineChoices page <a href="https://www.youronlinechoices.com/" className="" target="_blank"
                        rel="noopener">click here</a>.
                    </p>
                    <p>Please note, however, that if you do decide to block cookies or similar technologies,
                      some parts of our sites may not function correctly.</p>
                    <p><br /></p>
                    <p><b>Using a Third-Party Account on our Services</b></p>
                    <p>If you use a third-party service (such as Google, Facebook, or other social media
                      platforms) to create an account, we may receive personal information that you allow
                      such third-party service to share with us such as your name, e-mail address, profile
                      picture, or other personal information. The third-party service may also collect
                      information about you that you have agreed to in their terms of service or privacy
                      notice. Please check with the third-party service for more details.</p>
                    <p><b>In Person at a Store or Over the Phone<br /></b>When iFixScreens.com provides you
                      services, either remotely or in one of our stores, we may collect personal
                      information from you, such as:</p>
                    <ul className="">
                      <li>Name;</li>
                      <li>Mailing address;</li>
                      <li>Email address;</li>
                      <li>Cell phone number;</li>
                      <li>Electronic Serial Number ("ESN") or International Mobile Equipment Identity
                        ("IMEI") data;</li>
                      <li>Device information, for example serial number or media access control ("MAC")
                        address;</li>
                      <li>Records of products or services you have purchased from us;</li>
                      <li>Any information that you provide as part of purchasing our services, for example
                        payment card information;</li>
                      <li>Any information that you provide to allow our technicians to access your device
                        for servicing</li>
                      <li>Video or audio recording in our stores, for example security cameras in certain
                        locations where permitted by law</li>
                      <li>An audio recording of your phone conversation with us</li>
                    </ul>
                    <p><b>Services Performed at Your Home or Other Location<br /></b>One should be cognizant
                      that, when receiving services at one's home or other location, the service provider
                      may have the ability to view any items that can be seen by visitors, which may
                      include personal information. If one has consented to it, the service provider may
                      require access to one's device in order to fulfill the services requested, such as
                      altering configurations, backing up data, or providing technology set-up or counsel.
                      Additionally, if one is getting a device repair as part of an insurance claim, the
                      service provider may need to take photographs of the device to certify that the
                      damage has been mended. It is important to bear in mind that any data present on the
                      device or its surrounding areas may be visible in the photograph.</p>
                    <p><b>Other Personal Information<br /></b>We may utilize external data sources to supply
                      context and background information concerning the users of our services in order to
                      enhance the customer experience, prevent fraud or malicious activity, or fulfill
                      internal company and external regulatory prerequisites. We furthermore draw
                      inferences from the personal information we obtain from you to potentially provide
                      products or services that we conjecture would suit you (Note: you may at any time
                      revoke your approval of our utilization or disclosure of your personal information
                      for marketing and promotional objectives by reaching out to us as specified in the
                      Where to Turn With Questions section of this privacy notice.)</p>
                    <p><b>How we use your Personal Information</b></p>
                    <p>iFixScreens.com may use your Personal Information to:</p>
                    <ol className="">
                      <li>Fulfill a service to you;</li>
                      <li>Establish and verify your identity;</li>
                      <li>Activate and maintain your account;</li>
                      <li>Provide technical support;</li>
                      <li>Protect and improve our services;</li>
                      <li>Offer updates, notices and other information about applications and services
                        available from iFixScreens.com or its affiliates as permitted by law. (Note: at
                        any time you may choose to withdraw your consent to iFixScreens.com use or
                        disclosure of your personal information for marketing and promotional purposes
                        by contacting us as outlined in the Where to Turn With Questions section of this
                        Notice);</li>
                      <li>Respond to your questions, inquiries, comments and instructions;</li>
                      <li>To enforce the applicable Terms and Conditions;</li>
                      <li>Comply with the law and defend our rights;</li>
                      <li>Track and analyze de-identified data and provide such data to third parties that
                        provide services to iFixScreens.com;</li>
                      <li>Protect against fraud and potential fraud;</li>
                      <li>Notify you of any known breach of your personal information; and</li>
                      <li>Maintain the security and integrity of iFixScreens.com systems and services.
                      </li>
                    </ol>
                    <p><b>SHARING</b></p>
                    <p>iFixScreens.com may share Personal Information with companies that are affiliated
                      with it, or with non-affiliated companies in order to provide, maintain, and operate
                      its services or marketing. Additionally, iFixScreens.com may disclose Personal
                      Information without providing a choice in order to protect the legal rights of
                      iFixScreens.com, its affiliated companies, employees, agents, and contractors; to
                      protect the safety and security of visitors; to protect against fraud or for risk
                      management purposes; or to comply with the law or legal process. Furthermore, if
                      iFixScreens.com is involved in a merger, sale, or transfer of assets, it may
                      transfer Personal Information to a third party as part of that transaction.</p>
                    <p><b>SECURITY</b></p>
                    <p>We employ commercially reasonable, industry standard technical, administrative, and
                      physical controls to protect Your Personal Information, including encryption when
                      appropriate. However, since the internet is not a fully secure environment, we
                      cannot guarantee the security of information transmitted between You and Us.
                      Consequently, You acknowledge that You transmit such information at Your own risk.
                      We shall provide You with notice of any confirmed security breach of Your Personal
                      Information to the extent required by applicable state and federal law.</p>
                    <p><b>CHANGES TO THIS PRIVACY NOTICE</b></p>
                    <p>IFixScreens.com may update this Privacy Notice from time to time. If any changes are
                      made, the modified date near the top of the page will be altered. It is recommended
                      to check this Privacy Notice periodically for any changes. If, where applicable to
                      the service purchased, there are material changes to this Privacy Notice, best
                      efforts will be made to notify the user electronically and, where necessary, seek
                      their affirmative consent in accordance with applicable laws.</p>
                    <p><b>ACCESS AND CHOICE</b></p>
                    <p>iFixScreens.com has implemented the following procedure that you may use to access,
                      correct, or delete your personal information, or choose how your information is
                      used.</p>
                    <p>If</p>
                    <ul className="">
                      <li>you would like to know the types of information that iFixScreens.com collects
                        from visitors to its website,</li>
                      <li>your personal information is incorrect and you would like to correct it</li>
                      <li>you wish to stop receiving email marketing promotions from iFixScreens.com</li>
                      <li>you wish to receive a copy of the information that iFixScreens.com has about
                        you,</li>
                      <li>Contact us using the contact information in the Where to Turn With Questions
                        section of this notice.</li>
                    </ul>
                    <p><b>CHILDREN UNDER 13</b></p>
                    <p>Our Services are not directed to children under 13, and we do not knowingly collect
                      Personal Information from such minors. If you become aware of your child accessing
                      the Services and providing Personal Information without your consent, please contact
                      us using the information provided in the “Where to Turn With Questions” section. We
                      will take necessary steps to remove any Personal Information from our storage
                      systems and terminate the account, should we determine that a child under 13 has
                      accessed the Services.</p>
                    <p><b>FOR NON-U.S. RESIDENTS</b></p>
                    <p>We may transfer Personal Information that we collect about you outside of the country
                      in which it was collected. If you are visiting from the European Union or other
                      region with laws governing data collection and use that may differ from U.S. law,
                      please be aware that you are transferring information about yourself, including your
                      Personal Information, to a country and jurisdiction that does not have the same data
                      protection laws in place as the European Union or other region. By doing so, you are
                      consenting to the transfer of information about yourself, including your Personal
                      Information, to the United States, as described in this Notice.</p>
                    <p><b>CALIFORNIA CONSUMER PRIVACY ACT (CCPA)</b></p>
                    <p>The California Consumer Privacy Act (CCPA) grants California consumers certain
                      privacy protections through the provision of specific disclosures and the granting
                      of certain rights. If you are a California consumer, this document provides you with
                      the aforementioned disclosures and information regarding your rights and how to
                      exercise them, should you so choose.</p>
                    <p>Categories of personal information we collect</p>
                    <p>We may collect the categories of personal information described in the personal
                      information we collect section of this notice. These categories are classified under
                      the CCPA as follows:</p>
                    <p>Identifiers:</p>
                    <ul className="">
                      <li>Name,</li>
                      <li>mailing address,</li>
                      <li>email address,</li>
                      <li>cell phone number,</li>
                      <li>electronic serial number (“ESN”) or International Mobile Equipment Identity
                        (“IMEI”),</li>
                      <li>device serial number, and</li>
                      <li>media access control (“MAC” address), CallerID / ANI (Automatic Number
                        Identification) information</li>
                    </ul>
                    <p>California Customer Records personal information categories:</p>
                    <ul className="">
                      <li>Name,</li>
                      <li>mailing address,</li>
                      <li>email address,</li>
                      <li>cell phone number,</li>
                      <li>electronic serial number (“ESN”) or International Mobile Equipment Identity
                        (“IMEI”),</li>
                      <li>device serial number,</li>
                      <li>media access control (“MAC”) address,</li>
                      <li>CallerID / ANI (Automatic Number Identification) information, and</li>
                      <li>financial information such as credit card number and debit card number</li>
                    </ul>
                    <p>Commercial information:</p>
                    <ul className="">
                      <li>Records of products or services you have purchased from us,</li>
                      <li>responses to online, verbal or video surveys</li>
                    </ul>
                    <p>Biometric information:</p>
                    <ul className="">
                      <li>A scan of driver's license, passport, or other personal identification card to
                        identify fraud or for regulatory compliance purposes</li>
                      <li>“voice prints” or other similar biometric identifiers used in call recordings
                      </li>
                    </ul>
                    <p>Sensory information:</p>
                    <ul className="">
                      <li>Audio information from customer interactions with customer service
                        representatives,</li>
                      <li>audio/video inside our store locations</li>
                      <li>photos of your device taken by a service provider to confirm that it was damaged
                        and has been repaired</li>
                    </ul>
                    <p>Internet or other similar network activity:</p>
                    <p>Information we collect when you visit our websites our use our mobile applications:
                    </p>
                    <ul className="">
                      <li>IP address,</li>
                      <li>unique device identifier,</li>
                      <li>the content of web pages,</li>
                      <li>transactions with APIs (Application Program Interface),</li>
                      <li>hardware information,</li>
                      <li>hardware and system settings,</li>
                      <li>browser type,</li>
                      <li>browser languages,</li>
                      <li>the date and time of your request,</li>
                      <li>referral URL,</li>
                      <li>cookies and pixel tags</li>
                    </ul>
                    <p>Geolocation Information: GPS, cell tower, and Bluetooth location data if you enable
                      geolocation on your device operating system and are you using a location-based
                      service. You may turn this off at any time within the device settings</p>
                    <p>Inferences from Personal Information: Inferences we draw from the personal
                      information we collect from you to potentially offer products or services that we
                      believe would be a good fit for you</p>
                    <p>Categories of sources of personal information</p>
                    <p>We collect personal information from the following categories of sources:</p>
                    <ul className="">
                      <li>Directly from you;</li>
                      <li>Partners and affiliates that assist us in providing products and services to
                        you;</li>
                      <li>Non-affiliated companies to assist us in providing, maintaining and operating
                        our services or marketing; and</li>
                      <li>Non-affiliated companies that provide us with demographic information.</li>
                    </ul>
                    <p>Business purposes for collecting personal information</p>
                    <p>We may use or disclose the personal information we collect for one or more of the
                      following business purposes:</p>
                    <ul className="">
                      <li>Fulfill a service or market a new service or product to you;</li>
                      <li>Establish and verify your identity;</li>
                      <li>Activate and maintain your account;</li>
                      <li>Provide technical support;</li>
                      <li>Protect and improve our services;</li>
                      <li>Offer updates, notices and other information about applications and services
                        available from iFixScreens.com or its affiliates as permitted by law. (Note: at
                        any time you may choose to withdraw your consent to iFixScreens.com use or
                        disclosure of your personal information for marketing and promotional purposes
                        by contacting us as outlined in the Where to Turn With Questions section of this
                        Notice);</li>
                      <li>Respond to your questions, inquiries, comments and instructions;</li>
                      <li>To enforce the applicable Terms and Conditions;</li>
                      <li>Comply with the law and defend our rights;</li>
                      <li>Track and analyze de-identified data and provide such data to third parties that
                        provide services to iFixScreens.com;</li>
                      <li>Protect against fraud and potential fraud;</li>
                      <li>Notify you of any known breach of your personal information; and</li>
                      <li>Maintain the security and integrity of iFixScreens.com systems and services.
                      </li>
                    </ul>
                    <p>Disclosure of personal information for a business purpose</p>
                    <p>We may disclose your personal information to the following categories of third
                      parties:</p>
                    <ul className="">
                      <li>Non-affiliated companies to assist us in providing, maintaining and operating
                        our services or marketing. These companies are required to comply with the
                        principles set out in this notice and only use such information for the purposes
                        for which it was provided to them; and</li>
                      <li>A third-party, in the event of a proposed or actual purchase, sale (including a
                        liquidation, realization, foreclosure or repossession), lease, merger,
                        amalgamation or any other type of acquisition, disposal, transfer, conveyance or
                        financing of all or any portion of its business or of any assets or shares of
                        our business or a division thereof in order for you to continue to receive the
                        same or similar products and services from the third-party. In such an event, we
                        will provide notice of any material change to this notice, or our Services, in
                        the manner described in this Notice. In these circumstances, Personal
                        Information may be shared with the actual or prospective purchasers or
                        assignees, or with the newly acquired business.</li>
                    </ul>
                    <p>We may disclose the following categories of personal information to third parties for
                      a business purpose:</p>
                    <ul className="">
                      <li>Identifiers;</li>
                      <li>California Customer Records personal information categories;</li>
                      <li>Commercial information;</li>
                      <li>Internet or other similar network activity;</li>
                      <li>Sensory information (i.e., audio information); and</li>
                      <li>Inferences drawn (e.g., preferences) from personal information.</li>
                    </ul>
                    <p><b>Sale of your personal information</b></p>
                    <p>Under the California Consumer Privacy Act (CCPA), WE DO NOT SELL any personal
                      information as the term is traditionally understood. However, certain methods of
                      advertising employed by us may be considered a sale of your personal information to
                      third parties that assist us in providing, maintaining, and operating our marketing.
                      Such personal information may include the following categories:</p>
                    <ul className="">
                      <li>Identifiers;</li>
                      <li>Internet or other similar network activity; and</li>
                      <li>Inferences from personal information.</li>
                    </ul>
                    <p>Individuals may opt out of the sale of their personal information by adjusting their
                      cookies preferences and turning off targeting ads. Furthermore, we do not sell the
                      personal information of individuals under the age of 16 if we have actual knowledge
                      of the individual's age.</p>
                    <p><b>Access to and deletion of your personal information</b></p>
                    <ul className="">
                      <li>Information Request: By contacting us, you may ask that iFixScreens.com provide
                        you with a copy of your personal information.</li>
                      <li>Deletion Request: By contacting us, you may ask that iFixScreens.com delete any
                        of your personal information that we have collected about you and retained,
                        subject to certain exceptions.</li>
                      <li>These exceptions include but are not limited to the following:<ul>
                        <li>providing a good or service that you requested, taking actions
                          reasonably anticipated within the context of our ongoing business
                          relationship with you, or otherwise performing our contract with you;
                        </li>
                        <li>detecting security incidents and protecting against fraud or illegal
                          activity;</li>
                        <li>debugging products and services;</li>
                        <li>enabling solely internal uses that are reasonably aligned with consumer
                          expectations;</li>
                        <li>complying with a legal obligation; and</li>
                        <li>making other internal and lawful uses of your Personal Information that
                          are compatible with the context for which you provided it.</li>
                      </ul>
                      </li>
                    </ul>
                    <p><br /></p>
                    <p>To make such an access or deletion request, please email info@ifixscreens.com. We
                      will not discriminate against you for exercising any of your rights related to your
                      personal information.</p>
                    <p><b>WHERE TO TURN WITH QUESTIONS</b></p>
                    <p>If you have any questions about this Notice, about our website, product or service,
                      or want to request access to, correction, or deletion of your Personal Information,
                      or have a privacy-related complaint, you can contact iFixScreens.com by sending
                      email to info@ifixscreens.com.</p>
                    <p>You may also contact us at:</p>
                    <p>iFixScreens.com</p>
                    <p>Attn: Privacy Office</p>
                    <p>1311 W Spring St, Suite B, Monroe, GA 30655</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {isTermPopOpen() && (
        <div className="terms-popupmain active">
          <div className="terms-popupoverlay"></div>
          <div className="terms-popupinner">
            <div className="close" onClick={closeTermsPop}>
              <svg clip-rule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" />
              </svg>
            </div>
            <div className="scrollinner">
              <div className="wrapper">
                <div className="terms-tabs-links">
                  <h3>Quick Links:</h3>
                  <ul>
                    <li><a href="#wrapper">Repair Terms and Conditions</a></li>
                    <li><a href="#websiteterm">Website Terms and Conditions</a></li>
                    <li><a href="#smsterms">SMS Terms and Conditions</a></li>
                    <li><a href="#accessibilitylink">Accessibility Statement</a></li>
                    <li><a href="#franchisedis">Franchise Disclosure Statement</a></li>
                  </ul>
                </div>
              </div>
              <div className="repair-terms-of-service">
                <div className="wrapper">
                  <div className="inner">
                    <div className="img-half">
                      <img src="https://ifixscreens.com/storage/2021/10/terms-768x756.jpg.webp" alt="" />
                    </div>
                    <div className="content-half">
                      <h2>Repair Terms of Service</h2>
                      <h3>Effective Date: Jan 1, 2023.</h3>
                      <p>This Agreement applies generally to all Repair Services and governs the use of such Services as
                        well as the Website operated by i-fix-screens.com, Inc., a New York corporation (the “Company”).
                        The Company has developed a comprehensive system, referred to as the “System”, for the operation
                        of stores and mobile units, which primarily offer and sell Repair Services and other ancillary
                        products and accessories. These stores are either owned and operated by the Company’s affiliates
                        or independent owners and franchisees (collectively referred to as “System Operators”).</p>
                      <p><strong>This Agreement contains a mandatory arbitration provision, which stipulates that any
                        disputes arising from the use of the Services must be resolved exclusively through
                        arbitration, and further waives any right to a jury trial or any class action proceedings.
                        Should you not agree with any of the terms of this Agreement, you are prohibited from using
                        the Services.</strong></p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="repair-terms-and-conditions2">
                <div className="wrapper">
                  <div className="inner">
                    <h3><b>Definitions</b></h3>
                    <p>In this Agreement, the terms "Our," "Us," and "We" refer to the Company and its respective parents,
                      subsidiaries, branches, affiliates, agents, employees, successors, and assigns, and, for the
                      purposes of all Sections of this Agreement except Sections 14, 21, and 23, shall also include its
                      System Operators; the terms "You," "Your," and "Yourself" refer to a person or business who uses the
                      Services and any person or entity represented by that individual; the term "Service Authorization &
                      Estimate" refers to the receipt provided to and agreed to by You prior to the commencement of
                      Services, which describes the Services to be performed and the estimated costs; the term "Device"
                      refers to the eligible device, as defined in this Agreement, identified on the Service
                      Authorization, Intake Form & Estimate on which You authorize Us to perform the Services; and the
                      term "Website" refers to</p>
                    <p>
                      <a href="https://ifixscreens.com/" className="" style={{
                        outline: 'none'
                      }}>https://ifixscreens.com/</a>
                      <br />
                      <a href="https://franchise.ifixscreens.com" target="_blank" className="" style={{
                        outline: 'none'
                      }}>https://franchise.ifixscreens.com</a>
                      <br />
                      <a href="https://sell.ifixscreens.com/" target="_blank" className="" style={{
                        outline: 'none'
                      }}>https://sell.ifixscreens.com/</a>
                      <br />
                      <a href="https://ifixscreens.co/" className="" style={{ outline: 'none' }} target="_blank"
                        rel="noopener">https://ifixscreens.co/</a>
                      <br />
                      <a href="https://i-fix-screens.com/" target="_blank" rel="noopener">https://i-fix-screens.com/</a>
                    </p>
                    <h3><b>Privacy Policy</b></h3>
                    <p>You acknowledge and agree that when You visit the Website or use the Services, We may utilize
                      automatic or other means (e.g., cookies and web beacons) to collect information about You and Your
                      Device and/or Your access or use of the Website. Additionally, You may be required to provide
                      certain information about Yourself and/or Your Device as a condition of receiving the Services, and
                      the Services may provide You with opportunities to share information about Yourself with others. All
                      information We collect through or in connection with the Services is subject to Our Privacy Policy,
                      which is available at <a href="https://ifixscreens.com/about-us/privacy-policy/" target="_blank"
                        className="" style={{ outline: 'none' }}>https://ifixscreens.com/about-us/privacy-policy/</a> and
                      explains Our policies with respect to the collection, use, and disclosure of information related to
                      or derived from Your use of the Website and Services. Therefore, You should read the Privacy Policy
                      carefully and completely. It is incorporated by reference into this Agreement, and by using the
                      Services, You consent to the collection, use, and disclosure of Your information as set forth in
                      that Policy. Because We are unable to guarantee the security of Your personal information, You
                      acknowledge and agree that You provide it to Us at Your own risk. If You know or suspect that the
                      passwords associated with or stored on Your Device have been made available to or accessed by anyone
                      as a result of Your use of the Services, You should immediately change or reset those passwords.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Representations</b></h3>
                    <p> You must agree and represent to Us that, when seeking Services, You are the owner and/or have the
                      necessary authority to consent to an inspection and repair of the Device. We reserve the right to
                      deny you Services if We determine that You are not the owner and/or authorized user. Additionally,
                      You must represent to Us that any information or data disclosed is not confidential or proprietary
                      to You or any third party.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Authorizations</b></h3>
                    <p>You are hereby authorizing Us to perform the Services, which may include repairs, technical
                      support, in-home services, and other services as described in the Service Authorization, Intake Form
                      & Estimate, in accordance with this Agreement. When requesting these Services, You give Us your
                      express consent to inspect and repair the Device, and authorize Us to carry out any repairs or
                      modifications necessary to provide the Services. You acknowledge and agree that these modifications
                      may be permanent and irreversible.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Scope of the Services:</b></h3>
                    <p>You hereby agree to hold Us harmless and to indemnify Us from any and all claims or damages, of
                      whatever kind, arising from the Services.</p>
                    <p>The Services provided by Us include the repair of Your Device, as well as any applicable operating
                      systems and software applications either on the Device or intended to be used thereon. Such Services
                      may additionally include technical support related to either the repair or the optimization of Your
                      usage of Your Device. Technology recycling may also be included, subject to separate terms and
                      conditions. In performing the Services, We may use new, rebuilt, reconditioned, or refurbished
                      parts, as well as original or non-original parts. You acknowledge that the Services are not provided
                      as part of the original manufacturer’s warranty and that such Services may void any applicable
                      manufacturer’s warranty. You hereby agree to exempt Us from any and all claims or damages that may
                      result from the Services.</p>
                    <ul>
                      <li><strong>A) &nbsp;DATA ON DEVICE:</strong><br />You bear the sole responsibility for backing up
                        any data on your Device and for deleting, encrypting, or otherwise protecting said data from
                        unauthorized use. iFixScreens.com shall not be held liable for backing up or restoring your data,
                        nor shall it be liable for any data that is lost or corrupted. Furthermore, iFixScreens.com shall
                        not treat data on Your Device as confidential, nor shall it be bound by any agreement with you or
                        other obligation to do so.<br /><br /><strong>B) Repair Authorization:</strong><br />I hereby
                        authorize iFixScreens.com to perform the work described in the Work Authorization & Estimate. I
                        understand that services will be rendered for the Estimated Cost (plus applicable tax). I am aware
                        that iFixScreens.com is not responsible (and I assume the risk) for any data loss, data
                        corruption, or breach of data on my device during service. Additionally, I am aware that
                        additional charges may apply if iFixScreens.com determines after further inspection that service
                        is not covered by the applicable manufacturer's Standard Limited Warranty, iFixShield protection
                        plan, or any other extended warranty, if any, for the device, and iFixScreens.com will contact me
                        in such an event via phone call, sms, email, or I will be informed in person. I understand that if
                        this device has been carrier unlocked, the carrier unlock may be removed during the repair, and
                        iFixScreens.com will not be able to alter software from its manufactured state thereafter.
                        Furthermore, I understand that if I fail to return for my device, my device shall be considered
                        “abandoned” following two contact attempts using the contact information provided above within 30
                        days of repair completion. In addition, I understand that all repairs performed at applicable
                        manufacturer authorized service centers, if any, require a full system update to ensure devices
                        are working properly. I also understand that some existing applications and programs may not be
                        compatible with the updated systems. Moreover, I understand that changing some parts including the
                        screen or battery on some devices will result in a notification on the device that says,
                        unauthorized battery or screen replacement or the repair is not performed by an authorized repair
                        center or the part is non-original. These notifications are normal and do not affect the device's
                        functionalities. These notifications appear for both OEM and NON-OEM parts. We cannot guarantee
                        that the device will maintain its original water-resistant properties post-repair. Customers are
                        advised to avoid exposing their repaired devices to water or moisture. I am also aware that there
                        is no warranty on parts not purchased through iFixScreens.com, no warranty on water-damaged
                        devices, a 180-day warranty on parts installed by iFixScreens.com as long as the part is not
                        physically damaged, no refunds on special orders/out-of-stock parts, and a 30-day warranty on
                        special orders/out-of-stock parts and batteries. Furthermore, I understand that the customer is
                        responsible for labor to reverse any install/service performed, and a non-refundable diagnosis fee
                        applies for motherboard repairs or any repair taking more than 30 minutes and is applied to repair
                        costs if repaired.</li>
                    </ul>
                  </div>
                  <div className="inner">
                    <h3><b>Availability of the Services</b></h3>
                    <p>All eligible Devices are eligible for Service during the operating hours of stores and/or service
                      centers in the System, as determined by System Operators. An individual desiring to use the Services
                      on behalf of Your company may be required to provide identifying information, such as whether they
                      are an owner, member, partner, director, manager, employee, or agent of Your company. For onsite,
                      mail-in, mobile or in-home Services, eligibility is contingent upon the participation of stores, the
                      availability of the Services in Your geographic location, and the eligibility requirements provided
                      in this Agreement. We reserve the right to cancel or refuse Services if We determine that the
                      Service location is cost prohibitive for Our Service technicians to travel to.</p>
                  </div>
                  <div className="inner">
                    <h3>Eligibility For Services</h3>
                    <p>Eligible devices for the Services may include, but are not limited to, cellular phones, laptops,
                      tablets, gaming devices, televisions, printers, and smart home products, as determined by Us in Our
                      sole discretion. For Service eligibility and initiation, We must conduct a physical inspection of
                      the device, confirm that the device is eligible, accessible, and serviceable, and that there are no
                      modifications to the device that would make it ineligible or unsafe for the performance of Services.
                      At Our sole discretion, We will determine the eligibility for onsite and in-home Services during the
                      scheduling process, and will confirm eligibility in accordance with this Agreement at the designated
                      Service location.</p>
                  </div>
                  <div className="inner">
                    <h3>Back Up</h3>
                    <p>You are solely responsible for safeguarding any software and data housed on Your Device. This
                      includes deleting, encrypting, or otherwise protecting Your data from unauthorized access. We
                      disclaim any responsibility for any loss, alteration, or corruption of any hardware, software, data,
                      or files, regardless of the cause. We may deny the provision of Services to You if We deem that You
                      have not taken appropriate measures to back up Your files. You are responsible for any and all
                      restoration or reconstruction of lost or altered files, data, or programs. We will not hold any data
                      on Your Device in confidence and We disclaim any agreement or obligation to do so..</p>
                  </div>
                  <div className="inner">
                    <h3><b>Abandonment</b></h3>
                    <p>When the Services are completed and Your Device is ready for pick up, We will make contact with
                      You. If, despite Our attempt to reach You, You fail to pick up Your Device or otherwise make
                      arrangements for its return within thirty (30) days, or any other period of time as mandated by law,
                      it will be considered abandoned and become Our property. In such a case, We reserve the right to
                      dispose of the abandoned property in Our sole discretion pursuant to applicable law, including by
                      selling it, with the proceeds being used to recover administrative and repair costs.</p>
                  </div>
                  <div className="inner">
                    <h3>Replacement Devices</h3>
                    <p>Subject to this Agreement regarding Your responsibility to back up Your data, We shall be
                      responsible to the extent provided by applicable law for the physical safety of Your Device while it
                      is in Our possession for Service. Should Your Device be lost, stolen or damaged while it is under
                      Our care for Service, We shall repair or replace it with a device of like kind and quality, as
                      determined by Us in Our sole discretion, which, at Our sole option, may be new or refurbished.</p>
                  </div>
                  <div className="inner">
                    <h3>Limited Warranty</h3>

                    <p>
                      Under this Agreement, the repairs and parts used in the Services, as well as any replacement Device,
                      shall be warranted for a period of 180 days from the date the Services are completed (the “Limited
                      Warranty”). This warranty is subject to the provisions and exclusions set forth in this Agreement.
                    </p>
                    <p data-css="tve-u-17d09327723" style={{ textAlign: 'left' }}>
                      <strong>
                        A. Limited Warranty Exclusions:</strong>
                      This Limited Warranty does not cover Services or repairs performed on Devices that have been exposed
                      to moisture or liquids outside of the manufacturer’s intended use, or that have been subjected to
                      abuse, misuse, damage due to external causes, an Act of God, normal wear and tear, battery leakage
                      or damage resulting from battery leakage, mishandling, physical damage, operation outside of design
                      limits, improper repair by someone other than the warrantor, unauthorized modification, excessive
                      corrosion, electrical current, heat, moisture or vibration, improper specification, misapplication,
                      software modifications performed by someone other than the warrantor, updated software, use of
                      unauthorized or unapproved software, viruses, malware, spyware, attempts to modify any software that
                      has been installed by the warrantor, or Devices on which the serial number has been altered,
                      defaced, or is missing. This Limited Warranty covers the following software Services only: factory
                      restores, backups, jailbreaks, and unlocks. This Limited Warranty is
                      non-transferable.<br /><strong>B. Ownership of Repaired or Replaced Parts and Devices:</strong>
                      Unless state or other laws dictate otherwise, all replaced Devices, components, boards, parts, and
                      equipment shall become Our property, and You shall relinquish any and all rights You may possess
                      under said laws regarding the replaced Device or any repaired or replaced parts.<br /><strong>C.
                        Limited Warranty Procedure:</strong> If a Device that has been repaired or replaced under the
                      180-day Limited Warranty malfunctions within the Warranty period, it must be returned to a store or
                      service center within the System for evaluation by Us. The individual responsible for the Device
                      will be responsible for any associated shipping costs. Upon examination, if We determine, in Our
                      sole discretion, that the parts or repairs used to perform the Services were defective, or that the
                      replacement Device is defective, then the Device will be fixed at no cost.<br /><strong>D. No-Lemon
                        Policy:</strong> For replacement Devices, if three (3) covered repairs have been completed on the
                      Device in accordance with this Limited Warranty, and it requires a fourth (4th) repair within the
                      180 days period of the Limited Warranty, We shall replace the Device with a substitute Device of the
                      same kind and quality, which may be new or refurbished in Our sole discretion. Should We provide a
                      substitute Device, it shall be warranted under this Limited Warranty for the remainder of the
                      initial 180 days period of the Limited Warranty.
                      <br /><br />
                    </p>
                  </div>
                  <div className="inner">
                    <h3><b>Disclaimer Of All Other Warranties:</b></h3>
                    <p>THE LIMITED WARRANTY STATED ABOVE SETS FORTH THE FULL EXTENT OF OUR RESPONSIBILITIES, AND THE
                      EXCLUSIVE REMEDY REGARDING WORK PERFORMED OR PARTS SUPPLIED BY US IN CONNECTION WITH THE SERVICES
                      PERFORMED ON YOUR DEVICE. THE FOLLOWING DISCLAIMER IS APPLICABLE TO YOU TO THE MAXIMUM EXTENT
                      PERMITTED BY APPLICABLE LAW. YOU ACKNOWLEDGE AND AGREE THAT THE SERVICES AND WEBSITE ARE PROVIDED ON
                      AN 'AS IS' AND 'AS AVAILABLE' BASIS, AND THAT YOUR USE OF OR RELIANCE ON EITHER IS AT YOUR SOLE RISK
                      AND DISCRETION. WE HEREBY DISCLAIM ANY AND ALL REPRESENTATIONS, WARRANTIES AND GUARANTIES REGARDING
                      THE SERVICES, WHETHER EXPRESS, IMPLIED OR STATUTORY, AND INCLUDING, WITHOUT LIMITATION, THE IMPLIED
                      WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT, EXCEPT AS
                      SPECIFICALLY SET FORTH IN THIS AGREEMENT. FURTHERMORE, WE MAKE NO WARRANTY THAT (A) THE SERVICES
                      WILL MEET YOUR REQUIREMENTS; OR (B) THE SERVICES WILL BE AVAILABLE, TIMELY, RELIABLE, COMPLETE,
                      SECURE OR ERROR-FREE. EXCEPT AS PROVIDED IN THESE TERMS, NO ADVICE OR INFORMATION, WHETHER ORAL OR
                      WRITTEN, OBTAINED BY YOU FROM US SHALL CREATE ANY REPRESENTATION, WARRANTY OR GUARANTY. FURTHERMORE,
                      YOU ACKNOWLEDGE AND AGREE THAT WE HAVE NO OBLIGATION TO SUPPORT OR MAINTAIN THE SERVICES. YOU
                      ACKNOWLEDGE AND AGREE THAT WE MIGHT NOT BE ABLE TO OFFER THE SERVICES AT ALL, IN THE ABSENCE OF THE
                      FOREGOING DISCLAIMERS AND LIMITATIONS. WE SHALL HAVE NO OTHER WARRANTY OBLIGATION WHATSOEVER WITH
                      RESPECT TO THE SERVICES EXCEPT AS SPECIFICALLY SET FORTH IN THIS AGREEMENT, AND ANY OTHER CLAIMS,
                      LOSSES, LIABILITIES, DAMAGES, COSTS OR EXPENSES ATTRIBUTABLE TO ANY FAILURE TO CONFORM TO ANY
                      WARRANTY WILL BE YOUR SOLE RESPONSIBILITY.</p>
                    <h3><b>Limitation Of Liability</b></h3>
                    <p>SUBJECT TO THE EXTENT PERMITTED BY APPLICABLE LAW, YOU AGREE THAT WE SHALL NOT BE LIABLE FOR ANY
                      INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR EXEMPLARY DAMAGES ARISING OUT OF OR IN CONNECTION
                      WITH YOUR ACCESS OR USE OF, OR INABILITY TO ACCESS OR USE, THE SERVICES OR THE WEBSITE, WHETHER OR
                      NOT THE DAMAGES WERE FORESEEABLE AND WHETHER OR NOT WE WERE ADVISED OF THE POSSIBILITY OF SUCH
                      DAMAGES, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, LOSS OF PROFITS OR REVENUES,
                      FAILURE TO TRANSMIT OR RECEIVE ANY DATA, LOSS OF TIME, DAMAGE TO REPUTATION OR GOODWILL, MISUSE OR
                      DISCLOSURE OF DATA OR CONFIDENTIAL INFORMATION, BUSINESS INTERRUPTION, LOSS OF PRIVACY, ALTERATION,
                      CORRUPTION, OR LOSS OF THE DEVICE, DATA, HARDWARE, SOFTWARE, OR FILES, FAILURE TO RECEIVE OR BACKUP
                      YOUR DATA (OR ARCHIVED DATA), OR ANY OTHER COMMERCIAL OR PECUNIARY LOSS WHATSOEVER ARISING OUT OF OR
                      IN ANY WAY RELATED TO THE SERVICES. UNLESS EXPRESSLY STATED OTHERWISE IN THIS AGREEMENT, OUR
                      AGGREGATE LIABILITY TO YOU, WHETHER BASED IN CONTRACT, NEGLIGENCE, STRICT LIABILITY, STATUTE, OR
                      OTHER THEORY OF LIABILITY, SHALL NOT EXCEED THE AMOUNT OF THE FEES PAID BY YOU FOR THE SERVICES, OR
                      $100.00, WHICHEVER IS GREATER. THESE LIMITATIONS SHALL APPLY EVEN IF THE STATED REMEDY FAILS OF ITS
                      ESSENTIAL PURPOSE.</p>
                    <h3><b>Modification</b></h3>
                    <p>This Agreement may be modified by Us at any time. Your continued use of the Services and/or Website
                      shall constitute Your agreement to any such modifications. We reserve the right to suspend or
                      terminate Your use of the Services and/or Website at any time and for any reason, including but not
                      limited to abuse, excessive usage, or failure to pay any fees or charges. We further reserve the
                      right to change the scope or extent of the Services at any time and for any reason. No one other
                      than Us is authorized to modify this Agreement or make any binding representations or claims
                      regarding the Services, whether in advertising, presentations, or otherwise.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Severability & Waiver</b></h3>
                    <p>The parties hereby agree that if any provision of this Agreement is found to be invalid or
                      unenforceable, it shall be modified in such a way as to be valid and enforceable while preserving
                      its intent and purpose. If such modification is not possible, the provision shall be severed from
                      this Agreement. Further, any failure to enforce a right or term of this Agreement shall not be
                      construed as a waiver of that right or term.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Meta - Data</b></h3>
                    <p>You hereby acknowledge and agree that We may collect and use Meta-Data logs during our diagnostic
                      evaluation in order to improve the future functionality of our diagnostic tool and symptom
                      evaluation process. We will use the data collected solely for the purposes of enhancing and
                      improving this process, and may share it with Our affiliates. Unless you provide your consent, the
                      data will not be distributed any further. The types of data that may be collected from Your Device
                      include, but are not limited to: device phone number, device model number, device IMEI, device
                      serial number, downloaded applications and their associated settings, and host applications and
                      their associated settings.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Arbitration Agreement</b></h3>
                    <p>Most of Your issues related to the Services can be resolved by sending an email to
                      info@ifixscreens.com. In the event of any disagreement or dispute between You and Us, You agree to
                      first attempt to resolve the matter through informal discussion.<br /><strong>A.</strong> We and You
                      agree to resolve any disputes through binding arbitration or small claims court instead of through
                      courts of general jurisdiction. We and You agree that any arbitration will take place on an
                      individual basis only, and that We and You waive all rights to a jury trial or to participate in
                      class actions or other representative proceedings. This Arbitration Agreement ('ARB') shall survive
                      the termination of the Agreement and is governed by the Federal Arbitration Act. This ARB shall be
                      interpreted broadly, and it includes any dispute between We and You that arises out of or relates in
                      any way to our relationship or the Services, whether based in contract, tort, statute, fraud,
                      misrepresentation, or otherwise. However, this ARB does not preclude You from bringing an individual
                      action against Us in small claims court or from informing any federal, state, or local agencies of
                      Your dispute; such agencies may be able to seek relief on Your behalf.<br /><strong>B.</strong> To
                      initiate arbitration, a written Notice of Claim must be sent by certified mail to iFixScreens, 1311
                      W Spring St, Suite B, Monroe, GA 30655, ATTN: Legal Department. The Notice must include a
                      description of the dispute and the relief sought. If the dispute is not resolved within 90 days of
                      receipt of the Notice, the individual may start an arbitration proceeding with the American
                      Arbitration Association ('AAA'). Information regarding the arbitration process, including rules and
                      forms, may be obtained at www.adr.org or by telephone at 1-800-778-7879. The arbitration shall be
                      conducted in Walton County.state of Georgia and each party shall bear its own costs and expenses
                      associated therewith. The decision of the arbitrator shall be final and binding on the
                      parties.<br /><strong>C.</strong> The arbitration shall be administered by the American Arbitration
                      Association (AAA) in accordance with the Commercial Arbitration Rules and the Supplementary
                      Procedures for Consumer Related Disputes (the 'Rules') then in effect and as modified by this
                      Arbitration Agreement (the 'Agreement'). The Arbitrator shall be bound by the terms of the
                      Agreement, and shall be responsible for deciding all issues, with the exception that issues relating
                      to the enforceability of the Agreement may be decided by a court. If the dispute is for $10,000 or
                      less, the parties may conduct the arbitration by submitting documents to the Arbitrator or by
                      telephone. If the dispute is for more than $10,000, the Right to Hearings shall be determined by the
                      Rules. Unless otherwise agreed, any hearings shall take place at the county/parish of the mailing
                      address of the claimant. The arbitration shall be conducted in Walton County.state of Georgia and
                      each party shall bear its own costs and expenses associated therewith. The decision of the
                      arbitrator shall be final and binding on the parties.<br /><strong>D.</strong> The Arbitrator shall
                      issue a decision including the facts and law upon which his/her decision is based. If the Arbitrator
                      finds in the favor of the Claimant and issues a damages award that is greater than the value of the
                      last settlement offer made by the Respondent, or if the Respondent made no settlement offer, and the
                      Arbitrator awards the Claimant any damages, the Respondent shall: (1) pay the Claimant the amount of
                      the award or $2,500, whichever is greater; and (2) pay the Claimant's attorney, if any, the
                      attorney's fees and expenses reasonably incurred in the arbitration. While the right to the
                      attorney’s fees and expenses discussed above is in addition to any right the Claimant may have under
                      applicable law, neither the Claimant nor his/her attorney may recover duplicate awards of attorney’s
                      fees and expenses. The Respondent hereby waives any right he/she may have under applicable law to
                      recover attorney’s fees and expenses from the Claimant if the Respondent prevails in the
                      arbitration.<br /><strong>E.</strong> If you as a party seek declaratory or injunctive relief, such
                      relief can only be awarded to the extent necessary to provide relief. The parties agree that any
                      claims brought against one another must be done so in an individual capacity, and not in a purported
                      class action, class arbitration or other representative proceeding. Unless the parties agree
                      otherwise, the arbitrator may not consolidate the dispute of a party with any other person's
                      dispute, nor may the arbitrator preside over any form of representative or class proceeding. If this
                      specific provision of the Arbitration Agreement is found to be unenforceable, the entirety of such
                      Agreement shall be null and void.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Class Action Waiver</b></h3>
                    <p>In furtherance of Section 17A of this Agreement, any Claim arising out of or subsequent to
                      cancellation or termination of this Agreement must be brought in the parties' individual capacities
                      and not as a plaintiff or class member in any purported class, class arbitration, collective,
                      representative, multiple plaintiff, or similar basis (hereinafter “Class Action”), and the parties
                      expressly waive any ability to maintain any Class Action in any forum whatsoever. The arbitrator
                      shall not have authority to combine or aggregate similar claims or conduct any Class Action, nor
                      shall the arbitrator have authority to make an award to any person or entity not a party to the
                      arbitration. Any claim that all or part of this Class Action Waiver is unenforceable,
                      unconscionable, void, or voidable may only be determined in a court of competent jurisdiction and
                      not by an arbitrator. The parties agree that this Section 18 shall expressly survive cancellation or
                      termination of the Agreement. The parties understand that they would have had a right to litigate
                      through a court and to have a judge or jury decide their case and to be party to a class or
                      representative action; however, they understand and choose to have any claims decided individually,
                      through arbitration. If this specific provision of this Section 18 is found to be unenforceable,
                      then the entirety of this Section 18 and the ARB is null and void.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Claim Limitation</b></h3>
                    <p>Unless otherwise allowed by applicable law, any claim related to the Services must be brought
                      within 180 days of the events giving rise to the claim. Failure to do so within this 180-day window
                      will result in the waiver and barring of the claim.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Third-Party Content</b></h3>
                    <p>The Services may expose You to content, websites, products, and services created or provided by
                      parties other than Us ("Third-Party Content"). We do not review, endorse, or assume any
                      responsibility for Third-Party Content, and shall have no liability to You for access to or use of
                      such Third-Party Content. You acknowledge and agree that We are not responsible for Third-Party
                      Content, including their accuracy, completeness, timeliness, validity, copyright compliance,
                      legality, decency, quality, or any other aspect thereof. We do not assume, and will not have, any
                      liability or responsibility to You or any other person or entity for any Third-Party Content. Links
                      to Third-Party Content are provided solely as a convenience to You, and You access and use them
                      entirely at Your own risk and subject to such third parties' terms and conditions. By accessing or
                      using Third-Party Content, You do so at Your own risk and discretion, and You understand that this
                      Agreement and Privacy Policy do not apply to such Third-Party Content.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Intellectual Property Rights</b></h3>
                    <p>You agree that all copyrights, patents, trademarks, trade secrets and other intellectual property
                      or proprietary rights associated with the Services are Our exclusive property, and We reserve and
                      retain all such rights not expressly granted to You in this Agreement. If You submit comments or
                      Ideas about the Services, including ways to improve the Services or other products or services, You
                      acknowledge that such submission is gratuitous, unsolicited, and without restriction. We are not
                      under any fiduciary or other obligation in regards to such submission, and We are free to use the
                      Idea without compensation to You, and/or to disclose the Idea to anyone on a non-confidential basis.
                      Furthermore, You acknowledge that Our acceptance of Your submission does not waive any rights We may
                      have to use similar or related ideas previously known to Us, or developed by Our employees, or
                      obtained from sources other than You.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Indemnification</b></h3>
                    <p>You hereby agree to indemnify, defend, and hold Us harmless from any claim, proceeding, loss,
                      damage, liability, or expense of any kind arising out of or in connection with Your use or misuse of
                      the Services, Your alleged or actual breach of this Agreement, Your alleged or actual violation of
                      any applicable rule, law, or regulation, Your negligence or willful misconduct, or Your alleged or
                      actual violation of the intellectual property or other rights of third parties. We reserve the
                      right, at Your expense, to assume the exclusive defense and control of any matter for which You are
                      required to indemnify Us, and You agree to cooperate in that defense.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Assignment</b></h3>
                    <p>You may not transfer or assign any rights or licenses granted hereunder; any such attempted
                      transfer or assignment shall be null and void. We, however, may transfer or assign such rights or
                      licenses without restriction.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Entire Agreement & Governing Law</b></h3>
                    <p>This Agreement, along with the documents referenced in it, comprises the entirety of the parties'
                      arrangement regarding the Services, nullifying any prior or current contracts. The interpretation of
                      this Agreement and the relationship between the parties shall be determined in accordance with the
                      laws of the State of Georgia, without accounting for any conflicts of law principles. The United
                      Nations Convention on Contracts for the International Sale of Goods shall not apply.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Misuse</b></h3>
                    <p>One shall not misuse the Services or Website in any manner that interferes with or interrupts the
                      Services or Website or any hardware, software, system, or network connected with the Services or
                      Website; stalks, harasses, threatens, or harms any person or is otherwise invasive of another’s
                      privacy rights; uses the Services or Website on a device without permission; tampers with or makes
                      an unauthorized connection to any network, including, without limitation, the network of any
                      wireless carrier; disseminates viruses or other computer code, files, or programs that interrupt,
                      destroy, or limit the functionality of the Services or Website or any other computer software or
                      hardware; removes, disables, circumvents, or otherwise creates or implements any workaround to any
                      copy protection, rights management, or security features in or protecting the Services or Website;
                      or uses any robot, spider, or other automatic device, process, or means to use the Services or
                      Website.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Services Exclusions</b></h3>
                    <p>Technical Support Services may have certain limitations and exclusions, including but not limited
                      to (a) assistance with third-party software or services that are not related to the Device; (b)
                      installation of third-party software or OEM drivers not supported by the Device; (c) assistance with
                      network coverage issues, such as dropped calls/data interruptions; (d) over-the-air updates to
                      operating systems, firmware, or some software; (e) diagnostic support not related to the Device; (f)
                      modification of Original Equipment Manufacturer ('OEM') software; (g) hardware and equipment setup
                      and repair; (h) installation of non-sanctioned applications; or (i) assistance with enterprise level
                      software, industry-specific hardware, or equipment.</p>
                  </div>
                  <div className="inner">
                    <h3><b>Commercially Reasonable Efforts & Technical Problems</b></h3>
                    <p>The Parties agree that Company shall use commercially reasonable efforts to provide User with the
                      Services and Website. Should Company be unable to resolve any issue related to User's Device after
                      making commercially reasonable efforts, Company has the right, at its sole discretion, to refuse to
                      take any further steps to resolve such issue. Further, Company may have limited information from
                      vendors, manufacturers, and developers, and may be incapable of obtaining the proprietary or other
                      information necessary to resolve the issue related to User's Device. Certain technical problems
                      encountered by User when using his/her Device may be due to software or hardware errors not yet
                      remedied by the hardware or software vendors, manufacturers or developers, in which case Company may
                      not be able to resolve User's particular issue. Notwithstanding, User shall remain liable for any
                      fees or charges associated with the Services.</p>
                    <p><b>The IFIXSCREENS.COM® trademarks and logos are the exclusive property of I-FIX-SCREENS.COM, Inc.
                      and its affiliates. Any and all other trademarks are the property of their respective owners. The
                      appearance of such trademarks should not be interpreted as an indication of affiliation,
                      sponsorship, or endorsement by any of the owners of the other trademarks, service marks, and/or
                      product brands that appear on the website. Galaxy, iPhone, iPod, iPad, Mac, and other marks and
                      words are registered trademarks of Apple, Inc, Samsung, etc.. iFixScreens.com is an independent
                      service company and holds no affiliation with Apple Inc, Samsung, or any other manufacturer. All
                      rights reserved.</b></p>

                  </div>
                </div>
              </div>
              <div className="repair-terms-and-conditions2 repair-terms-and-conditions2-red" id="smsterms">
                <div className="wrapper">
                  <div className="inner">
                    <h2>Sms Terms And Conditions</h2>
                    <h3>Effective Date: Jan 1, 2023.</h3>
                    <p>Please read these SMS Terms & Conditions (the “SMS Terms”) carefully. By enrolling or otherwise
                      agreeing to receive text messages from or on behalf of iFixScreens.com or by otherwise providing
                      your phone number to iFixScreens.com, you agree to these SMS Terms, as well as iFixScreens.com’s
                      Terms of Use and Privacy Policy, which are incorporated herein by reference and can be viewed at the
                      links provided here, or at iFixScreens.com.com. For purposes of these SMS Terms, “iFixScreens.com,”
                      “the Company,” “we,” or “us” shall mean iFixScreens.com device repair & sales stores, Inc. and any
                      of its subsidiaries, divisions, or affiliates.</p>
                    <h3>Please Note:</h3>
                    <p>THESE SMS TERMS CONTAIN AN ARBITRATION CLAUSE WITH A CLASS ACTION WAIVER THAT AFFECTS YOUR RIGHTS.
                      THE ARBITRATION PROVISION AFFECTS HOW DISPUTES WITH iFixScreens.com ARE RESOLVED. YOU AGREE TO BE
                      BOUND BY THIS ARBITRATION PROVISION. IN ARBITRATION, THERE IS NO JUDGE OR JURY AND THERE IS LESS
                      DISCOVERY AND APPELLATE REVIEW THAN IN COURT. PLEASE READ THESE SMS TERMS CAREFULLY.</p>
                    <h3>Opting into Text Messages</h3>
                    <p>By opting into any iFixScreens.com text program, you expressly consent to receive recurring
                      marketing text messages that may be sent using an automatic telephone dialing system, by or on
                      behalf of iFixScreens.com, at the cell phone number you provide us. By voluntarily providing your
                      cell phone number to iFixScreens.com, you consent to receive transactional, operational, or
                      informational text messages at that phone number, including but not limited to order confirmations;
                      shipping and delivery notifications; and appointment reminders for grooming, veterinary, training,
                      or wellness services. Please note we may not be able to deliver messages to all mobile carriers.
                      Consent to receive texts is not a condition of purchasing any goods or services, and you understand
                      and agree that all text messages may be sent using automated technology.</p>
                    <h3>How to Opt Out and Get Help</h3>
                    <p>To stop receiving text messages from iFixScreens.com, you agree to reply STOP to the number sending
                      the message. After replying STOP, you may receive additional communications confirming that your
                      request has been received and processed, and you may continue to receive text messages for a short
                      period while iFixScreens.com processes your request(s). If you opt out of one iFixScreens.com text
                      messaging program, you will remain opted into other iFixScreens.com text messaging programs (if
                      applicable) unless you opt out of those programs separately. If you need further assistance, text
                      HELP to the number sending the message, or contact iFixScreens.com customer service at (855)
                      462-4349. Below is more information on the types of text messages you may receive, and how to opt
                      out of text messages from iFixScreens.com. In all cases, consent to receive texts is not a condition
                      of purchasing any goods or services, and message and data rates may apply:</p>
                    <h3>Mobile Marketing Alerts, SMS Informational Campaigns, and One-Time Offer Campaigns:</h3>
                    <p>By enrolling in promotional text programs such as iFixScreens.com Mobile Marketing alerts, SMS
                      Informational Campaigns, or One-Time Offer Campaigns, you will receive recurring marketing and
                      informational texts from or on behalf of iFixScreens.com at the mobile number you provide when
                      opting in. In some cases, you may text us to enroll.</p>
                    <h3><b>Order Tracking</b></h3>
                    <p>Same-Day Delivery, and Curbside Pickup Texts: You may provide your cell phone number to opt in to
                      receive text messages about your orders, shipments, and/or deliveries. In some cases, you may text
                      us to enroll. You may receive text messages when your package is on its way, out for delivery,
                      and/or when it arrives. For curbside pickup orders, you may receive texts when your items are ready
                      to be picked up, reminders to pick up your order, and alerts if an item is out of stock or
                      cancelled. To be removed from these lists, reply STOP. For help, reply HELP.<br />After opting out
                      of receiving text messages, you can re-enroll in any iFixScreens.com text messaging program by
                      following the instructions for that program. We would be happy to welcome you back.</p>
                    <h3>Cost</h3>
                    <p>Message and data rates may apply for any messages sent to you from or on behalf of iFixScreens.com,
                      and messages you send to us. If you have any questions about your text plan or data plan, it is best
                      to contact your wireless provider.</p>
                    <h3>Eligibility and Change in Phone Number</h3>
                    <p>By opting into iFixScreens.com’s text messaging program(s) or by otherwise providing your cell
                      phone number to iFixScreens.com, you warrant that you are 18 years of age or older. You further
                      warrant that you are the current subscriber or authorized user of the phone number you have
                      provided. You agree that you will not initiate messages to the mobile phone of any other person or
                      entity without authorization. If you change, forfeit, or deactivate the phone number you have
                      provided to iFixScreens.com, you agree to notify iFixScreens.com immediately. Failure to do so
                      constitutes a material breach of these SMS Terms and iFixScreens.com’s Terms of Use. Mobile carriers
                      are not liable for delayed or undelivered messages.</p>
                    <h3>Mandatory Dispute Resolution In Regards to SMS Policy</h3>
                    <p>PLEASE READ THIS SECTION CAREFULLY – IT MAY SIGNIFICANTLY AFFECT YOUR LEGAL RIGHTS, INCLUDING YOUR
                      RIGHT TO FILE A LAWSUIT IN COURT AND TO HAVE A JURY HEAR YOUR CLAIMS. IT CONTAINS PROCEDURES FOR
                      MANDATORY PRE-DISPUTE RESOLUTION, BINDING ARBITRATION AND A CLASS ACTION
                      WAIVER.<br /><br />IRRESPECTIVE OF ANY LAW TO THE CONTRARY, YOU MUST PROVIDE NOTICE TO
                      iFixScreens.com, PURSUANT TO THE PROCEDURES SET FORTH IN THIS SECTION, OF ANY CLAIM WITHIN ONE YEAR
                      OF ITS ACCRUAL OR YOUR CLAIM SHALL BE WAIVED AND TIME-BARRED.</p>
                    <h3>Pre-Dispute Resolution Process</h3>
                    <p>Should you and iFixScreens.com have a Dispute (as defined below), iFixScreens.com is committed to
                      engaging with you to resolve it. Therefore, for any Dispute that arises between you and
                      iFixScreens.com, the parties agree that they will first make a good faith effort to resolve it
                      informally. This informal dispute resolution process is a condition precedent to commencing any
                      formal proceeding in arbitration or small claims court. The parties agree that any relevant
                      limitations period and filing fee or other deadlines will be tolled while the parties engage in this
                      process.<br /><br />For your Disputes with iFixScreens.com, you must first send your name, address,
                      telephone number, email address, and sufficient information for iFixScreens.com to identify any
                      transaction at issue; a detailed description of your Dispute; and the nature and basis of your
                      claims and the relief sought, along with the calculation you used (the “Notice”) to the following
                      email address: info@iFixScreens.com.com. You and iFixScreens.com agree to negotiate in good faith
                      about the Dispute, including through an informal and individualized telephone or video settlement
                      conference if requested by iFixScreens.com. If either party to the Dispute is represented by
                      counsel, that party’s counsel may participate, but the party also must personally appear at and
                      participate in the settlement conference. This process should lead to resolution of the Dispute, but
                      if the matter is not resolved within sixty (60) days after iFixScreens.com’s receipt of the complete
                      written description detailed above, you and iFixScreens.com agree to the further dispute resolution
                      provisions below. This time period will start to run upon receipt of the information referenced
                      above. If the sufficiency of the Notice or compliance with this pre-dispute resolution process is at
                      issue, either party may elect to have this issue decided by a court, and any formal dispute
                      resolution proceeding shall be stayed pending resolution of the issue.</p>
                    <h3><b>Arbitration For SMS Policy</b></h3>
                    <p>You and iFixScreens.com agree that any and all controversies, disputes, demands, counts, claims, or
                      causes of action between you and the Company, or the Company's employees, agents, affiliates,
                      subsidiaries, successors, representatives, or assigns (“Dispute(s)”), shall be resolved through
                      binding and confidential arbitration, except that you or the Company may elect to have a Dispute
                      heard in small claims court if it qualifies for hearing by such a court, provided that an action in
                      small claims may only seek individualized relief and so long as the action remains in that court and
                      is not removed or appealed to a court of general jurisdiction. If the limitations on a small claims
                      court proceeding are deemed unenforceable for any reason, it shall be severed from this agreement
                      and the parties may not elect to proceed in small claims court, and the dispute shall be heard in
                      arbitration. In addition, each party retains the right to seek injunctive or other equitable relief
                      in a court of competent jurisdiction to prevent the actual or threatened infringement,
                      misappropriation, or violation of a party's copyrights, trademarks, trade secrets, patents, or other
                      intellectual property rights. “Dispute” shall be interpreted broadly and shall also include all
                      Disputes that arose before your agreement to these SMS Terms, and which arise after the termination
                      of this agreement. Notwithstanding the foregoing, issues related to the scope, validity, and/or
                      enforceability of this arbitration agreement are for a court to decide.</p>
                    <p>There is no judge or jury in arbitration and arbitration procedures are simpler and more limited
                      than rules applicable in court. YOU ACKNOWLEDGE AND AGREE THAT, APART FROM THE NARROW EXCEPTIONS
                      ABOVE, YOU AND iFixScreens.com ARE EACH WAIVING YOUR RIGHTS TO SUE IN COURT, INCLUDING RIGHTS TO
                      RECEIVE A TRIAL BY JURY OR TO PARTICIPATE AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS
                      ACTION LAWSUIT, CLASS-WIDE ARBITRATION, PRIVATE ATTORNEY GENERAL ACTION, OR ANY OTHER REPRESENTATIVE
                      PROCEEDING.</p>
                    <p>THE ARBITRATOR MAY AWARD DECLARATORY OR INJUNCTIVE RELIEF ONLY IN FAVOR OF THE INDIVIDUAL PARTY
                      SEEKING RELIEF AND ONLY TO THE EXTENT NECESSARY TO PROVIDE RELIEF WARRANTED BY THAT PARTY’S
                      INDIVIDUAL CLAIM. THE ARBITRATOR MAY NOT AWARD RELIEF FOR OR AGAINST ANYONE WHO IS NOT A PARTY TO
                      THE ARBITRATION PROCEEDING. FURTHER, UNLESS BOTH YOU AND iFixScreens.com AGREE OTHERWISE, THE
                      ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE PERSON’S CLAIMS AND MAY NOT OTHERWISE PRESIDE OVER ANY
                      FORM OF A REPRESENTATIVE OR CLASS PROCEEDING. IF A COURT DETERMINES THAT PUBLIC INJUNCTIVE RELIEF
                      MAY NOT BE WAIVED AND ALL APPEALS FROM THAT DECISION HAVE BEEN EXHAUSTED (OR THE DECISION IS
                      OTHERWISE FINAL), THEN THE PARTIES AGREE THAT THE PARTICULAR CLAIM FOR PUBLIC INJUNCTIVE RELIEF
                      SHALL BE SEVERED AND STAYED PENDING ARBITRATION OF THE REMAINING CLAIMS. IF THIS SPECIFIC PARAGRAPH
                      IS FOUND TO BE UNENFORCEABLE, THEN THE ENTIRETY OF THIS ARBITRATION PROVISION (EXCEPT FOR THE JURY
                      TRIAL WAIVER) SHALL BE NULL AND VOID.</p>
                    <p>Arbitration shall be subject to the Federal Arbitration Act and federal arbitration law, and shall
                      be conducted by Judicial Arbitration Mediation Services, Inc. (“JAMS”) pursuant to the JAMS
                      Streamlined Arbitration Rules & Procedures (the “JAMS Rules”) as modified by this arbitration
                      agreement. The JAMS Rules, including instructions for bringing arbitration, are available on its
                      website at www.jamsadr.com/rules-streamlined-arbitration. If JAMS is unable or unwilling to
                      administer a proceeding under this arbitration provision as written, the parties shall agree on a
                      substitute arbitration organization. If the parties cannot agree, the parties shall mutually
                      petition a court of appropriate jurisdiction to appoint an arbitration organization that will
                      administer a proceeding under this arbitration provision as written and applying the selected
                      arbitration organization’s consumer rules. When initiating arbitration, you shall personally certify
                      to iFixScreens.com and to JAMS that you are a party to this arbitration agreement and provide a copy
                      or link to it. You shall also personally certify that you have complied with the pre-dispute
                      resolution process detailed above. You agree that you shall personally participate, along with your
                      counsel if represented, in the initial conference with the arbitrator unless the parties agree
                      otherwise.</p>
                    <p>iFixScreens.com will pay its arbitration costs as required by JAMS rules, and in the event that you
                      are able to demonstrate that the costs of arbitration will be prohibitive as compared to costs of
                      litigation, and you have complied with the pre-dispute resolution process outlined above,
                      iFixScreens.com will pay as much of your arbitration filing and hearing fees as the arbitrator deems
                      is necessary to prevent the arbitration from being cost-prohibitive as compared to the cost of
                      litigation. Each side shall pay their own attorneys' fees, costs, and arbitration fees unless the
                      arbitrator finds, among other grounds, (1) that either the substance of a claim or the relief sought
                      is frivolous or brought for an improper purpose (as measured by the standards set forth in Federal
                      Rule of Civil Procedure 11(b)), or (2) the claim(s) at issue permit the prevailing party to be
                      reimbursed its fees and litigation costs, and in such instances, the fees and costs awarded shall be
                      determined by the arbitrator consistent with applicable law and with the JAMS Rules. The arbitrator
                      may consider whether a party had previously offered full relief to the other party or whether the
                      proceeding is part of multiple case filings. The provisions of Federal Rule of Civil Procedure 68
                      shall be applied by the arbitrator. The arbitrator shall be bound by these SMS Terms as any court
                      would be. The arbitrator shall issue a reasoned, detailed decision explaining the essential findings
                      and conclusions on which the award is based. The arbitration award shall be binding only as to the
                      parties. The arbitration may consider rulings in other arbitrations involving other claimants, but
                      an arbitrator’s ruling will not be binding in proceedings involving different claimants.</p>
                    <p>The arbitration may be conducted by telephone, based on written submissions, or in person at a
                      mutually agreed-upon location convenient for you. You agree to appear at an initial conference with
                      the arbitrator and at any hearing, along with your counsel if you are represented. If fifty (50) or
                      more claimants submit Notices raising similar claims and they are represented by the same or
                      coordinated counsel, you understand and agree to the following provisions: (1) you agree that the
                      adjudication of your Dispute may be delayed; (2) you agree that your counsel will negotiate in good
                      faith with iFixScreens.com to determine a reasonable staged bellwether process involving a subset of
                      demands not to exceed fifty (50) at a time, each of which shall be adjudicated on an individual
                      basis; (3) only after each of the arbitrations that proceed are adjudicated or otherwise resolved
                      shall the next set of staged proceedings commence; (4) your Dispute shall not be filed or considered
                      properly filed in arbitration and filing fees shall not be due and owing until it is selected for
                      inclusion in this continuously staged, reasonable bellwether process. This process shall continue
                      until all the claimants’ claims are adjudicated or otherwise resolved. The statute of limitations
                      and any filing fee deadlines shall be tolled for your claim from the time of initiation with JAMS
                      until the time your Dispute is selected for a bellwether process, withdrawn, or otherwise resolved.
                      A court shall have authority to enforce this paragraph and, if necessary, to enjoin the mass filing
                      of arbitration demands against iFixScreens.com.</p>
                    <p>As referenced above, this dispute resolution section shall be governed by the Federal Arbitration
                      Act. It shall survive any termination or cancellation of these SMS Terms. Any amendments to this
                      dispute resolution section shall be prospective only and shall not affect any pending Dispute for
                      which iFixScreens.com has notice or pending arbitration proceeding.</p>
                    <p>YOU AGREE THAT, BY ENTERING INTO THIS AGREEMENT, YOU AND iFixScreens.com ARE EACH WAIVING THE RIGHT
                      TO A TRIAL BY JURY AND TO PARTICIPATE IN A CLASS ACTION TO THE MAXIMUM EXTENT PERMITTED BY LAW.</p>
                    <h3><b>Opt-out Of Agreement To Arbitrate</b></h3>
                    <p>iFixScreens.com’s updates to these SMS Terms do not provide you with a new opportunity to opt out
                      of arbitration if you previously agreed and did not validly opt out of arbitration. iFixScreens.com
                      will continue to honor any valid opt outs if you previously opted out of arbitration with
                      iFixScreens.com.</p>
                    <h3><b>Changes to the SMS Terms</b></h3>
                    <p>These SMS Terms may be updated by iFixScreens.com at any time without prior notice. By continuing
                      to be enrolled in any iFixScreens.com promotional text messaging program, or by providing your cell
                      phone number for transactional, operational, or informational text messages, you agree to any
                      changes.</p>
                    <h3><b>Questions</b></h3>
                    <p>For questions about these SMS Terms or iFixScreens.com’s text messages, please contact
                      iFixScreens.com customer service at info@iFixScreens.com.com.</p>

                  </div>
                </div>
              </div>
              <div className="repair-terms-and-conditions2" id="accessibilitylink">
                <div className="wrapper">
                  <div className="inner">
                    <h2>Accessibility Statement</h2>
                    <p>Effective Date: Jan 1, 2023.</p>
                    <div className="inner">
                      <p>iFixScreens.com and its subsidiaries, divisions, and affiliates (collectively, “iFixScreens.com”)
                        are committed to providing accessible websites, applications, online services and similar
                        interactive services (each a “Website”) to all visitors, including people with disabilities.
                        iFixScreens.com has established this Website Accessibility Statement to further ensure we provide
                        goods, services, information and a retail experience to all of our customers in a manner
                        consistent with this core value.</p>
                      <p>iFixScreens.com has a third-party digital accessibility partner to assist iFixScreens.com in
                        adopting and implementing procedures in support of the World Wide Web Consortium’s Web Content
                        Accessibility Guidelines (“WCAG”) 2.1 Level AA (“WCAG 2.1 AA”), as its web accessibility standard
                        for its Websites. iFixScreens.com continues to make WCAG conformance of its Websites a key focus
                        of its software development and design efforts.</p>
                      <p>iFixScreens.com conducts periodic Website accessibility audits to ensure continued accessibility
                        for its Websites in conformance with WCAG 2.1 AA. In a dynamic, ever-changing technology
                        environment, iFixScreens.com understands the importance of continually testing its digital
                        properties to ensure consistent experiences are delivered. iFixScreens.com tests and confirms the
                        accessibility of each Website in advance of an initial launch, if applicable, and on a periodic
                        basis thereafter to monitor and test for conformity to WCAG 2.1 AA and other accessibility
                        guidelines. iFixScreens.com uses manual, functional and technical methods to conduct the
                        evaluations, which includes user testing by people with disabilities, to enhance the digital
                        customer experience for people of all abilities. iFixScreens.com provides regular training and
                        education to employees who are central to its Website software and design development on current
                        Website accessibility guidelines and principles.</p>
                      <p>Please note that our Websites may link to, or interface with, third-party sites that we do not
                        control and which are not affiliated directly with iFixScreens.com. These third-party vendors may
                        not have undertaken the same efforts that iFixScreens.com has to comply with the WCAG standards.
                        As such, iFixScreens.com does not make representations regarding the accessibility and compliance
                        with the ADA (or other applicable laws) of third-party sites. In addition, third-party vendors
                        provide some content, plugins and widgets on our Websites. While we ask those third-party vendors
                        to ensure accessibility, we cannot ensure their conformance, but commit to continuously working
                        with them to ensure updates are made consistently to improve the customer experience for all.</p>
                      <p>Please note that our Websites may link to, or interface with, third-party sites that we do not
                        control and which are not affiliated directly with iFixScreens.com. These third-party vendors may
                        not have undertaken the same efforts that iFixScreens.com has to comply with the WCAG standards.
                        As such, iFixScreens.com does not make representations regarding the accessibility and compliance
                        with the ADA (or other applicable laws) of third-party sites. In addition, third-party vendors
                        provide some content, plugins and widgets on our Websites. While we ask those third-party vendors
                        to ensure accessibility, we cannot ensure their conformance, but commit to continuously working
                        with them to ensure updates are made consistently to improve the customer experience for all.</p>
                      <h3><b>Mandatory Dispute Resolution via Arbitration</b></h3>
                      <p>In the event of a dispute arising out of or in connection with this statement, the parties shall
                        attempt to resolve it through amicable negotiation. If the parties fail to reach an agreement
                        within 180 days, either party may submit the dispute to binding arbitration in accordance with the
                        rules of theAmerican Arbitration Association (AAA, www.adr.org). The arbitration shall be
                        conducted in Walton County.state of Georgia and each party shall bear its own costs and expenses
                        associated therewith. The decision of the arbitrator shall be final and binding on the parties.
                      </p>
                      <p>Contacting iFixScreens.com with Accessibility Questions or Comments</p>
                      <p>Please send any specific questions or concerns about the accessibility of any webpage or function
                        on any iFixScreens.com Website to info@iFixScreens.com.com. If you do encounter an accessibility
                        issue, we appreciate you letting us know and we will make all reasonable efforts to improve the
                        accessibility of that page.</p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="repair-terms-and-conditions2" id="franchisedis">
                <div className="wrapper">
                  <div className="inner">
                    <h2>Franchise Disclosure Statement</h2>
                    <p>Effective Date: Jan 1, 2023.</p>
                    <p>The information on this website https://ifixscreens.com/ or https://franchise.ifixscreens.com/ does
                      not constitute an offer to sell, or the solicitation of an offer to buy, a franchise. It is for
                      information purposes only. The offer to sell a franchise can only be made through the delivery of a
                      franchise disclosure document (FDD). Currently, the following states regulate the offer and sale of
                      franchises: California, Hawaii, Illinois, Indiana, Maryland, Michigan, Minnesota, New York, North
                      Dakota, Oregon, Rhode Island, South Dakota, Virginia, Washington, and Wisconsin. We will not sell a
                      franchise in these states until we have registered the franchise (or obtained an applicable
                      exemption from registration) and delivered the FDD to the prospective franchisee in compliance with
                      applicable local laws.</p>
                    <h3><b>Mandatory Dispute Resolution via Arbitration</b></h3>
                    <p>In the event of a dispute arising out of or in connection with this statement, the parties shall
                      attempt to resolve it through amicable negotiation. If the parties fail to reach an agreement within
                      180 days, either party may submit the dispute to binding arbitration in accordance with the rules of
                      theAmerican Arbitration Association (AAA, www.adr.org). The arbitration shall be conducted in Walton
                      County.state of Georgia and each party shall bear its own costs and expenses associated therewith.
                      The decision of the arbitrator shall be final and binding on the parties.</p>

                  </div>
                </div>
              </div>
              <div className="repair-terms-and-conditions2">
                <div className="wrapper">
                  <div className="inner">
                    <h2>Website Terms of Use</h2>
                    <p>Effective Date: Jan 1, 2023.</p>
                    <p><strong>SCOPE OF USE.</strong> I-Fix-Screens.com, Inc., a New York Corporation, on behalf of itself
                      and for the benefit of its affiliates and subsidiaries ("We", "Us" and "Our" and any derivation
                      thereof) provides this Website (the "Site") to the user of the Site ("You", "Your" and "Yourself"),
                      for Your informational, noncommercial use, and subject to the following Terms of Use (the "Terms").
                      You shall use the Site strictly in accordance with these Terms and in a manner consistent with all
                      applicable local, state, national and international laws and regulations. Use of the Site is limited
                      to persons eighteen (18) years of age or older. Any use of the Site to evaluate whether to enter
                      into a business relationship with Us shall not constitute a commercial use for the purposes hereof.
                      It is prohibited for You to use the Site in violation of any applicable laws and regulations or in
                      violation of the rules of any of Our service providers. Further, certain other programs or services
                      provided by Us through linked websites or other channels may have additional terms and conditions
                      regarding Your use of those services, and nothing in these Terms is intended to modify such terms
                      and conditions. Moreover, neither these Terms, nor any content, materials, features, or products and
                      services of the Site create any partnership, joint venture, employment, or other agency relationship
                      between You and Us. You are not authorized to enter into any contract on Our behalf or bind Us in
                      any way.</p>
                    <p><strong>ACCEPTANCE OF THE TERMS.</strong> You must read these Terms carefully before you begin to
                      use the Site. By using the Site and/or clicking “accept” or “agree” to the Terms when this option is
                      available to you, you are agreeing to be bound and abide by these Terms and the terms of the Privacy
                      Policy located at <a href="https://ifixscreens.com/about-us/privacy-policy/" target="_blank"
                        className="" style={{ outline: 'none' }}>https://ifixscreens.com/about-us/privacy-policy/</a> (the
                      “Privacy Policy”). The Privacy Policy explains our practices concerning the collection and use of
                      your information through or in connection with the Site. It is incorporated into these Terms and
                      governs our use of your information and any information you submit or make available to us in
                      connection with the Site. If you are not willing to accept these Terms, you may not use this Site.
                    </p>
                    <p><strong>MODIFICATIONS.</strong> We reserve the right to modify this Site and update the rules and
                      regulations governing its use, at any time, including without limitation these Terms. Modifications
                      will be posted on the Site, and the “Last Updated” date at the top of this web page will be revised.
                      All modifications become effective immediately upon posting and apply to all access to and use of
                      the Site thereafter. You understand and agree that if you use this Site after the date on which the
                      Terms have changed, We will treat your use as acceptance of the updated Terms. We may also make
                      changes in the products and/or services described in this Site at any time. You are expected to
                      check this page periodically so that you are aware of any changes, as they are binding on you.</p>
                    <p><strong>REGISTRATION.</strong> You shall be responsible for any and all access to or use of the
                      Site by You, or any person or entity using Your Account(s) or Your Account Data, whether or not such
                      access or use has been authorized by or on behalf of You. You agree to immediately notify Us of any
                      unauthorized use of Your Account(s) or Your Account Data or any other breach of
                      security.<br /><br />You agree that You will provide true, accurate, current, complete, and
                      up-to-date information when accessing or using the Site, and that You will promptly notify Us of any
                      changes to such information. If You provide any information that is untrue, inaccurate, non-current,
                      or incomplete, or We have reasonable grounds to suspect that such information is untrue, inaccurate,
                      non-current, or incomplete, We have the right to restrict, terminate, or refuse any and all current
                      or future access or use of the Site (or any portion thereof) in Our sole discretion and without
                      notice. You shall be responsible for any and all access to or use of the Site by You, or any person
                      or entity using Your Account(s) or Your Account Data, whether or not such access or use has been
                      authorized by or on behalf of You. You agree to immediately notify Us of any unauthorized use of
                      Your Account(s) or Your Account Data or any other breach of security.</p>
                    <p><strong>ACCESS TO SITE.</strong> We reserve the right to withdraw or amend the materials contained
                      on or displayed on the Site, including the operation and offering of the Site itself, in our sole
                      discretion without notice. Your account may give you access to certain portions of the Site and
                      functionality that we may establish and maintain from time to time, in our sole discretion. We will
                      not be liable if, for any reason, all or any part of the Site is unavailable at any time or for any
                      period. From time to time, we may restrict access to some parts of the Site, or to the entire Site,
                      to users, including registered users. We have the right to disable any username, password, or other
                      identifier, whether chosen by you or provided by us, at any time in our sole discretion for any or
                      no reason, including if, in our opinion, you have violated any of these Terms. You are responsible
                      for making all of the arrangements necessary for you to have access to the Site, and for ensuring
                      that all persons who access the Site through your internet connection are aware of these Terms and
                      comply with them.</p>
                    <p><strong>CONNECTION REQUIREMENTS.</strong> You are responsible for providing and maintaining, at
                      your own risk, option, and expense, any hardware, software, and communication lines necessary to
                      access and use the Site. We reserve the right to alter the access configuration of the Site at any
                      time without prior notice.</p>
                    <p><strong>SECURITY.</strong> You shall be held responsible for any activity that takes place through
                      Your account, and You agree that You shall not sell, transfer, license, or assign Your account,
                      username, or any associated account rights. The creation of accounts by people or businesses who are
                      not expressly authorized to do so on behalf of their employers or clients is strictly forbidden, and
                      You agree that You shall not create an account for any third party other than Yourself. If You are
                      using the Site on behalf of a legal entity, You attest that You are authorized to enter into and
                      agree to these Terms on behalf of said legal entity. We reserve the right to take any action deemed
                      necessary to ensure the security of the Sites and Your Account, which may include, but is not
                      limited to, changing Your password, terminating Your Account, or requesting additional information
                      to authorize transactions on Your Account. You are solely responsible for maintaining the
                      confidentiality of Your Account Data and any security questions and responses associated with Your
                      Account. Any person with knowledge of, or access to, Your Account Data or the security questions and
                      responses associated with Your Account may use that information to gain access to Your Account;
                      therefore, You are solely liable for any claims, damages, losses, costs, or other liabilities
                      resulting from or caused by Your failure to keep Your Account Data and the security questions and
                      responses confidential, whether such failure occurs with or without Your knowledge or consent. You
                      shall immediately notify Us of any suspected or actual unauthorized access to or use of Your Account
                      Data or any other breach of Your Account security. Additionally, You authorize and consent to the
                      collection, storage, sharing, use, transfer, and sale by Us and Our service providers, of any
                      information and data related to or derived from Your use of the Site.</p>
                    <p><strong>NO WARRANTIES.</strong> ALL CONTENT ON THIS SITE IS PROVIDED TO YOU ON AN "AS-IS,"
                      "AS-AVAILABLE" BASIS AND WE EXPRESSLY DISCLAIM ALL WARRANTIES AND CONDITIONS OF ANY KIND EITHER
                      EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
                      FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, SATISFACTORY QUALITY, TIMELY, OR FREEDOM FROM COMPUTER
                      VIRUS OR MALICIOUS CODE. WE MAKE NO WARRANTY AS TO THE ACCURACY, COMPLETENESS, CURRENCY OR
                      RELIABILITY OF ANY CONTENT AVAILABLE THROUGH THIS SITE, OR THAT ANY SUCH PROBLEMS WILL BE CORRECTED.
                      YOU ARE RESPONSIBLE FOR TAKING ALL PRECAUTIONS NECESSARY TO ENSURE THAT ANY CONTENT YOU MAY OBTAIN
                      FROM THE SITE IS FREE OF VIRUSES OR MALWARE. USE OF THE SITE IS AT YOUR SOLE RISK. WITHOUT LIMITING
                      THE FOREGOING, NEITHER WE NOR ANYONE ASSOCIATED WITH US REPRESENTS OR WARRANTS THAT THE WEBSITE, ITS
                      CONTENT, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE WILL BE ACCURATE, RELIABLE, ERROR-FREE,
                      OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES IT
                      AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR THAT THE SITE OR ANY SERVICES OR ITEMS
                      OBTAINED THROUGH THE SITE WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS. TO THE FULLEST EXTENT
                      PROVIDED BY LAW, THE COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
                      IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY,
                      NON-INFRINGEMENT, AND FITNESS FOR A PARTICULAR PURPOSE. THE FOREGOING DOES NOT AFFECT ANY WARRANTIES
                      THAT CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.</p>
                    <p><strong>DISCLAIMER: </strong>Certain products and services described on the Site may not be
                      available to all users. Content and other information contained on the Site have been prepared as a
                      convenience to its users and are not intended to constitute advice or recommendations upon which a
                      user may rely. We have used reasonable efforts in collecting, preparing, and providing quality
                      information and material, but we make no warranty or guarantee as to the accuracy, completeness, or
                      adequacy of the information contained in or linked to the Site. Users must rely on the information
                      from the Site at their own risk. The information and descriptions contained herein are not intended
                      to be complete descriptions of the terms, exclusions and conditions applicable to the products and
                      services, but are provided solely for general informational purposes; users must refer to the
                      relevant product or services agreement for complete terms and conditions. If a user purchases a
                      product or service from us or a third party, the terms and conditions applicable to that transaction
                      will govern such purchase, as applicable, and the use of the Site does not affect that purchase in
                      any manner. We cannot and do not guarantee or warrant that files available for downloading from the
                      internet or the Site will be free of viruses or other destructive code. Users are responsible for
                      implementing sufficient procedures and checkpoints to satisfy their particular requirements for
                      anti-virus protection and accuracy of data input and output, and for maintaining a means external to
                      Our Site for any reconstruction of any lost data. TO THE FULLEST EXTENT PROVIDED BY LAW, WE WILL NOT
                      BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK, RANSOMWARE
                      VIRUSES, OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT A USER’S COMPUTER EQUIPMENT,
                      COMPUTER PROGRAMS, DATA, OR OTHER PROPRIETARY MATERIAL DUE TO THE USE OF THE SITE OR ANY PRODUCT OR
                      SERVICES OR ITEMS OBTAINED THROUGH THE SITE OR TO THE DOWNLOADING OF ANY MATERIAL POSTED ON IT, OR
                      ON ANY SITE LINKED TO IT.</p>
                    <p><strong>TRADEMARKS.</strong> All trademarks, service marks, and logos used or displayed on the
                      Sites are owned by Us or by third parties and are the property of their respective owners. We own
                      various trademarks, service marks, and logos that may be used on the Site. Prior to using any
                      trademark or service mark owned by Us, written permission must be obtained from Us. Unauthorized use
                      of any trademark, service mark, or logo used on the Site may constitute a violation of state,
                      national, and international trademark laws. Furthermore, Our custom icons, graphics, logos, and
                      scripting on the Site are protected by trademark, trade dress, copyright, or other proprietary right
                      law, and may not be copied, modified, or used in whole or in part without Our prior written
                      permission.</p>
                    <p><strong>RESTRICTIONS ON USE.</strong> You may only use the Site for lawful purposes, and in
                      accordance with these Terms of Use. You agree not to use the Site in any way that is in violation of
                      any federal, state, local, or international law or regulation, including, without limitation, any
                      laws regarding the export of data or software to and from the United States or other countries. You
                      shall not exploit, harm, or attempt to exploit or harm minors in any way by exposing them to
                      inappropriate content, asking for personal information, or otherwise. You shall not send, knowingly
                      receive, upload, download, use, or re-use any material that does not comply with the Content
                      Standards set forth in these Terms of Use. You shall not transmit, or procure the sending of, any
                      advertising or promotional material without Our prior written consent, including any 'junk mail,'
                      'chain letter,' 'spam,' or any other similar solicitation. You shall not impersonate or attempt to
                      impersonate Us, an employee, another user, or any other person or entity (including, without
                      limitation, by using email addresses or screen names associated with any of the foregoing).
                      Additionally, you shall not engage in any other conduct that restricts or inhibits anyone’s use or
                      enjoyment of the Site, or which, as determined by Us, may harm Us or the users of the Site, or
                      expose them to liability.</p>
                    <p>You agree not to use the Site in any manner that would disable, overburden, damage, or impair it,
                      or interfere with any other party's use of the Site, including their ability to engage in real time
                      activities; to use any robot, spider, or other automatic device, process, or means to access the
                      Site; to use any manual process to monitor or copy any material on the Site, or for any purpose not
                      expressly authorized in these Terms of Use, without Our prior written consent; to use any device,
                      software, or routine that interferes with the proper working of the Site; to introduce any viruses,
                      Trojan horses, worms, logic bombs, or other material that is malicious or technologically harmful;
                      to attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of the Site,
                      the server on which the Site is stored, or any server, computer, or database connected to the Site;
                      to share Your passcode, password, authentication credentials with any unauthorized third party which
                      would enable that third party to obtain unauthorized access to the Site; to attack the Site via a
                      denial-of-service attack or a distributed denial-of-service attack; or to otherwise attempt to
                      interfere with the proper working of the Site.</p>
                    <p><strong>USER CONTRIBUTIONS. </strong>The Site may contain Interactive Services, such as message
                      boards, chat rooms, personal web pages or profiles, forums, bulletin boards, and other features,
                      which allow Users to post User Contributions. These User Contributions must comply with the Content
                      Standards set out in these Terms of Use. By providing any User Contribution on the Website, the User
                      grants Us, Our affiliates and service providers, and each of their and Our respective licensees,
                      successors, and assigns, the right to use, reproduce, modify, perform, display, distribute, and
                      otherwise disclose to third parties any such material for any purpose according to the User's
                      account settings, as applicable. The User represents and warrants that they own or control all
                      rights in and to the User Contributions and have the right to grant the license granted above. They
                      further represent and warrant that all of their User Contributions comply with these Terms of Use,
                      and that they understand and acknowledge that they are responsible for any User Contributions they
                      submit or contribute, and that they, not Us, have full responsibility for such content, including
                      its legality, reliability, accuracy, and appropriateness. We are not responsible or liable to any
                      third party for the content or accuracy of any User Contributions posted by any User of the Site.
                    </p>
                    <p><strong>MONITORING, ENFORCEMENT AND TERMINATION.</strong> Under normal circumstances, We do not
                      actively monitor general use of the Site nor do We exercise editorial control over the content of
                      any third party’s website, e-mail transmission, news group, or other material created or accessible
                      over or through this Site. However, We reserve the right to: (1) monitor use of the Site at any time
                      as We deem appropriate; (2) remove or refuse to post any User Contributions for any or no reason in
                      Our sole discretion; (3) take any action with respect to any User Contribution that We deem
                      necessary or appropriate in Our sole discretion, including if We believe that such User Contribution
                      violates the Terms of Use, including the Content Standards, infringes any intellectual property
                      right or other right of any person or entity, threatens the personal safety of users of the Site or
                      the public, or could create liability for Us; (4) disclose Your identity or other information about
                      You to any third party who claims that material posted by You violates their rights, including their
                      intellectual property rights or their right to privacy; (5) take appropriate legal action, including
                      without limitation, referral to law enforcement, for any illegal or unauthorized use of the Site;
                      and (6) block, terminate or suspend Your access to all or part of the Site for any or no reason,
                      including without limitation, any violation of these Terms of Use.</p>
                    <p>Without limiting the foregoing, We reserve the right to cooperate fully with any law enforcement
                      authorities or court order requesting or directing Us to disclose the identity or other information
                      of anyone who posts any materials on or through the Site. YOU HEREBY WAIVE AND HOLD HARMLESS US AND
                      OUR AFFILIATES, LICENSEES, AND SERVICE PROVIDERS FROM ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY
                      US DURING, OR AS A CONSEQUENCE OF, INVESTIGATIONS BY EITHER US OR LAW ENFORCEMENT AUTHORITIES.
                      Notwithstanding the foregoing, We do not undertake to review all material before it is posted on the
                      Site, nor can We ensure prompt removal of objectionable material after it has been posted.
                      Accordingly, We shall not be held liable for any action or inaction regarding transmissions,
                      communications, or content provided by any user or third party. We shall bear no liability or
                      responsibility to anyone for performance or nonperformance of the activities described herein.</p>
                    <p><strong>CONTENT STANDARDS.</strong> User Contributions must comply in their entirety with all
                      applicable federal, state, local, and international laws and regulations, and must not contain any
                      material that is defamatory, obscene, indecent, abusive, offensive, harassing, violent, hateful,
                      inflammatory, or otherwise objectionable; promote sexually explicit or pornographic material,
                      violence, or discrimination based on race, sex, religion, nationality, disability, sexual
                      orientation, or age; infringe any patent, trademark, trade secret, copyright, or other intellectual
                      property or other rights of any other person; violate the legal rights (including the rights of
                      publicity and privacy) of others or contain any material that could give rise to any civil or
                      criminal liability under applicable laws or regulations or that otherwise may be in conflict with
                      these Terms of Use and Our Privacy Policy; be likely to deceive any person; promote any illegal
                      activity, or advocate, promote, or assist any unlawful act; cause annoyance, inconvenience, or
                      needless anxiety or be likely to upset, embarrass, alarm, or annoy any other person; impersonate any
                      person, or misrepresent a User's identity or affiliation with any person or organization; involve
                      commercial activities or sales, such as contests, sweepstakes, and other sales promotions, barter,
                      or advertising; or give the impression that they emanate from or are endorsed by Us or any other
                      person or entity, if this is not the case.</p>
                    <p><strong>WEBSITE CONTENT & COPYRIGHT.</strong> This Site and the Content contained on this Site are
                      protected by U.S. and international copyright laws. Without Our written permission, one may not
                      modify, reproduce, or distribute the Content, design, or layout of the Site or individual sections
                      of the Content, design, or layout of the Site, or Our trademarks or logos. Our exclusive property,
                      the “Content”, encompasses the layout, compilation, organization, and display of the Content, as
                      well as all software and inventions used on and in connection with this Site. We reserve all rights
                      in the Site and its Content. However, one may download information from the Site and print out a
                      hard copy for personal use, provided that one keeps intact and does not remove or alter any
                      copyright or other notice (e.g., trademark, patent, etc.) contained in the information. We do not
                      warrant or represent that use of the Content, products and services, or any other materials
                      displayed on the Site will not infringe rights of third parties.</p>
                    <p><strong>COPYRIGHT INFRINGEMENT NOTIFICATION.</strong> Pursuant to Section 512 of Title 17 of the
                      United States Code, We have implemented procedures for receiving written notification of claimed
                      copyright infringement and for processing such claims in accordance with the law. To file a
                      copyright infringement notification, the Complaining Party must provide written communication to Our
                      Designated Agent, containing the information required by Section 512(c)(3) of the Copyright Act.
                      Such information includes: (i) a physical or electronic signature of a person authorized to act on
                      behalf of the owner of an exclusive right that is allegedly infringed; (ii) identification of the
                      copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single
                      online site are covered by a single notification, a representative list of such works at that site;
                      (iii) identification of the material that is claimed to be infringing or to be the subject of
                      infringing activity and that is to be removed or access to which is to be disabled, and information
                      reasonably sufficient to permit the service provider to locate the material; (iv) information
                      reasonably sufficient to permit the service provider to contact the complaining party, such as an
                      address, telephone number, and, if available, an electronic mail address at which the complaining
                      party may be contacted; (v) a statement that the complaining party has a good faith belief that use
                      of the material in the manner complained of is not authorized by the copyright owner, its agent, or
                      the law; and (vi) a statement that the information in the notification is accurate, and under
                      penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an
                      exclusive right that is allegedly infringed. Such notifications should be directed to
                      iFixScreens.com, 1311 W Spring St, Suite B, Monroe, GA 30655, ATTN: Legal Department or contact by
                      email at info@ifixscreens.com. Please note that the designated contact information is solely for the
                      purpose of receiving notices of copyright infringement and any other communication, feedback,
                      comments or requests for technical support will not receive a response.</p>
                    <p><strong>RELIANCE ON INFORMATION POSTED.</strong> The information provided on or through the Site is
                      made available solely for general information purposes. We make no representations or warranties as
                      to the accuracy, completeness, or usefulness of such information, and any reliance You place on such
                      information is done so at Your own risk. We shall not be liable for any reliance placed on the
                      materials by You or any other visitor to the Site, or by anyone who may be informed of any of its
                      contents. Any third-party content provided on the Site, including materials provided by other users,
                      bloggers, and third-party licensors, syndicators, aggregators, and/or reporting services, does not
                      necessarily reflect Our opinion. We are not responsible for, nor liable to You or any third party,
                      for the content or accuracy of any materials provided by any third parties.</p>
                    <p><strong>LINKING TO THE SITE AND SOCIAL MEDIA FEATURES.</strong> You may link to Our Site, provided
                      that You do so in a fair and legal manner that does not damage Our reputation or take advantage of
                      it, and that You do not establish a link in such a way as to suggest any form of association,
                      approval, or endorsement on Our part without Our express written consent. This Site may provide
                      certain social media features that enable You to link from Your own or certain third-party websites
                      to certain content on this Site, to send emails or other communications with certain content, or
                      links to certain content, on this Site, or to cause limited portions of content on this Site to be
                      displayed or appear to be displayed on Your own or certain third-party websites. You may use these
                      features solely as they are provided by Us, and solely with respect to the content they are
                      displayed with, and otherwise in accordance with any additional terms and conditions We provide with
                      respect to such features. Subject to the foregoing, You must not establish a link from any website
                      that is not owned by You; cause the Site or portions of it to be displayed on, or appear to be
                      displayed by, any other site (e.g., via framing, deep linking, or in-line linking); link to any part
                      of the Site other than the homepage; or take any action with respect to the materials on this Site
                      that is inconsistent with any other provision of these Terms of Use. The website from which You are
                      linking, or on which You make certain content accessible, must comply in all respects with the
                      Content Standards set out in these Terms of Use. You agree to cooperate with Us in causing any
                      unauthorized framing or linking immediately to stop. We reserve the right to withdraw linking
                      permission without notice, and We may disable all or any social media features and any links at any
                      time without notice in Our discretion.</p>
                    <p><strong>INDEMNITY.</strong> You hereby agree to indemnify and hold harmless Us and Our
                      subsidiaries, affiliates, officers, agents, employees, partners, contractors, and licensors from and
                      against any and all suits, actions, losses, claims, proceedings, demands, expenses, damages,
                      settlements, judgments, injuries, liabilities, obligations, risks, and costs, including, without
                      limitation, litigation expenses and reasonable attorneys' fees, that may be incurred as a result of
                      Your use of the Site, Your use of any information obtained from the Site, Your User Contributions,
                      any use of the Site's content, services and products other than as expressly authorized in these
                      Terms, Your violation of these Terms, or Your violation of any law or any rights of another. We
                      reserve the right, at Your expense, to assume the exclusive defense and control of any matter that
                      You are required to indemnify against, and You agree to cooperate with Us in Our defense of such
                      matter. This indemnification shall remain in effect following the termination of these Terms.</p>
                    <p><strong>LIMITATION OF LIABILITY. </strong>You understand and agree that, to the fullest extent
                      permissible by law, We shall not be liable for any direct, indirect, incidental, consequential, or
                      special damages of any kind, whether based in contract, tort, strict liability, or otherwise,
                      arising out of or in any way connected with Your access to or use of the Site, even if We have been
                      advised of the possibility of such damages. This includes, but is not limited to, any actions taken
                      in connection with an investigation by law enforcement authorities regarding Your or any other
                      party's use of the Sites, any actions taken in connection with copyright or other intellectual
                      property owners, any damage to any user's computer, mobile device, or other equipment or technology,
                      and any reliance by any party on any content obtained through use of the Site, or that arises in
                      connection with mistakes or omissions in, or delays in transmission of, information to or from the
                      user, interruptions in telecommunications connections to the Site, viruses, whether caused in whole
                      or in part by negligence, acts of God, telecommunications failure, theft or destruction of, or
                      unauthorized access to the Site or related information or programs. You also acknowledge and agree
                      that Your use of the Site is predicated upon Your waiver of any right to sue Us and Our affiliates
                      directly or to participate in a class action suit for any losses or damages resulting from Your use
                      of the Site. Our total liability to You from all causes of action and under all theories will be
                      limited to the amount You have paid for the use of the Site, if any, and if You have paid no amount,
                      then $50. You further acknowledge and agree that You have viewed or used the Site with a full
                      understanding of the limitation of Our liability in this Agreement, and that You may be waiving
                      rights with respect to claims that are at this time unknown or unsuspected. In accordance with such
                      waiver, You acknowledge that You have read and understand, and hereby expressly waive, the benefits
                      of Section 1542 of the Civil Code of California, and any similar law of any state or territory,
                      which provides that “a general release does not extend to claims which the creditor does not know or
                      suspect to exist in his favor at the time of executing the release, which if known by him must have
                      materially affected his settlement with the debtor.” Some jurisdictions do not allow exclusions of
                      liability for certain types of damages. Accordingly, some of the above limitations may not apply to
                      You to the extent prohibited by law. In such cases, Our liability will be limited to the fullest
                      extent permitted by applicable law.</p>
                    <p><strong>THIRD-PARTY WEBSITES.</strong> Some links on this Site may direct You away from Our Site or
                      redirect You to other websites, including websites owned and operated by third parties. Please note
                      that such websites may collect both Personally Identifiable Information (PII) and Non-PII regarding
                      Your visit. The linked sites are not under Our control, and the content available on the internet
                      sites linked to this Site does not necessarily reflect Our opinion. We are providing these links as
                      a convenience to You, and access to any other internet sites linked to this Site is done at Your own
                      risk. The inclusion of any link does not constitute a recommendation or endorsement by Us of the
                      linked site. It is Your responsibility to review the terms of use and privacy policies of any
                      website You visit prior to using any linked websites. We shall not be held accountable for any
                      information, products, advertisements, content, services or software accessible through these
                      third-party websites or for any action You may take as a result of linking to any such website. We
                      are not obligated to maintain any link on the Site and may remove a link at any time in Our sole
                      discretion for any reason. We shall not be held liable, directly or indirectly, for any damages or
                      losses caused or alleged to be caused by or in connection with the use of or reliance on such
                      content, products, services or other materials available on or through any such website. We are not
                      responsible for the privacy practices of any other websites.</p>
                    <p><strong>RULES FOR SURVEYS.</strong> Any Surveys available through the Site shall be governed by
                      additional specific terms that are distinct from these Terms. By participating in any such Survey,
                      You shall be subject to those terms, which may differ from the conditions specified herein. We urge
                      You to read the pertinent terms, which are linked from the particular Survey, and to review Our
                      Privacy Policy, which, in addition to these Terms, regulates any information You submit in
                      connection with any such Survey.</p>
                    <p><strong>ELECTRONIC COMMUNICATIONS.</strong> When You visit the Site or send emails to Us, You are
                      engaging in electronic communication with Us. By providing Us with Your email address, You consent
                      to Our employing the email address to send You notices associated with the Site, including any
                      notices required by law, as an alternative to communication by postal mail. Where applicable, We
                      will communicate with You through email or by posting notices on the Site. We may additionally use
                      Your email address to send You other messages, such as changes to features of the Site and special
                      offers. You agree that all agreements, notices, disclosures and other communications that We furnish
                      to You electronically satisfy any legal requirement that such communications be in writing.
                      Furthermore, You agree that any notices We provide to You electronically are considered to be given
                      and received on the date We transmit any such electronic communication, as specified in these Terms.
                      Please refer to Your service-specific terms and privacy policy for information on opting out of
                      electronic communications.</p>
                    <p><strong>GOVERNING LAW AND GENERAL PRINCIPLES.</strong> We operate this Site from offices within the
                      United States of America. We do not represent that the information in the Site is appropriate or
                      available for use in other locations and access to the Site from territories where the contents of
                      the Site may be illegal is prohibited. Those who choose to access this Site from other locations do
                      so on their own initiative and are responsible for compliance with applicable local laws. By using
                      the Site, regardless of where the user is located in the world, they consent to these Terms and any
                      claims relating to the information, services or products made available through this Site will be
                      governed by the laws of the State of Georgia, U.S.A., excluding the application of its conflicts of
                      law rules. Any legal proceedings arising from or relating to these Terms of Use shall be brought
                      exclusively in the federal or state courts of Walton County, Georgia and the user consents to the
                      personal jurisdiction and venue of such courts. The user agrees that any claim they may have arising
                      out of or related to their use of the Site or their relationship with Us must be filed within one
                      (1) year after such claim arose; otherwise, the claim is permanently barred. If any provision of
                      these Terms is deemed unlawful, void, or for any reason unenforceable, then that provision will be
                      deemed severable from these Terms and will not affect the validity and enforceability of any
                      remaining provisions. Our failure to enforce the strict performance of any provision of these Terms
                      does not constitute a waiver of Our right to subsequently enforce such provision or any other
                      provisions of these Terms. The user agrees that any violation, or threatened violation, by them of
                      these Terms constitutes an unlawful and unfair business practice that will cause Us irreparable and
                      unquantifiable harm. They also agree that monetary damages would be inadequate for such harm and
                      consent to Our obtaining any injunctive or equitable relief that We deem necessary or appropriate.
                      These remedies are in addition to any other remedies We may have at law or in equity. We may assign
                      these Terms or any part of them without restrictions. These Terms, the Privacy Policy, and other
                      policies We may post on the Site constitute the entire agreement between Us and the user in
                      connection with their use of the Site and the Content, and supersedes any prior agreements between
                      Us and the user regarding use of the Site, including prior versions of these Terms. The section
                      headings are for convenience and do not have any force or effect.</p>
                    <p><strong>ENTIRE AGREEMENT. </strong>The Terms of Use and Our Privacy Policy constitute the sole and
                      entire agreement between the parties regarding the Site, and all prior and contemporaneous
                      understandings, agreements, representations, and warranties, both written and oral, are hereby
                      superseded.</p>
                    <p><strong>FEEDBACK. </strong>This website is operated by iFixScreens.com. All other feedback,
                      comments, requests for technical support, and other communications relating to the Site should be
                      directed to: iFixScreens.com., 1311 W Spring St, Suite B, Monroe, GA 30655, ATTN: Legal Department.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      )}











      <div className='custftr2'>
        <div className='wrapper'>
          <div className='inner'>
            <h2>iFixScreens ™ © 2012-{getYear()}</h2>
            <div className='footer_links'>
              <a href="https://ifixscreens.com/about-us/terms-and-conditions/">Terms and Conditions</a>
              <a href="https://ifixscreens.com/about-us/privacy-policy/">Privacy Policy</a>
            </div>

          </div>
        </div>
      </div>

      <footer className="custftr ifsc_footer" role="contentinfo" id="ifs_footer">
        <div className="custftrSec1">
          <div className="wrapper">
            <div id="ifs_footer1" className="ftrCol">
              <section id="text-7" className="col">
                <div className="scn">
                  <h3 className="ttl">Get The Newsletter</h3>
                  <div className="textwidget">
                    <div className="thrv_lead_generation_container tve_clearfix">
                      <div className="formsubmitting"></div>
                      <form id="subscribeForm" method="POST" action="">
                        <div className="tve_lead_generated_inputs_container tve_clearfix tve_empty_dropzone">
                          <div className="tve_lg_input_container tve_lg_input inpcol">
                            <input type="text" data-field="name" name="person_name" className="isRequired isname"
                              placeholder="Name" data-placeholder="Name" />
                            <span className="errfield">Required Field</span>
                          </div>
                          <div className="tve_lg_input_container tve_lg_input inpcol">
                            <input type="email" id="ftrperson_name" className="isRequired isemail" data-field="email"
                              data-required="1" data-validation="email" name="person_email" placeholder="Email"
                              data-placeholder="Email" />
                            <span className="errfield">Required Field</span>
                          </div>
                          <div className="tve_lg_input_container tve_submit_container tve_lg_submit">
                            <button type="submit" className="tve-froala" name="subscribe_newsletter">SUBSCRIBE</button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <p><a href="tel:(855)-462-4349" rel="nofollow sponsored">(855) 462-4349</a> Contact
                      Us</p>
                  </div>
                </div>
              </section>
            </div>
            <div id="ifs_footer2" className="ftrCol">
              <section id="nav_menu-9" className="col">
                <div className="scn">
                  <h3 className="ttl">Find Out !</h3>
                  <div className="menu-find-out-new-footer-container">
                    <ul id="menu-find-out-new-footer" className="menu">
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/about-us/">About Us</a>
                      </li>
                      <li
                        className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/device-mail-in-repair/">Mail-In Repair</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/ifixshield-protection-plan/">Device
                          Protection Plan</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/about-us/faq/">FAQ</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a target="_blank" rel="noopener" href="https://careers.smartrecruiters.com/IFixScreens1">Work
                          With Us</a>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page ">
                        <a href="https://ifixscreens.com/about-us/customer-reviews/">Leave Us A
                          Review</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/about-us/contact-us/">Contact Us</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/about-us/terms-and-conditions/">Terms and
                          Conditions</a>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy ">
                        <a rel="privacy-policy" href="https://ifixscreens.com/about-us/privacy-policy/">Privacy
                          Policy</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a target="_blank" rel="noopener" href="https://franchise.ifixscreens.com/">Franchise</a>
                      </li>

                    </ul>
                  </div>
                </div>
              </section>
            </div>
            <div id="ifs_footer3" className="ftrCol">
              <section id="nav_menu-8" className="col">
                <div className="scn">
                  <h3 className="ttl">Start Your Repair</h3>
                  <div className="menu-start-your-repair-new-footer-container">
                    <ul id="menu-start-your-repair-new-footer" className="menu">
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/smartphone-repair/iphone-repair/">iPhone
                          Repair</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/smartphone-repair/samsung-repair/">Samsung
                          Repair</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/smartphone-repair/google-repair/">Google
                          Repair</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/smartphone-repair/">All Smartphones
                          Repair</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/tablets-repair/">Tablet Repair</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/game-console-repair/">Game Console
                          Repair</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/drone-repairs/">Drones Repair</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/computer-repair/">Desktop Repair</a>
                      </li>
                      <li id="menu-item-175276" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-175276">
                        <a href="https://ifixscreens.com/laptop-and-mac-repair/">Laptop Repair</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom ">
                        <a href="https://ifixscreens.com/smartwatch-repair/">Watches Repair</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>
            <div id="ifs_footer4" className="ftrCol">
              <section id="text-8" className="col">
                <div className="scn">
                  <h3 className="ttl">Latest Post</h3>
                  <div className="textwidget">
                    <div className="recent_blog_post">
                      <div className="ifsc_rcbli">
                        <div className="ifsc_rcbli_text"> <a href="https://ifixscreens.com/blog/">Blog</a> </div>
                      </div>


                      {blogData.data.map((blog, blogIndex) => (
                        <div className="ifsc_rcbli" key={blog.ID}>
                          <div className="ifsc_rcbli_text">
                            <a href={blog.post_url} dangerouslySetInnerHTML={{ __html: blog.post_title }}></a>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <div className="custftrBtm">
          <div className="wrapper">
            <div className="custftrBtmLft">
              <p>iFixScreens ™ &copy; 2012-{getYear()}</p>
              <p>All iFixScreens Stores are
                independently owned and operated and may not offer all of the repair and warranty types
                listed on this website. Contact your local store for their specific repair capabilities,
                prices and warranty terms. All product and company names are trademarks of their respective
                holders. iPhone, iPad, iPod, iPod touch, Mac and iMac are registered trademarks and property
                of Apple, Inc. iFixScreens is a third-party repair company and is not affiliated with Apple.
              </p>
              <p>If you are vision-impaired or
                have some other impairment covered by the Americans with Disabilities Act or a similar law,
                and you wish to discuss potential accommodations related to using this website, please
                contact Support at <a href="mailto:info@ifixscreens.com">info@ifixscreens.com</a></p>
            </div>
            <div className="custftrBtmRt">
              <ul className="socfooter">
                <li> <a href="https://www.facebook.com/iFixScreens/" rel="nofollow" target="_blank">
                  <i className="fa fa-facebook"></i></a></li>
                <li><a href="https://twitter.com/ifixscreens" rel="nofollow" target="_blank"><i
                  className="fa fa-twitter"></i></a></li>
                <li> <a href="https://www.youtube.com/c/ifixscreensdotcom" rel="nofollow" target="_blank"><i
                  className="fa fa-youtube-play"></i></a></li>
                <li> <a href="https://www.instagram.com/ifixscreens/" rel="nofollow" target="_blank"><i
                  className="fa fa-instagram"></i> </a></li>
                <li> <a href="https://www.pinterest.com/ifixscreens/" rel="nofollow" target="_blank"><i
                  className="fa fa-pinterest"></i> </a></li>
                <li> <a href="https://www.linkedin.com/company/i-fix-screens" rel="nofollow" target="_blank"><i
                  className="fa fa-linkedin"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>


    </div>
  )
}


export default App;